(function () {
  'use strict';

  angular.module('mmd.clinic', []);

})();

(function () {
  'use strict';

  function WeeklyScheduleController($scope, $http, urls, ClinicService, $filter, CommonService) {
    var vm = this;
    console.log(" inside weekly schedule ");

    vm.init = false;
    vm.isClinic = CommonService.getClinicView();
    vm.isDoctor = CommonService.getDoctorView();

    vm.dayIndex = 0;
    vm.selectedDate = vm.weeklyAvailability.activeDate;

    vm.options = {
      weekday: "short", month: "short",
      day: "numeric"
    };

    vm.$onInit = function () {
      console.log(vm.weeklyAvailability);
      console.log("inside weekly schedule controller");
      vm.init = true;
      // process weekly availability
      vm.dayLabels = [];
      var currentDate = vm.weeklyAvailability.activeDate;
      if(!vm.weeklyAvailability.dateFromUrl){
        for (var i = 0; i < CommonService.getMaxDays(); i++) {
          var d = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + i);
          vm.dayLabels.push(d.toLocaleDateString("en-us", vm.options));
        }
      }else{
        var d = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 0);
        vm.dayLabels.push(d.toLocaleDateString("en-us", vm.options));
      }

      vm.activeDay = vm.dayLabels[0];
      vm.daySelected(0);
    };

    vm.daySelected = function (i) {
      var cd = vm.weeklyAvailability.activeDate;
      var d = new Date(cd.getFullYear(), cd.getMonth(), cd.getDate() + i);

      vm.selectedDate = d;
      console.log(" selected date = " + vm.selectedDate);
      vm.dayIndex = i;
      vm.activeDay = vm.dayLabels[i];
    };

    vm.handlePrevious = function() {
      $scope.$emit("request-handle-previous", {});
    };
    vm.handleNext = function() {
      $scope.$emit("request-handle-next", {});
    };
    vm.econsult = function () {
      $scope.$emit("request-econsult", {'doc': vm.docInfo, 'weeklyAvailability': vm.weeklyAvailability, 'date': vm.selectedDate});
    }

  }


  angular.module('mmd.clinic')
    .component('weeklySchedule', {
      templateUrl: 'app/modules/clinic/components/weekly-schedule/partials/weekly-schedule.html',
      bindings: {
        docInfo: '=',
        weeklyAvailability: '=',
        videoSlotsOnly: '='
      },
      controllerAs: 'vm',
      controller: WeeklyScheduleController
    });

})();

(function () {
  'use strict';

  function UploadController(CommonService,$http,$upload,urls) {
    var vm = this;
    vm.attachNow = false;


    vm.$onInit = function () {
      console.log(vm.attachmentInProgress);
    }
    vm.handleAttach = function (e) {

      // get the url.
      if (vm.pvr.patientAttachments === null || vm.pvr.patientAttachments === undefined) {
        vm.pvr.patientAttachments = [];
      }
      vm.getUrlInProgress = true;
      var getUploadUrl = {
        "requestType": "reqBlobDetailsFrmSession",
        "entityId": "23"
      };
      var uploadPromise = $http.post(urls.apiUrl + "?request=reqBlobDetailsFrmSession", getUploadUrl);
      uploadPromise.success(function (data) {

        vm.getUrlInProgress = false;
        vm.uploadUrl = urls.apiUploadUrl + data.blobUploadUrl;
        vm.attachNow = true;

      });
      uploadPromise.error(function (data) {

        window.alert("failed to get url " + data);
      });
    };

    vm.onFileSelect = function ($files) {
      vm.attachmentInProgress = true;
      for (var i = 0; i < $files.length; i++) {
        var file = $files[i];
        if (file.name.indexOf(",") > -1) {
          alert(" Sorry, file name with comma is not supported. Please change the file name and try again");
          break;
        }
        vm.pvr.patientAttachments.push({
          "contentType": file.type,
          "fileName": file.name,
          "size": file.size
        });

        vm.upload = $upload.upload({
          url: vm.uploadUrl, //upload.php script, node.js route, or servlet url
          data: {myObj: vm.myModelObj},
          file: file//, // or list of files: $files for html5 only
        }).progress(function (evt) {
          console.log('percent: ' + parseInt(100.0 * evt.loaded / evt.total));
        }).success(function (data, status, headers, config) {
          // file is uploaded successfully
          vm.uploadedBlobUrl = urls.apiUploadUrl + "/upload?blobkey=" + data;
          vm.pvr.patientAttachments[vm.pvr.patientAttachments.length - 1].status = "Success";
          vm.pvr.patientAttachments[vm.pvr.patientAttachments.length - 1].id = data;
          vm.pvr.patientAttachments[vm.pvr.patientAttachments.length - 1].creationDate = new Date().getTime();
          vm.pvr.patientAttachments[vm.pvr.patientAttachments.length - 1].servingUrl = "/upload?blobkey=" + data;
          vm.attachmentInProgress = false;
          vm.handleAttach();
          console.log(data);
        });
        //.error(...)
        //.then(success, error, progress);
        //.xhr(function(xhr){xhr.upload.addEventListener(...)})// access and attach any event listener to XMLHttpRequest.
      }

    };
    vm.handleDelete = function (blob) {

      var deleteBlob = {
        "requestType": "reqBlobDelFileFrmSession",
        "entityId": "23",
        "blobKey": blob.id
      };


      var delBlobPromise = $http.post(urls.apiUrl + "?request=reqBlobDelFileFrmSession", deleteBlob);
      delBlobPromise.success(function (data) {
        var index;
        for (var i = 0; i < vm.pvr.patientAttachments.length; i++) {
          if (vm.pvr.patientAttachments[i].id == blob.id) {
            index = i;
            break;
          }
        }
        vm.pvr.patientAttachments.splice(index, 1);

      });
      delBlobPromise.error(function (data) {
        window.alert("Unable to delete the file");
      });


    };
  }

  angular.module('mmd.clinic')
    .component('uploader', {
      templateUrl: 'app/modules/clinic/components/uploader/partials/uploader-component.html',
      bindings: {
        pvr: '=',
        attachmentInProgress: '='
      },
      controllerAs: 'vm',
      controller: UploadController
    });

})();

(function () {
  'use strict';

  function SimpleDoctorListController($scope, $http, $timeout, urls, $window,ClinicService, $filter, CommonService) {
    var vm = this;
    console.log(" simple doctor list called");
    // whether to show the profile info
    vm.hideProfile= CommonService.getHideProfile();
    vm.hideInPerson = CommonService.getHideInPerson();
    vm.baseUrl = CommonService.getBaseUrl();
    vm.showSchedule = false;
    var MAX_DAYS = CommonService.getMaxDays();
    console.log(vm.entityId);
    vm.showLocations = !vm.entityId;

    vm.today = new Date();
    vm.todayDate = vm.today.getFullYear() + '/' + (vm.today.getMonth() + 1) + '/' + vm.today.getDate();
    vm.init = false;
    vm.hasMoreRecords = false;



    vm.options = {
      weekday: "short", month: "short",
      day: "numeric"
    };

    vm.econsult = function (doc) {

      var selectedWkly = null;

      // 1. Pick the location which has online consultation enabled.
      // No two locations should have online consultation enabled.
      angular.forEach(doc.weeklyAvailabilityList,function(wkly){
        if(wkly.enableOnlineConsultation) {
          selectedWkly = wkly;
        }
      });
      if(selectedWkly) {
        var baseUri = document.baseURI;
        console.log(baseUri);
        if (baseUri != null && baseUri.indexOf("start_date=") > -1) {
          var startDate = baseUri.split("start_date=")[1].split("&")[0];
        }
          // get the doctor info, so that we get all the online visit types
          $http.post(urls.apiUrl + '?request=getDoctorInfo', {
          "requestType": "getDoctorInfo",
          "uId": doc.uid,
          "entityId": selectedWkly.locationInfo.entityId,
          "fetchCalendarInfo": true,
          "startRow": 0,
          "numRows": 1,
          "mmd" : true,
          "startDateString": startDate!=null?startDate:vm.today.getDate() + "/" + (vm.today.getMonth() + 1) + "/" + vm.today.getFullYear(),
          "endDateString": startDate!=null?startDate:vm.today.getDate() + 1 + "/" + (vm.today.getMonth() + 1) + "/" + vm.today.getFullYear()
        }).then(function (response) {
            if (response.data) {

              var docInfo = response.data.doctorInfoList[0];
              docInfo.weeklyAvailabilityList[0].econsultVisitTypes = [];

              angular.forEach(docInfo.weeklyAvailabilityList[0].visitTypes, function (aptType) {
                    console.log(" Processing visit type: " + aptType.aptTypeName);
                    console.log("   consultationType=" + aptType.consultationType);
                    console.log("   prepaid=" + aptType.prepaid);
                    console.log("   isEnabledForPublicAccess=" + aptType.isEnabledForPublicAccess);

                    // Check for Online Consultation types - support both old and new formats:
                    // 1. consultationType === "Online Consultation" (older format)
                    // 2. Check visit type flags (newer format using weeklyAvailability flags)
                    var isOnlineConsult = false;

                    if(aptType.consultationType) {
                      // Old format: use consultationType field
                      isOnlineConsult = aptType.consultationType === "Online Consultation";
                    } else {
                      // New format: if no consultationType, check if it's enabled for public and not prepaid
                      // All non-video, non-procedure visit types can be online consultations
                      isOnlineConsult = !aptType.isProcedure;
                    }

                    if(isOnlineConsult && !aptType.prepaid && aptType.isEnabledForPublicAccess) {
                      console.log(" ✓ Added to econsult visit type - " + aptType.aptTypeName);
                      docInfo.weeklyAvailabilityList[0].econsultVisitTypes.push(aptType);
                    } else {
                      console.log(" ✗ Skipped - isOnlineConsult=" + isOnlineConsult + " prepaid=" + aptType.prepaid + " isEnabledForPublicAccess=" + aptType.isEnabledForPublicAccess);
                    }
                });

              console.log(" === Total econsult visit types found: " + docInfo.weeklyAvailabilityList[0].econsultVisitTypes.length + " ===");
              $scope.$emit("request-econsult", {'doc': docInfo, 'weeklyAvailability': docInfo.weeklyAvailabilityList[0], 'date': vm.today});
            }
          });

      }




    };

    vm.$onInit = function () {
      console.log("inside doctor list controller");
      vm.docsList = [];
      vm.startRow = 0;
      vm.numRows = 20;
      getListOfDoctors();
      vm.init = true;
    };

    vm.showNextPage = function() {
      vm.startRow = vm.startRow + vm.numRows;
      getListOfDoctors();
    };

    function getListOfDoctors() {
      vm.dayLabels = [];
      vm.dateObjs = [];
      var date = new Date();
      //var date2 = new Date(date.getFullYear(), date.getMonth(), date.getDate() + MAX_DAYS);
      var date2 = new Date(date.getFullYear(), date.getMonth(), date.getDate() + MAX_DAYS);

      var deptToSend = vm.department;
      if (deptToSend == '') {
        console.log(" Got empty department, setting it to null");
        deptToSend = null;
      }

      var baseUri = document.baseURI;
      console.log(baseUri);
      if (baseUri != null && baseUri.indexOf("start_date=") > -1) {
        var startDate = baseUri.split("start_date=")[1].split("&")[0];
      }

      $http.post(urls.apiUrl + '?request=getDoctorInfo', {
        "requestType": "getDoctorInfo",
        "entityId": vm.entityId,
        "uId": vm.uId,
        "city" : vm.city,
        "area" : vm.area,
        "mmd" : vm.city && vm.city.length >0,
        "fetchCalendarInfo": false,
        "startRow": vm.startRow,
        "numRows": vm.numRows,
        "urlUniqueString": vm.urlUniqueString,
        "departmentName": deptToSend,
        "startDateString": date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear(),
        "endDateString": date2.getDate() + "/" + (date2.getMonth() + 1) + "/" + date2.getFullYear()
      }).then(function (response) {
        if (response.data) {
          angular.forEach(response.data.doctorInfoList,function(di){
            vm.docsList.push(di);
            di.currentTime = response.data.currentTime;
            di.showDr = di.isDoctor;

            if(di.department === "Acupuncture") {
              di.showDr = false;
            }
            console.log(" show dr is " + di.showDr + " for " + di.name);
            // default location first list
            var tempWklyAvailList = [];
            angular.forEach(di.weeklyAvailabilityList, function (wkly) {

              // what day to show
              //wkly.currentDate = date;

              //wkly.dayLabels = getDayLabels(wkly);
              //vm.daySelected(0, wkly, doctor);


              wkly.availabilities = [];
              if(wkly.daySlots && wkly.daySlots.length>0) {

                if(wkly.daySlots[0] && wkly.daySlots[0].length>0) {
                  // has atleast one availability
                  for(var i=0; i< wkly.daySlots[0].length; i++) {
                        var av = (wkly.daySlots[0])[i];
                       wkly.availabilities.push(ClinicService.getAvailabilitySlotsHeaders(av.availabilityStartSlot, av.availabilityEndTimeSlot, wkly.maxAptsPerHour));
                  }

                }

              }
            });
          });
          //vm.docsList = response.data.doctorInfoList;
          vm.hasMoreRecords = response.data.moreRecordsAvailable;
        }
      }, function (error) {
        console.log(error);
      });
    }

    vm.setupSchedule = function(doc, video) {
      doc.videoSlotsOnly = video;
      doc.showSchedule = false;
      $timeout(function(){
        doc.showSchedule = true;
        $timeout(function(){
          var element = $window.document.getElementById(doc.uid+"");
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 0);
      });
      if(video){
        window.ga('send', 'pageview', { page: "book_video_appointment" });
      }else{
        window.ga('send', 'pageview', { page: "book_in_person_appointment" });
      }



    }

   /* vm.setupVideoSchedule = function(doc) {
      doc.videoSlotsOnly = true;
      vm.setupSchedule(doc);
    }*/

  }



  angular.module('mmd.clinic')
    .component('simpleDoctorList', {
      templateUrl: 'app/modules/clinic/components/simple-doctor-list/partials/simple-doctor-list.html',
      bindings: {
        entityId: '=',
        uId: '=',
        department: '=',
        urlUniqueString: '=',
        city: '=',
        area: '='
      },
      controllerAs: 'vm',
      controller: SimpleDoctorListController
    });
})();

(function () {
  'use strict';

  function ProfileController(CommonService,$uibModal,$window) {
    var ctrl = this;

    ctrl.showModal= function() {
      var modalInstance = $uibModal.open({
      animation: true,

      templateUrl: 'app/modules/clinic/components/profile/partials/profile-details.html',
      controller: function($scope,$uibModalInstance,user,$sce){
        $scope.oneAtATime = true;

        $scope.userProfile = {
          "name" : user.firstName + " " + user.lastName,
          "profileSummary" : user.profileSummary,
          "sections" : [],
          "profileUrl" : user.profileUrl
        }
        $scope.userProfile.profileUrl = $sce.trustAsResourceUrl($scope.userProfile.profileUrl);
        var sections = [];
        if(user.profileSections) {
          angular.forEach(user.profileSections, function(profileSection) {
            if(profileSection.sectionContent) {
              var o = {};
              o.sectionTitle = profileSection.sectionTitle;
              o.sectionContent = [];
              angular.forEach(profileSection.sectionContent,function(sc){
                if(sc!=''){
                  o.sectionContent.push(sc);
                }

              });
              console.log(o);
              sections.push(o);
            }
         });
        }
        $scope.userProfile.sections = sections;

        // called when cancel is clicked
        $scope.cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };

      },
      size: "md",
      resolve: {
        user: function () {
          return ctrl.user;
        }

      }
    });

    /*modalInstance.result.then(function (selectedItem) {
      $scope.selected = selectedItem;
    }, function () {
      $log.info('Modal dismissed at: ' + new Date());
    });*/
    }

    ctrl.viewProfile = function() {
        CommonService.viewProfile(ctrl.doctorInfo.uid).then(function(response){
        if(response.data) {
              ctrl.user = response.data;
              if(ctrl.user.profileUrl) {
                $window.open(ctrl.user.profileUrl,"_blank");
              }else {
                ctrl.showModal();
              }

          }

        }, function(error){
            swal("error occured");
        });

    };
  }

  angular.module('mmd.clinic')
    .component('profile',{
      templateUrl: 'app/modules/clinic/components/profile/partials/profile.html',
      bindings: {
        doctorInfo: '='
      },
      controllerAs: 'vm',
      controller: ProfileController
    } );

})();

(function () {
  'use strict';

  function DoctorScheduleController($scope, $window, $timeout, $http, urls, ClinicService, $filter, CommonService) {
    var vm = this;
    console.log("inside doctor schedule");
    vm.dataAvailable = false;
    vm.hideProfile = CommonService.getHideProfile();
    vm.baseUrl = CommonService.getBaseUrl();

    vm.MAX_DAYS = CommonService.getMaxDays();
    vm.today = new Date();
    vm.todayDateStr = vm.today.toDateString();
    //vm.dateSelectorDate = vm.today.getDate() + "/" + (vm.today.getMonth() + 1) + "/" + vm.today.getFullYear()  ;
    vm.date1 = vm.today;
    vm.init = false;
    vm.doctorPage = vm.urlUniqueString && vm.urlUniqueString.length > 0;

    vm.options = {
      weekday: "short", month: "short",
      day: "numeric"
    };

    $scope.$on('request-handle-previous', function (event, args) {
      vm.handlePrevious();
    });
    /* vm.handlePreviousDay = function() {
       vm.handlePrevious(1);
     };*/

    /* vm.handleNextDay = function() {
       vm.handleNext(1);
     };*/

    vm.handlePrevious = function () {
      vm.date1 = new Date(vm.date1.getFullYear(), vm.date1.getMonth(), vm.date1.getDate() - vm.MAX_DAYS);
      vm.date1.setHours(0, 0, 0, 0);
      vm.getSchedule();
    };
    vm.handleNext = function (n) {
      vm.date1 = new Date(vm.date2.getFullYear(), vm.date2.getMonth(), vm.date2.getDate());


      vm.date1.setHours(0, 0, 0, 0);
      vm.getSchedule();
    };
    $scope.$on('request-handle-next', function (event, args) {
      vm.handleNext();

    });
    vm.setupShowDoctor = function () {
      vm.doc.showDr = vm.doc.isDoctor;
      if (vm.doc.department === "Acupuncture") {
        vm.doc.showDr = false;
      }
    };

    vm.getVideoSchedule = function () {
      vm.videoSlotsOnly = true;
      vm.getSchedule();
    };
    vm.getInPersonSchedule = function () {
      vm.videoSlotsOnly = false;
      vm.getSchedule();
    };
    vm.econsult = function () {

      var selectedWkly = null;

      // 1. Pick the location which has online consultation enabled.
      // No two locations should have online consultation enabled.
      angular.forEach(vm.doc.weeklyAvailabilityList, function (wkly) {
        if (wkly.enableOnlineConsultation) {
          selectedWkly = wkly;
        }
      });
      window.ga('send', 'pageview', {page: "book_econsult_appointment"});
      $scope.$emit("request-econsult", {'doc': vm.doc, 'weeklyAvailability': selectedWkly, 'date': vm.today});
    };


    vm.getSchedule = function () {

      var today = new Date();
      today.setHours(0, 0, 0, 0);

      var t1 = vm.date1.getTime();
      var t2 = today.getTime();

      if (t1 <= t2) {
        vm.date1 = today;
      }
      vm.dateSelectorDate = vm.date1.getDate() + "/" + (vm.date1.getMonth() + 1) + "/" + vm.date1.getFullYear();

      vm.date2 = new Date(vm.date1.getFullYear(), vm.date1.getMonth(), vm.date1.getDate() + vm.MAX_DAYS);

      var baseUri = document.baseURI;
      console.log(baseUri);
      if (baseUri != null && baseUri.indexOf("start_date=") > -1) {
        var urlStartDate = baseUri.split("start_date=")[1].split("&")[0];
        urlStartDate = decodeURIComponent(urlStartDate);
        vm.dateFromUrl = true;
        var dateSplits = urlStartDate.split('/');
        vm.urlStartDate = new Date(parseInt(dateSplits[2]), parseInt(dateSplits[1]) - 1, parseInt(dateSplits[0]))
        vm.date2 = new Date(vm.urlStartDate.getFullYear(), vm.urlStartDate.getMonth(), vm.urlStartDate.getDate());
      }
      /*if (baseUri != null && baseUri.indexOf("end_date=") > -1) {
        var urlEndDate = baseUri.split("end_date=")[1].split("&")[0];
        urlEndDate = decodeURIComponent(urlEndDate);
      }*/

      console.log(" entity id = " + vm.entityId);

      var post_args = {
        "requestType": "getDoctorInfo",
        "uId": vm.uid,
        "entityId": vm.entityId,
        "urlUniqueString": vm.urlUniqueString,
        "fetchCalendarInfo": true,
        "startRow": 0,
        "numRows": 1,
        "mmd": true,
        "startDateString": urlStartDate != null ? urlStartDate : vm.date1.getDate() + "/" + (vm.date1.getMonth() + 1) + "/" + vm.date1.getFullYear(),
        "endDateString": vm.date2.getDate() + 1 + "/" + (vm.date2.getMonth() + 1) + "/" + vm.date2.getFullYear()
      };

      if (vm.doctorPage) {
        //Don't include videoSlotsOnly variable in api call
        if (vm.doc && vm.doc.inPersonConsultEnabled && vm.doc.videoConsultEnabled) {
          post_args.videoSlotsOnly = vm.videoSlotsOnly;
        }
      } else if (vm.init || !vm.doctorPage) {
        post_args.videoSlotsOnly = vm.videoSlotsOnly;
      }
      /*if(vm.init) {
        post_args.videoSlotsOnly = vm.videoSlotsOnly;
      }*/

      $http.post(urls.apiUrl + '?request=getDoctorInfo', post_args).then(function (response) {
        vm.dataAvailable = true;
        if (response.data) {

          vm.doc = response.data.doctorInfoList[0];
          vm.setupShowDoctor();

          angular.forEach(vm.doc.weeklyAvailabilityList, function (wkly) {
            wkly.activeDate = vm.dateFromUrl ? vm.urlStartDate : vm.date1;
            wkly.dateFromUrl = vm.dateFromUrl;
            wkly.errorMessage = "Sorry, there is no timings specified for this doctor.";

            // process econsult visit types first.
            var applicableAptTypes = [];
            var econsultVisitTypes = [];
            angular.forEach(wkly.visitTypes, function (aptType) {
              console.log(" Processing visit type " + aptType.aptTypeName + " in " + wkly.locationInfo.hospitalName);
              if (aptType.consultationType !== "Online Consultation"
                && aptType.consultationType !== "Video Consultation"
                && aptType.isEnabledForPublicAccess) {
                console.log(" Added to applicable type - " + aptType.aptTypeName);
                applicableAptTypes.push(aptType);
              }
              // add video consultation irrespective of public access status
              if (aptType.consultationType === "Video Consultation") {
                console.log(" Added to applicable type - " + aptType.aptTypeName);
                applicableAptTypes.push(aptType);
              }
              if (aptType.consultationType && aptType.consultationType === "Online Consultation" && !aptType.prepaid) {
                console.log(" Added to econsult visit type - " + aptType.aptTypeName + " in " + wkly.locationInfo.hospitalName);
                econsultVisitTypes.push(aptType);
              }
            });
            wkly.econsultVisitTypes = econsultVisitTypes;
            wkly.applicableAptTypes = applicableAptTypes;

            var dayIndx = -1;
            angular.forEach(wkly.daySlots, function (arAvails) {
              // each day processing
              dayIndx++;
              if (arAvails && arAvails.length > 0) {
                // has availability
                wkly.errorMessage = null;

                var maxAptsPerHour = wkly.maxAptsPerHour;
                for (var i = 0; i < arAvails.length; i++) {
                  // for each availability slot
                  var av = arAvails[i];
                  av.header = ClinicService.getAvailabilitySlotsHeaders(av.availabilityStartSlotOrig, av.availabilityEndTimeSlotOrig, wkly.maxAptsPerHour);
                  var apTypes = [];
                  if (av.aptTypeName != null) {
                    // a specific apt type slot.. only that specific apt type is allowed.
                    av.header = av.header + "(" + av.aptTypeName + " only )";
                    angular.forEach(applicableAptTypes, function (aptType) {
                      if (aptType.aptTypeName === av.aptTypeName) {
                        console.log("Added appointment type " + aptType.aptTypeName);
                        apTypes.push(aptType);
                      }
                    });
                  } else if (av.aptTypeNames != null && av.aptTypeNames.length > 0) {
                    var apNames = "";
                    angular.forEach(av.aptTypeNames, function (ap) {
                      if (apNames === "") {
                        apNames = ap;
                      } else {
                        apNames = apNames + "," + ap;
                      }

                    });
                    av.header = av.header + "(" + apNames + " only )";

                    angular.forEach(applicableAptTypes, function (aptType) {

                      if (av.aptTypeNames.includes(aptType.aptTypeName)) {
                        console.log(" added appointment type " + aptType.aptTypeName);
                        apTypes.push(aptType);
                      }
                    });
                  } else {
                    // availability based visit type is not configured
                    // in this case, remove vide consultation from list
                    // this is a hack solution to disallow
                    // video booking from normal availabilities
                    angular.forEach(applicableAptTypes, function (aptType) {

                      if (aptType.consultationType !== "Video Consultation") {
                        console.log(" added appointment type " + aptType.aptTypeName);
                        apTypes.push(aptType);
                      }
                    });
                    //apTypes = applicableAptTypes;
                  }

                  //wkly.econsultVisitTypes = econsultVisitTypes;
                  angular.forEach(av.slots, function (v) {
                    if (wkly.aptBookingType === 4) {
                      v.slotLabel = "Request Appointment";
                    } else if (wkly.aptBookingType === 5) {
                      v.slotLabel = "Book a slot";
                    } else {
                      v.slotLabel = ClinicService.getSlotString(v.timeSlot, wkly.maxAptsPerHour);
                    }

                    //v.video = av.aptTypeName != null && av.aptTypeName == "Video Consultation";

                    v.applicableAptTypes = apTypes;
                    //console.log(" Apt types for slot = " + v.slotLabel );
                    //console.log(v.applicableAptTypes);
                    //v.video = hasVideoApt(aptTypes);

                  });
                  av.applicableAptTypes = apTypes;

                  av.noSlotsMessage = "";
                  av.advFlag = 0;

                  var curDate_12am_ms = new Date(wkly.activeDate.getFullYear(), wkly.activeDate.getMonth(), wkly.activeDate.getDate()).getTime();
                  // offset for tab
                  curDate_12am_ms = curDate_12am_ms + (dayIndx * 24 * 60 * 60 * 1000);

                  var isTodayDate = CommonService.isToday(vm.today, new Date(curDate_12am_ms));
                  //  var ts = CommonService.getTimeSlot(vm.today,60/maxAptsPerHour);
                  var isPast = CommonService.isTimePastAvailability(vm.doc.currentTime, av.availabilityEndTimeSlot, 60 / wkly.maxAptsPerHour);
                  console.log(" Processing AV = " + av.header);
                  console.log(" Is Past = " + isPast);
                  console.log(" Is Today = " + isTodayDate);

                  if (isPast && isTodayDate) {
                    //av.noSlotsMessage = 'Sorry. Doctor not available at this time';
                    av.noSlotsMessage = 'Appointment Booking Closed.';
                  } else if (av.slots.length != null && av.slots.length > 0) {

                    if (wkly.aptBookingType === 3 || wkly.aptBookingType === 4 || wkly.aptBookingType === 5) {
                      var s = [];
                      s.push(av.slots[0]);
                      av.slots = s;
                    }

                    //Advance booking slots
                    av.slotMessage = "";
                    var todayTemp2 = new Date();
                    todayTemp2.setHours(0);
                    todayTemp2.setMinutes(0);
                    todayTemp2.setSeconds(0);
                    todayTemp2.setMilliseconds(0);

                    var now_12_am_ms = todayTemp2.getTime();
                    var allowedAdvBookingDays = wkly.allowedAdvBookingDays;
                    var adv_booking_ms = (allowedAdvBookingDays * 24 * 60 * 60 * 1000);
                    var limit = now_12_am_ms + adv_booking_ms;
                    var isAdvBookingValid = (curDate_12am_ms < limit) && (allowedAdvBookingDays != 0);
                    var bookingStartDate = new Date((curDate_12am_ms - adv_booking_ms) + 24 * 60 * 60 * 1000);

                    if (allowedAdvBookingDays === 0) {
                      av.noSlotsMessage = "Online Booking facility is not available for this doctor";
                    } else if (!isAdvBookingValid) {
                      //  av.slotMessage = "Booking starts from " + $filter('date')(bookingStartDate, "dd/MM/yyyy");
                      av.noSlotsMessage = "Booking starts on " + $filter('date')(bookingStartDate, "dd/MM/yyyy");
                    } else {
                      av.advFlag = 1;
                    }


                  } else if (av.slots.length === 0) {
                    if (av.overBookingAllowed && av.isAtLeastOneSlotisBooked) {
                      av.noSlotsMessage = ClinicService.getAvailabilitySlots(av.availabilityEndTimeSlot, wkly.maxAptsPerHour);
                    } else if (av.callLaterToBook) {
                      var todayTemp = new Date();

                      todayTemp.setHours(0);
                      todayTemp.setMinutes(0);
                      todayTemp.setSeconds(0);
                      todayTemp.setMilliseconds(0);
                      try {

                        var finalVal = curDate_12am_ms + (av.availabilityStartSlot * (60 / wkly.maxAptsPerHour) * 60 * 1000) - (av.advBookingHour * 60 * 60 * 1000);
                        //var finalVal = curDate_12am_ms + av.aptBookingStartSlot * (60 / maxAptsPerHour) * 60 * 1000;
                        av.noSlotsMessage = 'Booking starts from ' + $filter('date')(finalVal, " dd/MMM/yyyy h:mm a");
                      } catch (e) {
                        console.log('Error', 'Error while getting the indexed data.');
                      }
                    } else if (av.assistantDoctorAvailable) {
                      av.noSlotsMessage = 'Asst. Doctor available';
                    } else if (av.atLeastOneSlotisBooked) {
                      av.noSlotsMessage = 'Appointments are full.';
                    } else {

                      if (vm.doc.bookingStartHour) {

                        var t1 = new Date(wkly.activeDate.getFullYear(), wkly.activeDate.getMonth(), wkly.activeDate.getDate()).getTime();
                        t1 = t1 + (dayIndx * 24 * 60 * 60 * 1000);

                        var bookingMsg = 'Appointment booking service opens daily at ' + vm.doc.bookingStartHour;
                        if (vm.doc.bookingStartMins) {
                          bookingMsg = bookingMsg + " : " + vm.doc.bookingStartMins;
                        }
                        bookingMsg = bookingMsg + " hours. ";
                        av.noSlotsMessage = bookingMsg;
                      } else {
                        av.noSlotsMessage = 'Sorry. Doctor not available at this time';
                      }

                    }

                  } else {
                    console.log(" no availability data found ! unexplained error");
                  }


                }
              }


            });


          });


          // get the component in the view.
          $timeout(function () {
            var element = $window.document.getElementById(vm.doc.uid + "");
            if (element) {
              element.scrollIntoView({behavior: "smooth", block: "start"});
            }

          }, 0);
        }
      }, function (error) {
        console.log(error);
      });


    }
    vm.$onInit = function () {
      console.log("inside doctor list controller");
      vm.getSchedule();
      vm.init = true;
    }
    /*vm.daySelected = function (i, wkly) {
      vm.doc.activeWeeklyAvailability = null;
      var d = new Date(wkly.currentDate.getFullYear(), wkly.currentDate.getMonth(), wkly.currentDate.getDate() + i);
      wkly.activeDay = d.toLocaleDateString("en-us", vm.options);
      wkly.activeAvails = [];
      wkly.activeAvailabilitySlots = [];

      angular.forEach(wkly.daySlots[i], function (avail) {
        var add = "";
        if (avail.aptTypeName && avail.aptTypeName == "Video Consultation") {
          add = "(Video Appointment only)";
        }
        wkly.activeAvails.push(
          ClinicService.getAvailabilitySlotsHeaders(avail.availabilityStartSlot, avail.availabilityEndTimeSlot, wkly.maxAptsPerHour) + add
        );
        wkly.activeAvailabilitySlots.push(avail);
      });
    };*/
    /*function getDayLabels(wkly) {
      var dayLabels = [];
      var currentDate = wkly.currentDate;
      for (var i = 0; i < MAX_DAYS; i++) {
        var d = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + i);
        dayLabels.push(d.toLocaleDateString("en-us", vm.options));
      }
      return dayLabels;
    }*/
    vm.handleDateChange = function (wkly, doc) {
      //wkly.currentDate = new Date(wkly.dateSelectorDate);
      vm.date1 = new Date(vm.dateSelectorDate);
      vm.getSchedule();
    }

  }

  angular.module('mmd.clinic')
    .component('doctorSchedule', {
      templateUrl: 'app/modules/clinic/components/doctor-schedule/partials/doctor-schedule.html',
      bindings: {
        entityId: '=',
        uid: '=',
        urlUniqueString: '=',
        drillDown: '=',
        videoSlotsOnly: '='
      },
      controllerAs: 'vm',
      controller: DoctorScheduleController
    });

})();

(function () {
  'use strict';

  function DayScheduleController($scope,ClinicService,$http,urls,CommonService) {
    var vm = this;

    // get the active slots for selected availability
    console.log("inside day schedule .. printing avail")
    console.log(vm.avail);


    vm.slotSelected = function(slot){
      // TODO: active date is the wrong date.
        $scope.$emit("slot-selected",
          {"slot" : slot,
            "label" : ClinicService.getSlotString(slot.timeSlot,vm.weeklyAvailability.locationInfo.maxAptsPerHour),
            "doc": vm.doctorInfo,
            "weeklyAvailability" : vm.weeklyAvailability,
            "date" : vm.selectedDate,
            "avail" : vm.avail,
            "videoSlotsOnly" : vm.videoSlotsOnly
          });
    }
  }

  angular.module('mmd.clinic')
    .component('daySchedule',{
      templateUrl: 'app/modules/clinic/components/day-schedule/partials/day-schedule.html',
      bindings: {
        weeklyAvailability: '=',
        doctorInfo: '=',
        avail : '=',
        selectedDate: '=',
        videoSlotsOnly: '='
      },
      controllerAs: 'vm',
      controller: DayScheduleController
    } );

})();

(function () {
  'use strict';

  function DoctorListController($scope, $http, urls, ClinicService, $filter, CommonService) {
    var vm = this;
    vm.hideProfile= CommonService.getHideProfile();
    /*vm.appId = "mmdconnect";
    if(window.location.href.indexOf("wello-care")>-1) {
      vm.appId = "wello-care";
    }*/
    vm.baseUrl = CommonService.getBaseUrl();

    var MAX_DAYS = 3;
    if (vm.urlUniqueString) {
      MAX_DAYS = 7;
    }

    // always fix it to 3 days if mobile.
    if(window.innerWidth <= 800) {
      MAX_DAYS  = 3;
    }
    console.log(vm.entityId);

    vm.today = new Date();
    vm.todayDate = vm.today.getFullYear() + '/' + (vm.today.getMonth() + 1) + '/' + vm.today.getDate();
    vm.init = false;


    vm.options = {
      weekday: "short", month: "short",
      day: "numeric"
    };

    vm.getSchedule = function (doc, wkly) {
      var d = wkly.currentDate;
      var indx = wkly.dayLabels.indexOf(wkly.activeDay);
      var activeDate = new Date(d.getFullYear(), d.getMonth(), d.getDate() + indx);
      doc.activeWeeklyAvailability = wkly;
      wkly.activeDate = activeDate;

      $http.post(urls.apiUrl + '?request=getDoctorInfo', {
        "requestType": "getDoctorInfo",
        "uId": doc.uid,
        "entityId": doc.activeWeeklyAvailability.locationInfo.entityId,
        "fetchCalendarInfo": true,
        "startRow": 0,
        "numRows": 1,
        "startDateString": activeDate.getDate() + "/" + (activeDate.getMonth() + 1) + "/" + activeDate.getFullYear(),
        "endDateString": activeDate.getDate() + 1 + "/" + (activeDate.getMonth() + 1) + "/" + activeDate.getFullYear()
      }).then(function (response) {
        if (response.data) {

          var docInfo = response.data.doctorInfoList[0];
          // replace in the UI list
          var arAvails = docInfo.weeklyAvailabilityList[0].daySlots[0];
          wkly.visitTypes = docInfo.weeklyAvailabilityList[0].visitTypes;
          var maxAptsPerHour = wkly.maxAptsPerHour;


          for (var i = 0; i < arAvails.length; i++) {
            var av = arAvails[i];
            wkly.activeAvailabilitySlots[i] = av;
            wkly.activeAvailabilitySlots[i].slots = arAvails[i].slots;
            var applicableAptTypes = [];

            if (av.aptTypeName != null) {
              // a specific apt type slot.. only that specific apt type is allowed.
              angular.forEach(wkly.visitTypes, function (aptType) {
                if (aptType.aptTypeName == av.aptTypeName) {
                  applicableAptTypes.push(aptType);
                }
              });
            } else {
              angular.forEach(wkly.visitTypes, function (aptType) {
                if (aptType.consultationType != "Online Consultation"
                  && aptType.consultationType != "Video Consultation"
                  && aptType.isEnabledForPublicAccess) {
                  applicableAptTypes.push(aptType);
                }

              });
            }
            //wkly.econsultVisitTypes = econsultVisitTypes;
            angular.forEach(wkly.activeAvailabilitySlots[i].slots, function (v) {
              v.slotLabel = ClinicService.getSlotString(v.timeSlot, wkly.maxAptsPerHour);
              //v.applicableAptTypes = applicableAptTypes;
              v.video = av.aptTypeName != null && av.aptTypeName == "Video Consultation";
              v.applicableAptTypes = applicableAptTypes;

            });

            av.noSlotsMessage = "";
            av.advFlag = 0;
            var isTodayDate = CommonService.isToday(vm.today, activeDate);
            //  var ts = CommonService.getTimeSlot(vm.today,60/maxAptsPerHour);
            var isPast = CommonService.isTimePastAvailability(doc.currentTime, av.availabilityEndTimeSlot, 60 / maxAptsPerHour);
            console.log("isPast" + isPast);

            if (isPast && isTodayDate) {
              //av.noSlotsMessage = 'Sorry. Doctor not available at this time';
              av.noSlotsMessage = 'Appointment Booking Closed.';
            }
            else if (av.slots.length != null && av.slots.length > 0) {
              //Advance booking slots
              av.slotMessage = "";
              var todayTemp2 = new Date();
              todayTemp2.setHours(0);
              todayTemp2.setMinutes(0);
              todayTemp2.setSeconds(0);
              todayTemp2.setMilliseconds(0);
              var curDate_12am_ms = new Date(wkly.activeDate.getFullYear(), wkly.activeDate.getMonth(), wkly.activeDate.getDate()).getTime();
              var now_12_am_ms = todayTemp2.getTime();
              var allowedAdvBookingDays = wkly.allowedAdvBookingDays;
              var adv_booking_ms = (allowedAdvBookingDays * 24 * 60 * 60 * 1000);
              var limit = now_12_am_ms + adv_booking_ms;
              var isAdvBookingValid = (curDate_12am_ms < limit) && (allowedAdvBookingDays != 0);
              var bookingStartDate = new Date((curDate_12am_ms - adv_booking_ms) + 24 * 60 * 60 * 1000);

              if (!isAdvBookingValid) {
                //  av.slotMessage = "Booking starts from " + $filter('date')(bookingStartDate, "dd/MM/yyyy");
                av.noSlotsMessage = "Booking starts on " + $filter('date')(bookingStartDate, "dd/MM/yyyy");
              }
              else {
                av.advFlag = 1;
              }


            }
            else if (wkly.activeAvailabilitySlots[i].slots == null || wkly.activeAvailabilitySlots[i].slots.length == 0) {
              if (av.overBookingAllowed && av.isAtLeastOneSlotisBooked) {
                av.noSlotsMessage = ClinicService.getAvailabilitySlots(av.availabilityEndTimeSlot, maxAptsPerHour);
              } else if (av.callLaterToBook) {
                var todayTemp = new Date();
                var curDate_12am_ms = new Date(wkly.activeDate.getFullYear(), wkly.activeDate.getMonth(), wkly.activeDate.getDate()).getTime();
                todayTemp.setHours(0);
                todayTemp.setMinutes(0);
                todayTemp.setSeconds(0);
                todayTemp.setMilliseconds(0);
                try {

                  var finalVal = curDate_12am_ms + (av.availabilityStartSlot * (60 / maxAptsPerHour) *60 * 1000) - (av.advBookingHour * 60 * 60 * 1000);
                  //var finalVal = curDate_12am_ms + av.aptBookingStartSlot * (60 / maxAptsPerHour) * 60 * 1000;
                  av.noSlotsMessage = 'Booking starts from ' + $filter('date')(finalVal, " dd/MMM/yyyy h:mm a");
                } catch (e) {
                  console.log('Error', 'Error while getting the indexed data.');
                }
              } else if (av.assistantDoctorAvailable) {
                av.noSlotsMessage = 'Asst. Doctor available';
              } else if (av.atLeastOneSlotisBooked) {
                av.noSlotsMessage = 'Appointments are full.';
              }
              else {
                av.noSlotsMessage = 'Sorry. Doctor not available at this time';
              }

            }

            else {
              console.log(" no availability data found ! unexplained error");
            }


          }


        }
      }, function (error) {
        console.log(error);
      });

      wkly.fetchCalendar = true;

    }
    vm.econsult = function (doc, wkly) {
      var d = wkly.currentDate;
      var indx = wkly.dayLabels.indexOf(wkly.activeDay);
      var activeDate = new Date(d.getFullYear(), d.getMonth(), d.getDate() + indx);
      console.log(activeDate);
      $http.post(urls.apiUrl + '?request=getDoctorInfo', {
        "requestType": "getDoctorInfo",
        "uId": doc.uid,
        "entityId": wkly.locationInfo.entityId,
        "fetchCalendarInfo": true,
        "startRow": 0,
        "numRows": 1,
        "startDateString": activeDate.getDate() + "/" + (activeDate.getMonth() + 1) + "/" + activeDate.getFullYear(),
        "endDateString": activeDate.getDate() + 1 + "/" + (activeDate.getMonth() + 1) + "/" + activeDate.getFullYear()
      }).then(function (response) {

        var docInfo = response.data.doctorInfoList[0];
        wkly.visitTypes = docInfo.weeklyAvailabilityList[0].visitTypes;
        wkly.econsultVisitTypes = [];
        angular.forEach(wkly.visitTypes, function (v) {
          if (v.consultationType == "Online Consultation" && !v.prepaid && v.isEnabledForPublicAccess) {
            wkly.econsultVisitTypes.push(v);
          }
        });
        $scope.$emit("request-econsult", {'doc': doc, 'weeklyAvailability': wkly, 'date': activeDate});

      }, function (error) {
        console.log(error);
      });

    }
    vm.$onInit = function () {
      console.log("inside doctor list controller");
      getListOfDoctors();
      vm.init = true;
    }

    vm.daySelected = function (i, wkly, doc) {
      doc.activeWeeklyAvailability = null;
      var d = new Date(wkly.currentDate.getFullYear(), wkly.currentDate.getMonth(), wkly.currentDate.getDate() + i);
      wkly.activeDay = d.toLocaleDateString("en-us", vm.options);
      wkly.activeAvails = [];
      wkly.activeAvailabilitySlots = [];

      angular.forEach(wkly.daySlots[i], function (avail) {
        var add = "";
        if (avail.aptTypeName && avail.aptTypeName == "Video Consultation") {
          add = "(Video Appointment only)";
        }
        wkly.activeAvails.push(
          ClinicService.getAvailabilitySlotsHeaders(avail.availabilityStartSlot, avail.availabilityEndTimeSlot, wkly.maxAptsPerHour) + add
        );
        wkly.activeAvailabilitySlots.push(avail);
      });
    };

    function getDayLabels(wkly) {
      var dayLabels = [];
      var currentDate = wkly.currentDate;
      for (var i = 0; i < MAX_DAYS; i++) {
        var d = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + i);
        dayLabels.push(d.toLocaleDateString("en-us", vm.options));
      }
      return dayLabels;
    }

    vm.getDoctorInfo = function (doc, wkly, isNext, isStartDate, fetchCalendar) {
      if (!fetchCalendar) {
        fetchCalendar = false;
      }
      var d1 = wkly.currentDate;

      if (!isStartDate) {
        var step = isNext ? MAX_DAYS : -MAX_DAYS;
        d1 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate() + step);
        d1.setHours(0, 0, 0, 0);
      }


      var today = new Date();
      today.setHours(0, 0, 0, 0);

      var t1 = d1.getTime();
      var t2 = today.getTime();

      if (t1 <= t2) {
        d1 = today;
      }
      var d2 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate() + MAX_DAYS);
      var eid = CommonService.getDoctorView() ? null : wkly.locationInfo.entityId;

      $http.post(urls.apiUrl + '?request=getDoctorInfo', {
        "requestType": "getDoctorInfo",
        "uId": doc.uid,
        "entityId": eid,
        "fetchCalendarInfo": fetchCalendar,
        "startRow": 0,
        "numRows": 1,
        "urlUniqueString": vm.urlUniqueString,
        "startDateString": d1.getDate() + "/" + (d1.getMonth() + 1) + "/" + d1.getFullYear(),
        "endDateString": d2.getDate() + "/" + (d2.getMonth() + 1) + "/" + d2.getFullYear()
      }).then(function (response) {
        if (response.data) {
          //vm.docsList = response.data.doctorInfoList;
          var docInfo = response.data.doctorInfoList[0];
          // replace in the UI list
          var d = $filter('filter')(vm.docsList, {'uid': doc.uid})[0];
          var indx = vm.docsList.indexOf(d);
          vm.docsList[indx] = docInfo;

          angular.forEach(docInfo.weeklyAvailabilityList, function (wkly) {
            // what day to show
            wkly.currentDate = d1;
            wkly.dayLabels = getDayLabels(wkly);
            vm.daySelected(0, wkly, docInfo);
          });

        }
      }, function (error) {
        console.log(error);
      });
    }

    function getListOfDoctors() {
      vm.dayLabels = [];
      vm.dateObjs = [];
      var date = new Date();
      var date2 = new Date(date.getFullYear(), date.getMonth(), date.getDate() + MAX_DAYS);

      var deptToSend = vm.department;
      if (deptToSend == '') {
        console.log(" Got empty department, setting it to null");
        deptToSend = null;
      }

      $http.post(urls.apiUrl + '?request=getDoctorInfo', {
        "requestType": "getDoctorInfo",
        "entityId": vm.entityId,
        "uId": vm.uId,
        "city" : vm.city,
        "area" : vm.area,
        "mmd" : vm.city && vm.city.length >0,
        "fetchCalendarInfo": false,
        "startRow": 0,
        "numRows": 100,
        "urlUniqueString": vm.urlUniqueString,
        "departmentName": deptToSend,
        "startDateString": date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear(),
        "endDateString": date2.getDate() + "/" + (date2.getMonth() + 1) + "/" + date2.getFullYear()
      }).then(function (response) {
        if (response.data) {
          vm.docsList = response.data.doctorInfoList;
          angular.forEach(vm.docsList, function (doctor) {
            doctor.currentTime = response.data.currentTime;
            // default location first list
            var tempWklyAvailList = [];
            /*angular.forEach(doctor.weeklyAvailabilityList, function (wkly) {
              if (wkly.daySlots) {
                for (var i1 in wkly.daySlots) {
                  var avSlotArray = wkly.daySlots[i1];
                  if (avSlotArray && avSlotArray.length > 0) {
                    tempWklyAvailList.push(wkly);
                    break;
                  }
                }
              }
            });
            console.log(tempWklyAvailList);
            doctor.weeklyAvailabilityList = tempWklyAvailList;
            */

            angular.forEach(doctor.weeklyAvailabilityList, function (wkly) {
              // what day to show
              wkly.currentDate = date;
              wkly.dayLabels = getDayLabels(wkly);
              vm.daySelected(0, wkly, doctor);
            });


          });

        }
      }, function (error) {
        console.log(error);
      });
    }

    vm.handleDateChange = function (wkly, doc) {
      wkly.currentDate = new Date(wkly.dateSelectorDate);
      console.log("date selector changed");
      vm.getDoctorInfo(doc, wkly, true, true);
    }

  }


  angular.module('mmd.clinic')
    .component('doctorList', {
      templateUrl: 'app/modules/clinic/components/doctor-list/partials/doctor-list.html',
      bindings: {
        entityId: '=',
        uId: '=',
        department: '=',
        urlUniqueString: '=',
        city: '=',
        area: '='
      },
      controllerAs: 'vm',
      controller: DoctorListController
    });

})();

(function () {
  'use strict';

  function BranchSelectorController($scope,ClinicService,$http,urls,CommonService,$document) {
    var vm = this;
    vm.baseUrl = CommonService.getBaseUrl();
    console.log(vm.baseUrl);
    console.log(vm.entityInfo);
    vm.selectedEntity = vm.branches[0].name;

    //background: url('{{vm.baseUrl}}/images/corp_back.png')
    //console.log(vm.branches);
    /*var bUrlConfig = vm.entityInfo.configMap['corporateBackgroundImageUrl'];
    var bUrl = vm.baseUrl + '/images/corp_back.png';
    if(bUrlConfig) {
      bUrl = bUrlConfig;
    }
    $document.getElementsByClassName("branch-selector").addStyle('background',bUrl);
    */
    vm.handleSubmit = function() {
        console.log(vm.selectedEntity);
        var eid = angular.forEach(vm.branches,function(e){
          if(e.name === vm.selectedEntity) {
            var i = location.href.indexOf("entity=");
            //var newUrl = location.href.substr(0,i) + "/#/app?eid=" + e.entityId;
            //window.location.replace(newUrl);
            var newUrl = location.href.substr(0,i) + "eid=" + e.entityId;
            window.location.href = newUrl;
          }
        });
    }
  }

  angular.module('mmd.clinic')
    .component('branchSelector',{
      templateUrl: 'app/modules/clinic/components/branch-selector/partials/branch-selector.html',
      bindings: {
        branches: '=',
        entityInfo: '=',
        hideName: '='
      },
      controllerAs: 'vm',
      controller: BranchSelectorController
    } );

})();


(function () {
  'use strict';

  function BookingFormController($scope, ClinicService, CommonService, CountriesService, $http, urls, $window, $location) {
    var vm = this;
    vm.setupVisitTypes = function() {
      // For e-consult, use econsultVisitTypes from weekly availability
      // For regular appointments, use applicableAptTypes from selected slot
      if(vm.isEconsult && vm.weeklyAvailability && vm.weeklyAvailability.econsultVisitTypes) {
        vm.visitTypes = angular.copy(vm.weeklyAvailability.econsultVisitTypes);
      } else if(vm.selectedSlot && vm.selectedSlot.applicableAptTypes) {
        if(vm.patient.international === true) {
          vm.visitTypes = vm.selectedSlot.applicableAptTypes.filter(function(vtype){
            return vtype.internationalPatientOnly === true;
          });
          if(vm.visitTypes.length === 0) {
            vm.visitTypes = angular.copy(vm.selectedSlot.applicableAptTypes);
          }
        } else {
          vm.visitTypes = angular.copy(vm.selectedSlot.applicableAptTypes);
        }
      } else {
        // Fallback: initialize empty array
        vm.visitTypes = [];
      }

      // Filter for international patients if needed
      if(vm.patient.international === true && vm.visitTypes.length > 0) {
        var internationalTypes = vm.visitTypes.filter(function(vtype){
          return vtype.internationalPatientOnly === true;
        });
        if(internationalTypes.length > 0) {
          vm.visitTypes = internationalTypes;
        }
      }

      // Set default visit type
      if(vm.visitTypes.length > 0) {
        vm.patient.visitType = vm.visitTypes[0];
      }
    }
    // setup visit types first.
    vm.setupVisitTypes();


    var disableAppyCouponCode = false;
    var pvrKey =  $location.search().pvrKey;
    console.log(" got pvr key = " + pvrKey);

    vm.patientAgeType = "age";
    vm.patient.newPatient = "true";
    vm.countryCode = "+91";
    vm.attachmentInProgress = false;
    vm.agreeToTerms = false;
    vm.baseUrl = CommonService.getBaseUrl();
    vm.countries = [];
    vm.consentUrl = vm.weeklyAvailability.locationInfo.configMap["consentUrl"];
    vm.serviceSuffixForPayment = vm.weeklyAvailability.locationInfo.hospitalName + " - " + vm.weeklyAvailability.locationInfo.area + " - " + vm.selectedDoctorInfo.name;
    var op = vm.weeklyAvailability.locationInfo.configMap["videoFormOptions"];
    if (op) {
      vm.videoFormOptions = JSON.parse(op);
      vm.hideReason = vm.videoFormOptions.hideDetails;
    }
    vm.countryList = CountriesService.getCountries();
    vm.paypalRender = function () {
      if(vm.showPaypal()){
        vm.showPayPalAlertText = true;
        var amt = Math.round(vm.patientData.visitType.fees + (vm.patientData.visitType.taxPercentage / 100) * vm.patientData.visitType.fees);
        // var amt = 0.01;
        paypal.Button.render({
          // Configure environment
          env: 'sandbox',
          client: {
            sandbox: 'AUAZsGZqavmedcYI1a2lef2NIwjUu8LU9hTz3dIIEDzcUXBD17dQ1sEmhmts3L02RmynJhXbQ3yMTpt4',
            production: 'demo_production_client_id'
          },
          // Customize button (optional)
          locale: 'en_US',
          style: {
            size: 'small',
            color: 'gold',
            shape: 'pill',
          },

          // Enable Pay Now checkout flow (optional)
          commit: true,
          // Set up a payment
          payment: function(data, actions) {
            return actions.payment.create({
              transactions: [{
                amount: {
                  // total: amt.toString()+'.00',
                  total: amt,
                  currency: 'OMR'
                }
              }]
            });
          },
          // Execute the payment
          onAuthorize: function(data, actions) {
            return actions.payment.execute().then(function() {
              var response = data;
              // Show a confirmation message to the buyer
              window.alert('Thank you for your purchase!');
              paymentCompletedCallback(response,amt);
            });
          }
        }, '#paypal-button');
      }
    };
    console.log(" ShowDr is " + vm.selectedDoctorInfo.showDr);




    vm.getSlotString = function () {
      return ClinicService.getSlotString(vm.selectedSlot.timeSlot, vm.weeklyAvailability.maxAptsPerHour);
    };
    vm.getCancellationMessage = function () {
      var k = "";
      k = vm.weeklyAvailability.locationInfo.configMap["videoAptCancellationMsg"];
      console.log("cancellation message = " + k);
      return k;
    };

   

    // Watch for changes in patient.visitType
$scope.$watch('vm.patient.visitType', function (newValue, oldValue) {
  if (newValue && newValue.staffInstruction) {
      vm.getStaffInstructions();
  } else {
      vm.staffInstructions = []; // Clear instructions if none are available
  }
}, true); // true for deep watching the object

// Function to get staff instructions
vm.getStaffInstructions = function () {
  if (vm.patient && vm.patient.visitType && vm.patient.visitType.staffInstruction) {
      // Split the instructions by commas and trim them
      var instructions = vm.patient.visitType.staffInstruction.split(',');
      vm.staffInstructions = instructions.map(function(instruction) {
          return instruction.trim();
      });
  } else {
      vm.staffInstructions = [];
  }
};


// Call it initially to ensure instructions are available on page load
if (vm.patient && vm.patient.visitType && vm.patient.visitType.staffInstruction) {
  vm.getStaffInstructions();
}

    


    vm.getPatientDetails = function (patientOld) {
      if (!patientOld || !patientOld.hospitalId || patientOld.hospitalId == '') {
        swal("Please provide Case or Hospital ID number provided by the clinic / hospital");
        return;
      }
      if (!patientOld.contactNum || patientOld.contactNum == '') {
        swal("Please provide phone number associated with your Case ID/Hospital ID for verification");
        return;
      }

      var getEventAction = {
        "requestType": "reqGetPatienInfoPublic",
        "entityId": vm.weeklyAvailability.locationInfo.entityId,
        "hospitalId": patientOld.hospitalId,
        "patientMobileNumber": patientOld.contactNum,
        "userIdOrServiceName": vm.selectedDoctorInfo.doctorUserId,
        "userUtcOffset": -(new Date().getTimezoneOffset())
      };

      return $http.post(urls.apiUrl + "?request=reqGetPatienInfoPublic", getEventAction)
        .then(function (result) {
          if (result.data) {
            if (result.data.patientMatched) {
              vm.patient.name = result.data.patientName;
              vm.patient.emailId = result.data.patientEmailId;
              vm.patient.patientID = result.data.patientId;
              vm.patient.contactNum = patientOld.contactNum;

              // update for dob
              vm.patient.ageMonths = result.data.patientAgeMonths;
              vm.patient.ageYears = result.data.patientAgeYears;
              vm.patient.patientDateOfBirth = result.data.dateOfBirth;
              vm.patient.sex = result.data.patientSex;

              var d = new Date(vm.patient.dateOfBirth);
              vm.patient.dobdd = d.getDate();
              vm.patient.dobmm = d.getMonth() + 1;
              vm.patient.dobyyyy = d.getFullYear();
              vm.patientAgeType = "dob";


            } else {
              //$log.info("patient did not match ");
              vm.patient.hospitalId = "";
              swal("Case/Hospital ID or Phone number entered did not match our records. Please try again, or continue booking by providing the information again");
            }
          } else {
            swal("Case or ID number entered is not valid. You can continue without the case or ID number by filling in the rest of the form ");
            vm.patient.hospitalId = "";
          }
        }, function (error) {
          swal("Error occured while fetching patient details");
        });
    };

    vm.isVideoType = function () {
      return vm.patient.visitType != null && vm.patient.visitType.consultationType === "Video Consultation";
    };

    vm.validateEmail = function() {
      if(vm.patient.emailId){
        var email = vm.patient.emailId;
        vm.invalidEmailId = false;
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        vm.invalidEmailId = !(re.test(email));
        return !(re.test(email));
      }else{
        vm.invalidEmailId = false;
        return true;
      }

    }

    vm.submitRequest = function () {
      if(vm.hideReason) {
        vm.patient.reason = vm.patient.visitType.aptTypeName;

      }
      if(vm.selectedCountry)
        vm.patient.nationality = vm.selectedCountry.name;
      var dataOk =
        (vm.isEconsult && vm.patient && vm.patient.name && vm.patient.contactNum && vm.patient.visitType && vm.patient.reason &&
          vm.pvr.patientQuery) ||
        (vm.selectedSlot && vm.isVideoType() &&
          vm.patient &&
          vm.patient.name &&
          vm.patient.contactNum &&
          vm.patient.visitType &&
          vm.patient.reason &&
          vm.pvr.patientQuery
          ) ||
        (vm.selectedSlot && !vm.isVideoType() && vm.patient && vm.patient.name && vm.patient.contactNum && vm.patient.visitType && vm.patient.reason);

            if (vm.showNationalID()) {
              dataOk = (dataOk && vm.patient.govtIdNum);
              if(!vm.isVideoType()) {
                vm.patient.reason = vm.patient.reason  + "(National ID: " + vm.patient.govtIdNum + ")";
              }
            }
            if (vm.showNationality()) {
              dataOk = (dataOk && vm.patient.nationality);
            }

            console.log("New patient = " + vm.patient.newPatient);

            if (vm.isVideoType() && vm.showFileNumberForFollowup() && vm.patient.newPatient === "false") {
              dataOk = (dataOk && vm.patient.fileNumber);
            }
            if (vm.patient.international && vm.showPassportDetails()){
              dataOk = (dataOk && vm.patient.passportNumber && vm.pvr.patientAttachments && vm.pvr.patientAttachments.length>0);
            }
            if(vm.weeklyAvailability.locationInfo.configMap["enablePatientProvidedFields"] === 'true') {
              dataOk = (dataOk && vm.checkMandatePatientProvidedFields());
            }
            if(vm.showEmailId()) {
              if(vm.isVideoType() || vm.isEconsult) {
                if(!(vm.videoFormOptions && vm.videoFormOptions.disableEmailId)) {
                  dataOk = (dataOk && vm.patient.emailId && !vm.invalidEmailId);
                }
              }
            }

            if (vm.patient.contactNum){
              if(!(/^\d+$/.test(vm.patient.contactNum))){
                swal("Invalid Mobile number, kindly enter correct number, don't include space or any characters Ex: 9123456789")
              }
              dataOk = (dataOk && (/^\d+$/.test(vm.patient.contactNum)))
            }
            if(vm.isFollowupVisit){
              if (vm.previousVisitDate == null){
                dataOk = false;
                vm.invalidFollowup = true;
              }
            }


            vm.patientDetailsNotFilled = !dataOk;

            if (!vm.patientDetailsNotFilled) {
              if (!disableAppyCouponCode && vm.couponMatched && vm.couponDiscountAmt > 0) {
                vm.patient.visitType.fees = vm.patient.visitType.fees - vm.couponDiscountAmt;
                vm.couponDiscountAmt = 0;
                disableAppyCouponCode = true;
              }
              bookAService(vm.patient);
              vm.patientDetailsNotFilled = false;
            }

    };

    vm.checkMandatePatientProvidedFields = function (){
      var dataOk = true;
      if(vm.pvr.customItems){
        angular.forEach(vm.pvr.customItems, function(ci){
          if(dataOk && ci.mandatory && !ci.fieldValue){
            dataOk = false;
          }
        });
      }
      return dataOk;
    };

    vm.clearFollowup = function () {
      if(!vm.isFollowupVisit){
        vm.invalidFollowup = false;
        vm.previousVisitDate = null;
        vm.pastVisitDate = null;
      }
    }

    vm.checkPrevDateValidity = function () {
      if(vm.previousVisitDate != null){
        var today = new Date();
        var dateDiff = (today.getTime() - vm.previousVisitDate.getTime())/(1000*60*60*24);
        console.log(dateDiff);
        if (dateDiff > vm.patient.visitType.daysLimitForFollowUp) {
          vm.invalidFollowup = true;
          vm.pastVisitDate = null;
        }else {
          vm.pastVisitDate = vm.previousVisitDate.getTime();
          vm.invalidFollowup = false;
        }
      }else{
        vm.pastVisitDate = null;
        vm.invalidFollowup = true;
      }
      /*if (vm.previousVisitDate!=null){
        var prevDates = vm.previousVisitDate.toString().split('/');
        if (prevDates!=null && prevDates.length>2){
          var enteredDate = new Date(parseInt(prevDates[2]),parseInt(prevDates[1])-1,parseInt(prevDates[0]));
          console.log(enteredDate);
          var today = new Date();
          var dateDiff = (today.getTime()-enteredDate.getTime())/ (1000*60*60*24);
          console.log(dateDiff);
          if (dateDiff > vm.patient.visitType.daysLimitForFollowUp) {
            vm.invalidFollowup = true;
          }else {
            vm.pastVisitDate = enteredDate.getTime();
            vm.invalidFollowup = false;
          }
        }
      }*/
    };
    vm.checkDate = function () {

      var invalid_year = isNaN(vm.patient.dobyyyy) || vm.patient.dobyyyy == null || vm.patient.dobyyyy == "";
      var invalid_month = isNaN(vm.patient.dobmm) || vm.patient.dobmm == null || vm.patient.dobmm == "";
      var invalid_date = isNaN(vm.patient.dobdd) || vm.patient.dobdd == null || vm.patient.dobdd == "";

      try {
        if (invalid_year || invalid_month || invalid_date) {
          vm.invalidDate = true;
        }
        else {
          vm.invalidDate = false;
          vm.patient.dateOfBirth = new Date(vm.patient.dobyyyy, vm.patient.dobmm - 1, vm.patient.dobdd).getTime();
          vm.patient.ageYears = null;
          vm.patient.ageMonths = null;
        }

      } catch (e) {
        vm.invalidDate = true;
      }
    }
    
    // document the function below 
    vm.checkAgeYears = function () {
      var age = parseInt(vm.patient.ageYearsStr);
      if (!isNaN(age)) {
        if (age > 0) {
          vm.patient.ageYears = age;
          vm.patient.dateOfBirth = null;
          vm.invalidAge = false;
        }
      } else {
        vm.invalidAge = true;
      }
    }

    vm.checkAgeMonths = function () {
      var age = parseInt(vm.patient.ageMonthsStr);
      if (!isNaN(age)) {
        if (age > 0) {
          vm.patient.ageMonths = age;
          vm.patient.dateOfBirth = null;
          vm.invalidAge = false;
        }
      } else {
        vm.patient.ageMonths = 0;
      }
    };
    vm.continueToNextStep = function () {
      $scope.$emit("submit-service-request");
    }

    function getDdMMyyyy(d) {
      var day = d.getDate();
      var month = d.getMonth();
      month = month + 1;
      if (("" + day).length == 1)
        day = '0' + day;
      if (("" + month).length == 1)
        month = '0' + month;
      return day + "/" + month + "/" + d.getFullYear();
    }

    function createDPEvent(patient, selectedVisitType) {
      // To Find Source info
      var baseUri = document.baseURI;
      console.log(baseUri);


      //var selectedSlotObj = ClinicService.getSelectedSlot();
      var dpEvent = {};
      // var maxAptsPerHour = ClinicService.getDoctorSchedulesObj().data.doctorInfoList[0].weeklyAvailabilityList[0].maxAptsPerHour;
      var maxAptsPerHour = vm.weeklyAvailability.maxAptsPerHour;

      if (baseUri != null && baseUri.indexOf("utm_source=") > -1) {
        var medium = baseUri.split("utm_source=")[1].split("&")[0];
        console.log("baseUri contains utm_source= , hence populating type as " + medium);
        dpEvent.sourceType = medium;
      }
      dpEvent.patientName = patient.name;
      dpEvent.patientContactNumber = patient.contactNum;
      dpEvent.countryCode = vm.countryCode.replace(/\D/g, '');
      if(dpEvent.countryCode!=='91'){
        //Removed as we decided to store country code and phone number separately
        // dpEvent.patientContactNumber = dpEvent.countryCode+dpEvent.patientContactNumber;
      }
      if (patient.dateOfBirth) {
        dpEvent.patientDateOfBirth = patient.dateOfBirth;
      }
      dpEvent.patientOrigNumber = patient.patientOrigNumber;
      dpEvent.patientEmailId = patient.emailId;
      dpEvent.startTime = new Date(getTimeForSlot(vm.selectedSlot, maxAptsPerHour)).getTime();
      dpEvent.ddmmyyyy = getDdMMyyyy(new Date(dpEvent.startTime)).replace(new RegExp('/', 'g'), "");
      dpEvent.userIdOrServiceName = patient.visitType.userId;
      dpEvent.doctor = true;
      dpEvent.timeSlot = vm.selectedSlot.timeSlot;
      dpEvent.daySlot = vm.selectedSlot.daySlot;
      dpEvent.sendEmailNotification = true;
      dpEvent.sendSmsNotification = true;
      dpEvent.standardReminderEnabled = false;
      dpEvent.standardReminderMinutes = 45;
      dpEvent.aptTypeName = patient.visitType.aptTypeName;
      dpEvent.details = patient.reason;
      dpEvent.numberOfTimeSlots = patient.visitType.numberOfTimeSlots;
      dpEvent.bookedTimeEvent = true;
      dpEvent.hospitalId = (selectedVisitType.hospitalId) ? selectedVisitType.hospitalId : null;
      dpEvent.nationality = patient.nationality;
      dpEvent.patientSex = patient.sex;
      dpEvent.ageYears = patient.ageYears;
      dpEvent.ageMonths = patient.ageMonths;

      //dpEvent.patientBookedChannel = "WEB";
      dpEvent.patientBookedChannel = CommonService.getPatientBookedChannel();
      console.log(dpEvent.patientBookedChannel);

      dpEvent.newPatient = (patient.newPatient == 'true');
      dpEvent.international = (vm.patient.international == 'true');
      if (vm.couponMatched) {
        dpEvent.couponCode = vm.couponCode;
      }

      if (patient.visitType.isPaymentEnabled) {
        if (patient.visitType.followUpFees != null) {
          dpEvent.fees = Math.round(patient.visitType.followUpFees + (patient.visitType.taxPercentage / 100) * patient.visitType.followUpFees);
        } else {
          dpEvent.fees = Math.round(patient.visitType.fees + (patient.visitType.taxPercentage / 100) * patient.visitType.fees);
        }
      }

      return dpEvent;
    }

    function updatePvrFromPatient(patient) {
      var maxAptsPerHour = vm.weeklyAvailability.maxAptsPerHour;
      vm.pvr.patient = patient;
      vm.pvr.patient.firstName = patient.name;
      vm.pvr.patient.countryCode = vm.countryCode.replace(/\D/g, '');
      if(vm.pvr.patient.countryCode!=='91'){
        //Removed as we decided to store country code and phone number separately
        // vm.pvr.patient.contactNum = vm.pvr.patient.countryCode+vm.pvr.patient.contactNum;
      }
      vm.pvr.reasonForVisit = patient.reason;
      vm.pvr.visitTypeName = patient.visitType.aptTypeName;
      vm.pvr.isConsultation = true;
      vm.pvr.doctorUserId = patient.visitType.userId;
      if (vm.couponMatched) {
        vm.pvr.couponCode = vm.couponCode;
      }
      if (vm.pvr.patient.visitType.isPaymentEnabled) {
        if (vm.isFollowupVisit && !vm.invalidFollowup){
          if (vm.patient.visitType.followUpFees != null){
            vm.pvr.consultationAmountBilled = Math.round(vm.pvr.patient.visitType.followUpFees + (vm.pvr.patient.visitType.taxPercentage / 100) * vm.pvr.patient.visitType.followUpFees);
          }
        }else{
          vm.pvr.consultationAmountBilled = Math.round(vm.pvr.patient.visitType.fees + (vm.pvr.patient.visitType.taxPercentage / 100) * vm.pvr.patient.visitType.fees);
        }
      }

      vm.pvr.consultationAmountPaid = 0;
      vm.pvr.doctorName = vm.selectedDoctorInfo.name;
      vm.pvr.status = "Response Pending";
      var vd;
      if (vm.isEconsult) {
        vd = vm.selectedDate;
        var d = new Date();
        vd.setHours(d.getHours());
        vd.setMinutes(d.getMinutes());
      } else {
        vd = new Date(getTimeForSlot(vm.selectedSlot, maxAptsPerHour));
      }

      vm.pvr.visitDate = vd.getTime();
      vm.pvr.dateLong = new Date(vd.getFullYear(), vd.getMonth(), vd.getDate()).getTime();
      if (patient.dateOfBirth) {
        vm.pvr.patient.dateOfBirth = patient.dateOfBirth;
      }
    }

    var handleAddAptConfirm = function (bookingStatus, addEventResult) {
      if (bookingStatus == 'confirmed') {
        if (vm.isVideoType()) {
          swal("Your video appointment booking is successful! Please check your mail for more details on how to connect to your video appointment");
        } else {
          swal("Your appointment booking is successful! Please check your mail for more details.");
        }
        $scope.$emit("request-complete");
        //resetToFirstStep();
      }/* else if (bookingStatus == 'confirmed') {
        swal("Booking Successful! Please check your mail for more details.");
        $scope.$emit("request-complete");
      }*/ else if (bookingStatus == 'reservedPendingPayment') {
        vm.bookingResult = addEventResult;
        if(vm.showPaypal()){
          vm.paypalRender();
        }else{
          vm.payAmount();
        }
      } else if (bookingStatus == 'reservedPendingVerification' || bookingStatus == 'reservedPendingVerificationEmail') {
        verifyOtp(addEventResult, "To confirm appointment, please enter OTP sent to your mobile:");
      } else {
        swal("Error while booking the appointment. Please try again.");
      }
    };
    var verifyOtp = function (respData, t) {
      //var t = retry? "Invalid OTP, Try again":"Enter OTP";
      swal({
        title: t,
        input: 'text',
        showCancelButton: true,
        cancelButtonText: 'Resend Code',
        inputValidator: function (value) {
          return new Promise(function (resolve, reject) {
            if (value) {
              resolve()
            } else {
              reject('You need to write something!')
            }
          })
        }
      }).then(function (otp) {
        var docSchedules = ClinicService.getDoctorSchedulesObj().data;
        $scope.bookApmtApiCall = true;

        $http
          .post(urls.apiUrl + '?request=ConfirmAppointmentAction', {
            otp: otp,
            aId: respData.aId,
            entityId: vm.weeklyAvailability.locationInfo.entityId
          })
          .then(function (response) {
            if (response.data.result) {
              swal("Your appointment is confirmed. Details of the appointment have been sent to you by SMS and Email!");
              //resetToFirstStep();
              $scope.$emit("request-complete");
            } else if (response.data.errorCode == "invalidAppointmentId") {
              //swal('OTP you entered is invalid');
              // retry
              verifyOtp(respData, "Invalid Code,Try again");
            }
          });
      }, function (dismiss) {
        if (dismiss === 'cancel') {
          $http
            .post(urls.apiUrl + '?request=ConfirmAppointmentAction', {
              aId: respData.aId,
              resendOTP: true
            })
            .then(function (response) {
              if (response.data.result) {
                verifyOtp(respData, "Code resent, try again");
              } else {
                swal("Sorry,Unable to resend Code!");
              }
            });
        }
      });
    };


    var handleAptAddError = function (errorCode) {
      if (errorCode === 'timeSlotsInSufficient') {
        swal("Sorry, all the appointment slots seem to be taken, Please try an alternate time.");
      } else if (errorCode === 'timeSlotUnavailable' || errorCode === 'timeSlotUnavailable') {
        swal("Sorry, the appointment slot you are trying to book is not available.  Please select an alternate time.");
      } else if (errorCode === 'appointmentAlreadyBooked' || errorCode === 'appointmentAlreadyBookedNumberMismatch') {
        swal("You have already scheduled an appointment for this patient.");
      } else if (errorCode === 'noPaidAptFoundOnDate'){
        swal("No Previous Paid appointment found for selected previous visit date, Hence follow up appointment cannot be book");
      } else if (errorCode === 'couponCodeMandatory') {
        swal("Discount coupon/code is mandatory, kindly enter valid coupon code to avail discount");
      } else if (errorCode === 'aptTimeInThePast') {
        swal("Booking time for this slot has been expired, kindly choose a different slot and try again");
      }else if (errorCode === '"appointmentAlreadyBookedNoNewApt'){
        swal("You have already scheduled an appointment for this patient. Multiple appointments are not allowed");
      }
      else {
        swal("Unable to book appointment due to a server error.");
      }
    };
    vm.getPayableAmount = function () {
      if (vm.pvr && vm.pvr.patient && vm.pvr.visitType) {
        var amt = Math.round(vm.pvr.patient.visitType.fees + (vm.pvr.patient.visitType.taxPercentage / 100) * vm.pvr.patient.visitType.fees);
        return amt;
      } else {
        return 0;
      }

    };

    vm.getOrderId = function() {
      if (vm.isEconsult || vm.isVideoType()) {
        return vm.bookingResult.id;
      } else {
        return  vm.bookingResult.aId;
      }
    };

    vm.payAmount = function () {
      //var amt = vm.patientData.visitType.fees;
      var amt = Math.round(vm.patientData.visitType.fees + (vm.patientData.visitType.taxPercentage / 100) * vm.patientData.visitType.fees);
      if (vm.isFollowupVisit && !vm.invalidFollowup){
        if (vm.patient.visitType.followUpFees != null){
          amt = Math.round(vm.pvr.patient.visitType.followUpFees + (vm.pvr.patient.visitType.taxPercentage / 100) * vm.pvr.patient.visitType.followUpFees);
        }
      }

      var keyObj = getRazorKey();

      var razorpay_key = keyObj.key;
      var hName = "DocPulse";
      if (!keyObj.default) {
        hName = vm.weeklyAvailability.locationInfo.hospitalName;
      }

      var paymentOptions = {
        "key": razorpay_key,
        "amount": (amt * 100),
        "name": hName,
        "description": "Service booking -" + vm.serviceSuffixForPayment,
        "handler": function (response) {
          if (response.razorpay_payment_id) {
            //if (keyObj.default) {
              // there is a webhook now, no need to call
              //swal("Your payment is successful, however it may take upto 20 mins to get a confirmation from the payment gatway. A confirmation email with full details will be sent to you shortly. If you do not receive a confirmation after 20 mins, please write to support@docpulse.com");
              //$scope.$emit("request-complete");
            //} else {
              paymentCompletedCallback(response, amt);
            //}

          } else {
            swal(" Sorry, payment has not been successful, please try again or send a email to support@docpulse.com for assistance");
            vm.payAmount();
          }
        },
        "modal.escape": false,
        "prefill": {
          "name": vm.patientData.name,
          "email": vm.patientData.emailId,
          "contact": vm.patient.contactNum
        },
        "notes": {
          "details": vm.serviceSuffixForPayment,
          "order_id": vm.getOrderId(),
          "razorKey": getRazorKey().key,
          "serviceType": getServiceType()
        }
      };

      var pgUrl = vm.weeklyAvailability.locationInfo.configMap["pgUrl"];
      if(pgUrl) {
        var toBeEncoded = 'towards=' + getServiceType();
        toBeEncoded = toBeEncoded + '&amount=' + amt;
        toBeEncoded = toBeEncoded + '&orderId=' + vm.getOrderId();
        toBeEncoded = toBeEncoded + '&hospitalName=' + vm.weeklyAvailability.locationInfo.hospitalName;
        toBeEncoded = toBeEncoded + '&contactNumber=' + vm.patient.contactNum;
        toBeEncoded = toBeEncoded + '&emailId=' + vm.patientData.emailId;
        toBeEncoded = toBeEncoded + '&razorKey=' + getRazorKey().key;
        if(vm.selectedDoctorInfo.isDoctor) {
          toBeEncoded = toBeEncoded + '&doctorName=Dr. ' + vm.selectedDoctorInfo.name;
        }else {
          toBeEncoded = toBeEncoded + '&doctorName=' + vm.selectedDoctorInfo.name;
        }
        var encodedStr = btoa(toBeEncoded);
        if(vm.weeklyAvailability.locationInfo.configMap["razorPayKey"]){
          $window.location.href = "https://www.meetmydoctor.in" + pgUrl + '?r=' + encodedStr;
        }else{
          $window.location.href = vm.baseUrl + pgUrl + '?r=' + encodedStr;
        }
      }else {
        var rzp1 = new Razorpay(paymentOptions);
        rzp1.open();
      }

    };

    vm.openConsentUrl = function () {
      $window.open(vm.consentUrl, "_blank");
    }

    function getServiceType() {
      var ret = null;
      if (vm.isEconsult) {
        ret = "e-Consultation";
      } else {
        if (vm.isVideoType()) {
          ret = "e-Consultation Video";
        } else {
          ret = "appointment";
        }
      }
      return ret;
    }

    function getRazorKey() {
      var razorpay_key = "rzp_live_oDf1QVAUyvqKVf";
      var k = vm.weeklyAvailability.locationInfo.configMap["razorPayKey"];
      var docpulse = true;
      if (k) {
        razorpay_key = k;
        docpulse = false;
      }
      //}

      return {key: razorpay_key, default: docpulse};
    }

    vm.isCouponCodeEnabled = function () {
      var k = vm.weeklyAvailability.locationInfo.configMap["couponCodes"];
      if (k) {
        return true;
      } else {
        return false;
      }
    };

    vm.applyCouponCode = function (coupon) {
      if (coupon) {
        vm.couponError = false;
        vm.couponMatched = false;
        vm.couponExpired = false;

        $http
          .post(urls.apiUrl + '?request=computeDiscountCouponCode', {
            // entityId: vm.weeklyAvailability.locationInfo.entityId,
            entityId: vm.weeklyAvailability.locationInfo.couponEntityId,
            couponCode: coupon,
            fees: vm.patient.visitType.fees,
            isPublic: true,
            department: vm.selectedDoctorInfo.department,
            patientContactNumber: vm.patient.contactNum,
            requestType: "computeDiscountCouponCode"
          })
          .then(function (response) {
            if (response.data.result) {
              vm.couponDiscountAmt = response.data.discountAmount;
              vm.couponMatched = true;
              vm.pvr.couponEntityId = vm.weeklyAvailability.locationInfo.couponEntityId;
            }else{
              if(response.data.errorCode == "couponCodeInvalid"){
                vm.couponError = true;
                swal("Invalid Coupon Code");
              }else if(response.data.errorCode == "couponCodeExpired"){
                vm.couponExpired = true;
                swal("This coupon is expired");
              }else if (response.data.errorCode == "couponCodeReachedLimit"){
                swal("Coupon Usage limit has been exceeded, hence cannot be applied");
              }else{
                swal("Error while applying coupon please try after some time");
              }
            }
          });
        /*var k = vm.weeklyAvailability.locationInfo.configMap["couponCodes"];
        if (k) {
          var coupons = JSON.parse(k);
          angular.forEach(coupons, function (cou) {
            if (cou.name == coupon) {
              if (!vm.couponMatched) {
                var couExpDateParts = cou.validTill.split("/");
                var couponExpDate = new Date(+couExpDateParts[2], couExpDateParts[1] - 1, +couExpDateParts[0]);
                var today = new Date();
                if (today.getTime() <= couponExpDate.getTime()) {
                  vm.couponMatched = true;
                  var couponValue = cou.couponValue;
                  if (couponValue.indexOf("%") > -1) {
                    vm.couponDiscountAmt = vm.patient.visitType.fees * (parseInt(couponValue.toString()) / 100)
                  } else {
                    vm.couponDiscountAmt = parseInt(cou.couponValue.toString());
                  }
                } else {
                  vm.couponExpired = true;
                }
              }
              // vm.patient.visitType.fees = vm.patient.visitType.fees - cou.couponValue;
            }
          });
          if (!vm.couponMatched && !vm.couponExpired) {
            vm.couponError = true;
          }
        } else {
          vm.couponError = true;
        }*/
      }
    };

    vm.clearCouponDiscount = function () {
      vm.couponError = false;
      vm.couponMatched = false;
      vm.couponExpired = false;
      vm.couponDiscountAmt = 0;
      vm.couponCode = null;
    };

    vm.showFirstAndFollowup = function () {
      // pph: remove dependency on video type.
      if(vm.videoFormOptions) {
        return vm.videoFormOptions.enableFirstOrFollowupSelection;
      }else {
        return !vm.isEconsult && !(vm.selectedSlot && vm.isVideoType());
      }
    };
    vm.showEmailId = function(){
      if(vm.videoFormOptions && vm.videoFormOptions.disableEmailId) {
        return false;
      }else {
        return true;
      }
    }

    vm.showNationalID = function () {
      if (vm.videoFormOptions && vm.videoFormOptions.showNationalID) {
        return true;
      } else {
        return false;
      }
    };
   vm.numericNationalID = function () {
      if (vm.videoFormOptions && vm.videoFormOptions.numericNationalID) {
        return true;
      } else {
        return false;
      }
    };
    vm.showNationality = function () {
      return vm.weeklyAvailability.locationInfo.configMap.enableMarketingFields === 'true'
    };
    vm.showFileNumberForFollowup = function () {
      if (vm.isVideoType() && vm.videoFormOptions && vm.videoFormOptions.showFileNumberForFollowup) {
        return true;
      } else {
        return false;
      }
    }

    vm.hideRequestForAnotherPatient = function () {
      if (vm.isVideoType() && vm.videoFormOptions && vm.videoFormOptions.hideRequestForAnotherPatient) {
        return true;
      } else {
        return !vm.isVideoType();
      }
    };

    vm.showPassportDetails = function () {
      if (vm.isVideoType() && vm.videoFormOptions && vm.videoFormOptions.showPassportDetails) {
        return true;
      } else {
        return false;
      }
    };

    vm.showPaypal = function () {
      if(vm.weeklyAvailability.locationInfo.configMap.enablePayPal){
        return true;
      }else {
        return false;
      }
    };

    

    vm.getCountries= function() {
      if(vm.countries.length===0) {
        $http
        .get(vm.baseUrl + "/api?request=countries").then(function(response){
          vm.countries =  response.data.nationalities;
       });
      }else {
        return vm.countries;
      }
    };

    vm.countrySelected = function(item,model,label) {
      vm.patient.nationality = item.name;
    };

    vm.getPatientProvidedFields = function () {
      return $http.post(urls.apiUrl + "?request=reqGetPatientProvidedFields",{
        requestType: "reqGetPatientProvidedFields",
        doctorUserId: vm.patient.visitType.userId,
        entityId: vm.weeklyAvailability.locationInfo.entityId,
        aptType: vm.patient.visitType.aptTypeName
      })
        .then(function (result) {
          if (result.data.result) {
            vm.pvr.customItems = result.data.customItems;
          }
        });
    };

    function paymentCompletedCallback(response, amt) {
      var service;

      var razorpay_key = getRazorKey().key;
      var oid;

      if (vm.isEconsult) {
        service = "e-Consultation";
        oid = vm.bookingResult.id;
      } else {
        if (vm.isVideoType()) {
          service = "e-Consultation Video";
          oid = vm.bookingResult.id;
        } else {
          service = "appointment";
          oid = vm.bookingResult.aId;
        }
      }
      var url;
      if (vm.showPaypal()){
         url = "/api?request=payment&order_id=" + oid + "&merchant_param1=" + service + "&amount=" + amt + "&paypal_payment_id=" +response.paymentID ;
      }else{
        url = "/api?request=payment&order_id=" + oid + "&merchant_param1=" + service + "&amount=" + amt + "&razorpay_payment_id=" + response.razorpay_payment_id+ "&razor_key=" + razorpay_key;
      }
      $http
        .get(CommonService.getPaymentHost() + url)
        .then(function (r) {
          if (r) {
            swal("Your payment is successful, however it may take upto 20 mins to get a confirmation from the payment gateway. If you do not receive a confirmation after 20 mins, please write to support@docpulse.com");
            //resetToFirstStep();
            $scope.$emit("request-complete");
          } else {
            swal('Error while processsing the payment.');
          }
        }, function (error) {
          console.log(error);
        });
    }

    var getTimeForSlot = function (esb, maxApts) {
      var numMins = esb.timeSlot * (60 / maxApts);
      var now = new Date(vm.selectedDate);
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);

      now.setTime((now.getTime() + numMins * 60 * 1000));
      return now;
    };

    function bookAService(patient) {
      vm.patientData = patient;
      var docSchedules, weeklyAvail;

      docSchedules = ClinicService.getDoctorSchedulesObj().data;
      //weeklyAvail = docSchedules.doctorInfoList[0].weeklyAvailabilityList[0];

      if (vm.isEconsult) {
        updatePvrFromPatient(patient);

        $http.post(urls.apiUrl + '?request=createOnlineConsultationPvr', {
          requestType: "createOnlineConsultationPvr",
          pvr: vm.pvr,
          entityId: vm.weeklyAvailability.locationInfo.entityId,
          userUtcOffset: -(new Date().getTimezoneOffset()),
          pvrKey : pvrKey ? pvrKey : null
        }).then(function (response) {
          var res = response.data;
          if (res.result) {
            // payment collection
            if (vm.patient.visitType.fees > 0 && vm.patient.visitType.isPaymentEnabled) {
              vm.bookingResult = res;
              vm.payAmount();
            } else {
              swal("Request submitted successfully. Response will be sent to your email within 24-48 hours ! Thanks");
              $scope.$emit("request-complete");
            }

          } else {
            swal("Error Occured");
          }
        }, function (error) {
          console.log(error);
        });
      } else if (vm.isVideoType()) {
        updatePvrFromPatient(patient);
        var now = new Date(vm.pvr.visitDate);
        now.setHours(0);
        now.setMinutes(0);
        now.setSeconds(0);
        now.setMilliseconds(0);
        var numMins = vm.selectedSlot.timeSlot * (60 / vm.weeklyAvailability.maxAptsPerHour);
        $http.post(urls.apiUrl + '?request=requestCreateVideoConsAptPvr', {
          requestType: "requestCreateVideoConsAptPvr",
          pvr: vm.pvr,
          entityId: vm.weeklyAvailability.locationInfo.entityId,
          startTime: now.getTime() + numMins * 60 * 1000,
          timeSlot: vm.selectedSlot.timeSlot,
          numSlots: patient.visitType.numberOfTimeSlots,
          userUtcOffset: -(new Date().getTimezoneOffset()),
          previousVisitTime: !vm.invalidFollowup?vm.pastVisitDate:null
        }).then(function (response) {

          if (response.data.result) {
            // copy the ID
            var res = response.data.addEventResult;
            res.id = response.data.id;
            handleAddAptConfirm(res.bookingStatus, res);
          } else {
            handleAptAddError(response.data.errorCode);
          }
        }, function (error) {
          console.log(error);
        });
      } else {
        var wholeObj = createDPEvent(patient, patient.visitType.aptTypeName);

        $scope.bookApmtApiCall = true;

        $http.post(urls.apiUrl + '?request=AddEventAction', {
          event: wholeObj,
          entityId: vm.weeklyAvailability.locationInfo.entityId,
          enableMultipleApts: vm.weeklyAvailability.locationInfo.enableMultipleApts,
          verificationEnabled: vm.patient.patientID == undefined || vm.patient.patientID == null,
          userUtcOffset: -(new Date().getTimezoneOffset()),
          previousVisitTime: !vm.invalidFollowup?vm.pastVisitDate:null
        }).then(function (response) {
          if (response.data.result) {
            handleAddAptConfirm(response.data.bookingStatus, response.data);
          } else {
            handleAptAddError(response.data.errorCode);
          }
        }, function (error) {
          console.log(error);
        });
      }

    }

    // FOCUS
    angular.element('#name').focus();
    //angular.element("#booking_form").scrollTop(0);
    $window.scrollTo(0, 0);

    // keep a copy of applicable visit type
    
    // get countries

    vm.getCountries();
    if(vm.weeklyAvailability.locationInfo.configMap["enablePatientProvidedFields"] === 'true'){
      vm.getPatientProvidedFields();
    }
    
    
  }


  angular.module('mmd.clinic')
    .component('bookingForm', {
      templateUrl: 'app/modules/clinic/components/booking-form/partials/booking-form.html',
      bindings: {
        selectedDoctorInfo: '=',
        selectedSlot: '=',
        patient: '=',
        pvr: '=',
        selectedDate: '=',
        weeklyAvailability: '=',
        isEconsult: '=',
        followup: '='

      },
      controllerAs: 'vm',
      controller: BookingFormController
    });

})();

(function () {
  'use strict';

  angular.module('mmd.meetmydoctor', []);

})();

(function () {
  'use strict';

  angular.module('mmd.meetmydoctor')
    .controller('MeetMyDoctorController', MeetMyDoctorController);

  function MeetMyDoctorController( $scope, $rootScope, $state, $http, $filter, $sce, $log, urls) {

    $log.info("inside meetmydoctor ");

    var vm = this;

    //$scope.currentNavItem = 'page1';

    vm.options = {
      "city" : null,
      "area" : null,
      "speciality" : null,
      "country": null
    };


    vm.getData = function() {
      $http.post(urls.apiUrl + "?request=mmdsearch",{
        requestType: "sr_get_countries_cities"
      }).then(function(response){
        if(response.data) {
          //vm.defaultCountry = response.data.defaultCountry;
          vm.countries = response.data.countries;
          vm.cities = response.data.cities;
          vm.options.country = response.data.defaultCountry;
          vm.options.city = response.data.defaultCity;
        }

      });
    }

    // boot strap
    vm.getData();

  }
})();

(function () {
  'use strict';

  angular.module('mmd.kiosk', []);

})();

(function () {
  'use strict';

  angular.module('mmd.kiosk')
    .service('KioskService', KioskService);

  function KioskService() {

    this.appointmentDetails = {};
    this.selectedDate = '';
    this.initialDate = '';
    this.lastTabDate = '';
    this.doctorSchedulesObj = {};
    this.selectedSlot = {};
    this.doctorDetails = {};

    this.setAppointmentDetails = function (apmt) {
      this.appointmentDetails = apmt;
    };
    this.getAppointmentDetails = function () {
      return this.appointmentDetails;
    };

    this.setRecentTabSelected = function (tab) {
      this.recentTab = tab;
    };
    this.getRecentTabSelected = function () {
      return this.recentTab;
    };

    this.setInitialDateString = function (date) {
      var x = date.split('/');
      this.initialDate = new Date(x[2], x[1], x[0]);
    };
    this.setInitialDate = function (date) {
      this.initialDate = date;
    };
    this.getInitialDate = function () {
      return this.initialDate;
    };
    this.setSelectedDate = function (date) {
      this.selectedDate = date;
    };
    this.getSelectedDate = function () {
      return this.selectedDate;
    };
    this.setLastTabDate = function (date) {
      this.lastTabDate = date;
    };
    this.getLastTabDate = function () {
      return this.lastTabDate;
    };

    this.setSelectedDoctorDetails = function (doctorDetails) {
      this.doctorDetails = doctorDetails;
    };
    this.getSelectedDoctorDetails = function () {
      return this.doctorDetails;
    };

    this.setDoctorSchedulesObj = function (obj) {
      this.doctorSchedulesObj = obj;
    };
    this.getDoctorSchedulesObj = function () {
      return this.doctorSchedulesObj;
    };

    this.getSlotString = function (val, maxAppointments) {
      if (!val && !maxAppointments) return "";

      var numberOfMinutes = val * (60 / maxAppointments);
      var nowDate = new Date();
      nowDate.setHours(0);
      nowDate.setMinutes(0);
      nowDate.setSeconds(0);
      nowDate.setMilliseconds(0);
      nowDate.setTime((nowDate.getTime() + numberOfMinutes * 60 * 1000));

      var totalHours = nowDate.getHours();
      var meridian = "AM";
      var hours = 0;

      if (totalHours < 12) {
        hours = totalHours;
        meridian = "AM";
      } else {
        meridian = "PM";
        if (totalHours !== 12) {
          hours = totalHours - 12;
        } else {
          hours = totalHours;
        }
      }
      var minutes = nowDate.getMinutes();
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      return hours + ":" + minutes + " " + meridian;
    };

    this.getAvailabilitySlotsHeaders = function (start, end, maxAppointments) {
      return this.getSlotString(start, maxAppointments) + " - " + this.getSlotString(end, maxAppointments);
    };

    this.getAvailabilitySlots = function (start, maxAppointments) {
      return this.getSlotString(start, maxAppointments);
    };

    this.setSelectedSlot = function (obj) {
      this.selectedSlot = obj;
    };
    this.getSelectedSlot = function () {
      return this.selectedSlot;
    };

  }

})();

(function () {
  'use strict';

  angular.module('mmd.kiosk')
    .factory('KioskFactory', KioskFactory);

  function KioskFactory() {

    var datesFact = {};

    datesFact.getDatesObj = function (ipDate) {
      if (typeof(ipDate) == 'object') {
        var datesObj = {
          startDate: '',
          endDate: ''
        };
        var startDate = new Date(ipDate.getFullYear(), ipDate.getMonth() + 1, ipDate.getDate());
        datesObj.startDate = startDate.getDate() + '/' + startDate.getMonth() + '/' + startDate.getFullYear();
        var endDate = angular.copy(startDate.setDate(startDate.getDate() + 3));
        endDate = new Date(endDate);
        datesObj.endDate = endDate.getDate() + '/' + endDate.getMonth() + '/' + endDate.getFullYear();

        return datesObj;
      } else {
        return 'error';
      }
    };

    datesFact.getWeekName = function (val) {
      var weeks = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      return weeks[val];
    };

    return datesFact;

  }

})();

(function () {
  'use strict';

  angular.module('mmd.kiosk')
    .controller('KioskController', KioskController);

  function KioskController($scope, $rootScope, $state, $http, $filter, $sce, $log, urls, KioskService, KioskFactory) {
    var vm = this;

    vm.steps = ['Select the Department', 'Select the Doctor', 'Select the Time', 'Book Appointment'];
    vm.step = 0;
    vm.stepperControl = {};
    vm.departmentsList = [];
    vm.selectedDepartment = '';
    vm.selectedDoctor = {};
    vm.docSelectedOnce = false;
    vm.selectedDoctorInfo = '';
    vm.patient = {};
    vm.showPaymentFrame = false;
    vm.stepSkipped = false;
    vm.entity = $state.params.entity;
    vm.cancelEnabled = false;
    vm.aptCode = null;
    var docSelectedStep;
    $rootScope.entityName = $state.params.entity;
    var today = new Date();
    vm.selectedDate = new Date();
    vm.today = $filter('date')(new Date(), "dd MMM yyyy");
    vm.todayDate = today.getFullYear() + '/' + (today.getMonth() + 1) + '/' + today.getDate();
    var count = 0;

    function getDateFormat(dateObj) {
      var formattedDate = '';
      var date = dateObj.getDate();
      var month = dateObj.getMonth() + 1;
      var year = dateObj.getFullYear();
      date = (date.toString().length == 1) ? ('0' + date) : date;
      month = (month.toString().length == 1) ? ('0' + month) : month;
      formattedDate = date + '/' + month + '/' + year;
      return formattedDate;
    }
    $scope.$watch('vm.entity', function (val, oldVal) {
      if (val != oldVal) {
        getListOfLocations();
      }
    });
    $scope.$watch('vm.selectedDate', function (val, oldVal) {
      if (val != oldVal) {
        if (typeof(val) === 'undefined') {
          console.log('Date not selected');
        } else {
          val = new Date(val);
          var tempStartDateStr = getDateFormat(val);
          val.setDate(val.getDate() + 1);
          var tempEndDateStr = getDateFormat(val);
          val.setDate(val.getDate() - 1);
          vm.newDate = val;
          if (count) {
            loadDoctorSchedules({startDate: tempStartDateStr, endDate: tempEndDateStr});
          }
          count += 1;
        }
      }
    });

    vm.loadOtherDaySlots = function (val) {
      vm.newDate.setDate(vm.newDate.getDate() + val);
      vm.selectedDate = $filter('date')(vm.newDate, "dd MMM yyyy");
    };

    vm.inlineOptions = {
      minDate: new Date(),
      showWeeks: false
    };

    vm.dateOptions = {
      formatYear: 'yy',
      maxDate: new Date(2020, 5, 22),
      minDate: new Date(),
      startingDay: 1
    };

    vm.open = function () {
      vm.popup.opened = true;
    };

    vm.setDate = function (year, month, day) {
      vm.selectedDate = new Date(year, month, day);
    };

    vm.popup = {
      opened: false
    };

    vm.prevStep = function () {
      vm.step -= 1;
      vm.stepperControl.prevStep();
      if (vm.stepSkipped && vm.step === 1) {
        vm.prevStep();
      }
      vm.selectedDepartment = '';
      vm.selectedDoctorInfo = '';
    };

    vm.nextStep = function (patient, doc) {
      switch (vm.step) {
        case 0:
          if (vm.selectedDepartment && !vm.selectedDoctorInfo) {
            vm.selectedDoctor = {};
            getListOfDoctors();
          }
          vm.stepperControl.nextStep();
          vm.step += 1;
          if (vm.selectedDoctorInfo) {
            vm.selectedDoctor = angular.copy(vm.selectedDoctorInfo);
            docSelectedStep = 1;
            vm.selectedDoctor.uid = angular.copy(vm.selectedDoctorInfo.uid);
            vm.nextStep(vm.step);
          }
          break;

        case 1:
          doc = doc || vm.selectedDoctorInfo;
          docSelected(doc, function () {
            var val = new Date();
            var tempStartDate = getDateFormat(val);
            val.setDate(val.getDate() + 1);
            var tempEndDate = getDateFormat(val);
            val.setDate(val.getDate() - 1);
            vm.newDate = val;
            loadDoctorSchedules({startDate: tempStartDate, endDate: tempEndDate});
            vm.stepperControl.nextStep();
            vm.step += 1;
          });
          break;

        case 2:
          vm.stepperControl.nextStep();
          vm.step += 1;
          if (vm.selectedDoctor.weeklyAvailabilityList) {
            vm.enableCaseId = vm.selectedDoctor.weeklyAvailabilityList[0].locationInfo.enableCaseIDSelection;
          }
          break;
        case 3:
          if (patient && patient.name && patient.contactNumber && patient.visitType && patient.reason) {
            bookAnAppointment(patient);
            vm.patientDetailsNotFilled = false;
            vm.stepperControl.nextStep();
            // vm.step += 1;
          } else {
            vm.patientDetailsNotFilled = true;
          }
          break;
      }
    };

    $scope.$watch('vm.selectedDepartment', function (newVal, oldVal) {
      //if (newVal && !oldVal) {

        for (var i = 0; i < vm.departmentsList.length; i++) {
          if(vm.departmentsList[i].toUpperCase()==newVal.toUpperCase()) {
            vm.nextStep();
            break;
          }
      //}
    }
    });

    $scope.$watch('vm.selectedDoctorData', function (newVal, oldVal) {
      if (newVal && newVal.displayString && newVal.id) {
        vm.stepSkipped = true;
        vm.nextStep();
      }
    });

    function getListOfLocations() {
      $http.post(urls.apiUrl + '?request=login_entity', {
        "requestType": "login_entity",
        "entityString": vm.entity
      })
        .then(function (response) {
          if (response.data && response.data.result) {
            vm.departmentsList = response.data.departmentList;
            vm.entityId = response.data.locationInfo ? response.data.locationInfo.entityId : '';
            if(response.data.locationInfo.configMap["branches"] && !vm.branches) {
              vm.branches = JSON.parse(response.data.locationInfo.configMap["branches"]);
            }
            vm.entityData = response.data;
          } else {
            swal("Sorry, the URL/link is invalid. Please check and try again");
          }
        }, function (error) {
          console.log(error);
        });
    }

    vm.getDoctorsBySearchKey = function (searchKey) {
      return $http.get(urls.apiUrl + '?request=get_docs_entity&qs=' + searchKey + '&eid=' + vm.entityId)
        .then(function (response) {
          return response.data.map(function (item) {
            return item;
          });
        }, function (error) {
          console.log(error);
        });
    };

    vm.getPatientDetails = function (patientOld) {
      var getEventAction = {
        "requestType": "reqGetPatienInfoPublic",
        "entityId": vm.selectedDoctor.weeklyAvailabilityList[0].locationInfo.entityId,
        "hospitalId": patientOld.hospitalId,
        "patientMobileNumber": patientOld.contactNumber,
        "userIdOrServiceName": vm.selectedDoctor.doctorUserId,
        "userUtcOffset": -(new Date().getTimezoneOffset())
      };

      return $http.post(urls.apiUrl + "?request=reqGetPatienInfoPublic", getEventAction)
        .then(function (result) {
          if (result.data) {
            if (result.data.patientMatched) {
              vm.patient.name = result.data.patientName;
              vm.patient.email = result.data.patientEmailId;
              vm.patient.patientID = result.data.patientId;
              vm.patient.contactNumber = patientOld.contactNumber;
            } else {
              $log.info("patient did not match ");
              swal("Phone number entered did not match our records. Please try again, or continue by entering the information for consultation ");
            }
          } else {
            swal("Case of ID number entered is not valid. You can request for online consultation without the case or ID number by filling in the rest of the form ");
            vm.patient.hospitalId = "";
          }
        }, function (error) {
          swal("Error occured while fetching patient details");
        });
    };
    vm.payAmount = function () {
      var amt = vm.patientData.visitType.cfb.onlineFeeComponent;
      var paymentOptions = {
        "key": "rzp_live_cJujiuwkiHOWa8",
        "amount": (amt * 100),
        "name": vm.patientData.name,
        "description": "appointment booking",
        "image": "https://www.docpulse.com/images/mt-0391-logo2.png",
        "handler": function (response) {
          // do a get request, Show whatever you get.
          // do a get AJAX request to :
          // "https//www.meetmydoctor.in/jsp/redirecturl.jsp?OrderId=<aId>&Merchant_Param=appointment&Amount=<in rupees>&razorpay_payment_id=" + response.razorpay_payment_id);
          // and show the response in a popup.
          paymentCompletedCallback(response, amt);
        },
        "prefill": {
          "name": vm.patientData.name,
          "email": vm.patientData.email,
          "contact": vm.patient.contactNumber
        },
        "theme": {
          "color": "#F37254"
        }
      };

      var rzp1 = new Razorpay(paymentOptions);
      rzp1.open();
    };

    function paymentCompletedCallback(response, amt) {
      $http
        .get("http://wello-care.appspot.com/jsp/ccavenue_redirect.jsp?order_id=" + vm.paymentData.aId + "&merchant_param1=appointment&amount=" + amt + "&razorpay_payment_id=" + response.razorpay_payment_id)
        .then(function (response) {
          if (response) {
            swal(response);
            resetToFirstStep();
          } else {
            swal('Error while processsing the payment.');
          }
        }, function (error) {
          console.log(error);
        });
    }

    function resetToFirstStep() {
      vm.step = 0;
      //vm.stepperControl = {};
      vm.selectedDepartment = '';
      vm.selectedDoctor = {};
      vm.docSelectedOnce = false;
      vm.selectedDoctorInfo = '';
      vm.patient = {};
    }

    function getListOfDoctors() {
      var date = new Date();
      var date2 = new Date(date.getFullYear(), date.getMonth(),date.getDate()+4);

      $http.post(urls.apiUrl + '?request=getDoctorInfo', {
        "requestType": "getDoctorInfo",
        "entityId": vm.entityId,
        "uId": vm.selectedDoctor.uid,
        "fetchCalendarInfo": true,
        "startRow": 0,
        "numRows": 100,
        "departmentName": vm.selectedDepartment,
        "startDateString": date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear(),
        "endDateString": date2.getDate() + "/" + (date2.getMonth() + 1) + "/" + date2.getFullYear()
      }).then(function (response) {
        if (response.data) {
          vm.docsList = response.data.doctorInfoList;
          angular.forEach(vm.docsList, function (val, key) {
            val.headers = getTimeSlotHeaders(val);
          });
        }
      }, function (error) {
        console.log(error);
      });
    }

    function docSelected(doc, cb) {
      if (doc && !doc.screenApts) {
        vm.selectedDoctor = doc;
        vm.docSelectedOnce = true;
        vm.selectedDoctorFromList = angular.copy(doc);
        docSelectedStep = 2;
        cb();
      } else {
        swal('Online appointment booking is not available for this doctor');
      }
    }

    //================================================================
    var entityId;
    var uId;
    var datesRange;

    vm.days = [];
    vm.weekDays = [];
    vm.availSlotsArray = [];
    vm.newDate = '';
    vm.apiCall = false;
    vm.numColumns = 3;
    vm.rows = [[], [], [], [], [], [], [], [], [], []];
    vm.cols = [];
    vm.weekDaysList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    vm.cols.length = vm.numColumns;
    vm.selectedDoc = vm.selectedDoctor;
    vm.format = 'dd MMM yyyy';

    vm.reloadDataForNewDay = function (val) {
      var initDate = KioskService.getInitialDate();
      var lastTab = KioskService.getRecentTabSelected();

      if (initDate && initDate !== '') {
        if (lastTab > val) {
          KioskService.setSelectedDate(initDate.setDate(initDate.getDate() - (lastTab - val)));
        } else {
          KioskService.setSelectedDate(initDate.setDate(initDate.getDate() + (val - lastTab)));
        }
      } else {
        KioskService.setSelectedDate(new Date());
      }

      vm.currentTabUrl = val || 1;
      KioskService.setRecentTabSelected(val);
      if (Object.keys(KioskService.getDoctorSchedulesObj()).length > 0) {
        vm.doctorSchedules = KioskService.getDoctorSchedulesObj().data;
        reloadTheData();
      }
    };
    vm.reloadDataForNewDay(1);

    vm.initializeRowLength = function (slotLength, numColumns) {
      return Math.ceil(slotLength / numColumns);
    };

    vm.slotSelected = function (selectedSlot, slotTime, availSlot) {
     // console.log(selectedSlot.video);
      vm.selectedSlotTime = slotTime;
      vm.selectedTimeSlot = selectedSlot.timeSlot;
      vm.minSlotSelected = true;
      vm.video = availSlot.aptType == "Video Consultation";

      if (selectedSlot === KioskService.getSelectedSlot()) {
        vm.selectedAId = '';
        vm.selectedTimeSlot = '';
        KioskService.setSelectedSlot('');
        vm.minSlotSelected = false;
      } else {
        vm.minSlotSelected = true;
        vm.selectedAId = selectedSlot.aId;
        vm.selectedTimeSlot = selectedSlot.timeSlot;
        KioskService.setSelectedSlot(selectedSlot);
      }
      vm.nextStep();
    };

    function loadDoctorSchedules(datesRange) {
      vm.reloadDataForNewDay(1);

      var id = vm.selectedDoctor.id!=null? vm.selectedDoctor.id: vm.selectedDoctor.uid;

      $http.post(urls.apiUrl + '?request=getDoctorInfo', {
        "requestType": "getDoctorInfo",
        "entityId": vm.entityId,
        "uId": id,
        "fetchCalendarInfo": true,
        "startRow": 0,
        "numRows": 1,
        "startDateString": datesRange.startDate,
        "endDateString": datesRange.endDate
      }).then(function (response) {
        if (!vm.selectedDoctor.uid) {
          vm.selectedDoctor = response.data.doctorInfoList[0];
        }
        vm.doctorSchedules = response;
        KioskService.setDoctorSchedulesObj(response);
        KioskService.setInitialDateString(datesRange.startDate);
        reloadTheData();
      }, function (error) {
        console.log(error);
      });
    }

    function getTimeSlotHeaders(docData) {
      if (docData && docData.weeklyAvailabilityList.length > 0) {
        vm.availablityDaySlots = docData.weeklyAvailabilityList[0].daySlots;
        vm.announceTimings = docData.weeklyAvailabilityList[0].announceTimings;
        var maxAptsPerHour = docData.weeklyAvailabilityList[0].maxAptsPerHour;
        vm.availSlotsArray = [];
        var currentDaySlots = vm.availablityDaySlots[vm.currentTabUrl - 1];
        if (!currentDaySlots) {
          currentDaySlots = [];
        }

        angular.forEach(currentDaySlots, function (val, key) {
          val.headers = KioskService.getAvailabilitySlotsHeaders(val.availabilityStartSlot, val.availabilityEndTimeSlot, maxAptsPerHour);
          if (!docData.availSlotsArray) {
            docData.availSlotsArray = [];
          }
          docData.availSlotsArray.push(val);
        });
      }
    }

    function reloadTheData() {

      var tempDay = "";
      if (vm.newDate != '') {
        tempDay = new Date(vm.newDate.getTime());
      } else {
        tempDay = new Date();
      }
      var tabYears = [];

      vm.days[0] = tempDay.getDate() + '/' + (tempDay.getMonth() + 1);
      vm.startWeekDay = tempDay.getDay();
      tabYears[0] = tempDay.getFullYear();
      tempDay.setDate(tempDay.getDate() + 1);

      vm.days[1] = tempDay.getDate() + '/' + (tempDay.getMonth() + 1);
      tabYears[1] = tempDay.getFullYear();
      tempDay.setDate(tempDay.getDate() + 1);

      vm.days[2] = tempDay.getDate() + '/' + (tempDay.getMonth() + 1);
      tabYears[2] = tempDay.getFullYear();

      KioskService.setLastTabDate(tempDay);

      vm.currentDate = vm.days[vm.currentTabUrl - 1] + '/' + tabYears[vm.currentTabUrl - 1];
      var dateArr = vm.currentDate.split('/');
      vm.dateHeading = new Date(dateArr[2], dateArr[1] - 1, dateArr[0]);

      vm.currentDate = vm.days[vm.currentTabUrl - 1] + '/' + tabYears[vm.currentTabUrl - 1];
      vm.enableCaseIDSelection = false;

      if (KioskService.getDoctorSchedulesObj() && KioskService.getDoctorSchedulesObj().data.doctorInfoList.length > 0) {
        vm.announceTimings = KioskService.getDoctorSchedulesObj().data.doctorInfoList[0].weeklyAvailabilityList[0].announceTimings;
        vm.phoneNumber = KioskService.getDoctorSchedulesObj().data.doctorInfoList[0].contactNum;
        vm.availablityDaySlots = KioskService.getDoctorSchedulesObj().data.doctorInfoList[0].weeklyAvailabilityList[0].daySlots;
        var maxAptsPerHour = KioskService.getDoctorSchedulesObj().data.doctorInfoList[0].weeklyAvailabilityList[0].maxAptsPerHour;
        vm.enableCaseIDSelection = KioskService.getDoctorSchedulesObj().data.doctorInfoList[0].weeklyAvailabilityList[0].locationInfo.enableCaseIDSelection;
        vm.listOfVisitTypes = KioskService.getDoctorSchedulesObj().data.doctorInfoList[0].weeklyAvailabilityList[0].visitTypes;

        // remove visit types for online, video and for whom public access disabled.
        var firstTimeVisit = null;
        var types = [];
        angular.forEach(vm.listOfVisitTypes, function (val, key) {
          if (val.consultationType != "Online Consultation" && val.consultationType != "Video Consultation" && val.isEnabledForPublicAccess) {
            //vm.listOfVisitTypes.splice(key, 1);
            types.push(val);
            if (val.aptTypeName.toLowerCase().includes("first")) {
              // if there is any visit type with first in it then we will make that get selected by default.
              firstTimeVisit = val;
            }
          }

        });
        vm.listOfVisitTypes = types;
        // if any
        if (firstTimeVisit) {
          vm.patient.visitType = firstTimeVisit;
        } else {
          vm.patient.visitType = vm.listOfVisitTypes[0];
        }


        vm.availSlotsArray = [];
        var currentDaySlots = vm.availablityDaySlots[vm.currentTabUrl - 1];
        if (!currentDaySlots) {
          currentDaySlots = [];
        }

        angular.forEach(currentDaySlots, function (val, key) {
          var slotHeaderArray = [];
          var aptType = '';

          if (!val.aptTypeName) {
            aptType = '';
          } else {
            aptType = val.econsultAppointmentType.aptTypeName;
          }

          // remove this

          angular.forEach(val.slots, function (slotVal, slotKey) {
              slotHeaderArray.push(KioskService.getAvailabilitySlots(slotVal.timeSlot, maxAptsPerHour))
         });

          val.slotLabelList = slotHeaderArray;

          if (val.slotLabelList == null || val.slotLabelList.length == 0) {
            if (val.overBookingAllowed && val.isAtLeastOneSlotisBooked) {
              val.availabilityMessage = KioskService.getAvailabilitySlots(val.availabilityEndTimeSlot, maxAptsPerHour);
            } else if (val.callLaterToBook) {
              var todayTemp = new Date();
              todayTemp.setHours(0);
              todayTemp.setMinutes(0);
              todayTemp.setSeconds(0);
              todayTemp.setMilliseconds(0);
              try {
                var finalVal = todayTemp.getTime() + (val.availabilityStartSlot * (60 / maxAptsPerHour) * 1000) - (val.advBookingHour * 60 * 60 * 1000);
                val.availabilityMessage = 'Booking starts from' + finalVal.toLocaleDateString() + finalVal.toLocaleTimeString();
              } catch (e) {
                console.log('Error', 'Error while getting the indexed data.');
              }
            } else if (val.assistantDoctorAvailable) {
              val.availabilityMessage = 'Asst. Doctor available';
            } else if (val.atLeastOneSlotisBooked) {
              val.availabilityMessage = 'Appointments are full';
            } else {
              val.availabilityMessage = 'Sorry. Doctor not available at this time';
            }
          } else if (val.slotLabelList.length != null && val.slotLabelList.length > 0) {
            //Advance booking slots
            var todayTemp2 = new Date();
            todayTemp2.setHours(0);
            todayTemp2.setMinutes(0);
            todayTemp2.setSeconds(0);
            todayTemp2.setMilliseconds(0);
            var currentDayArr = vm.currentDate.split('/');
            var curDate_12am_ms = new Date(currentDayArr[2], currentDayArr[1] - 1, currentDayArr[0]).getTime();
            var now_12_am_ms = todayTemp2.getTime();
            var allowedAdvBookingDays = KioskService.getDoctorSchedulesObj().data.doctorInfoList[0].weeklyAvailabilityList[0].allowedAdvBookingDays;
            var adv_booking_ms = (allowedAdvBookingDays * 24 * 60 * 60 * 1000);
            var limit = now_12_am_ms + adv_booking_ms;
            var isAdvBookingValid = ( curDate_12am_ms < limit ) && (allowedAdvBookingDays != 0);
            var bookingStartDate = new Date((curDate_12am_ms - adv_booking_ms) + 24 * 60 * 60 * 1000);

            if (!isAdvBookingValid) {
              //show message : “Booking starts from <bookingstartDate > “
              val.isAdvBookingValid = !isAdvBookingValid;
              val.advBookingStartDate = bookingStartDate;
              // console.log("Booking starts from", val.isAdvBookingValid);
            }
          } else {
            val.availabilityMessage = 'Debug : No Data';
          }
          // prashant: use availabilityEndTimeSlotOrig instead of availabilityEndTimeSlot
          val.headers = KioskService.getAvailabilitySlotsHeaders(val.availabilityStartSlot, val.availabilityEndTimeSlotOrig, maxAptsPerHour);
          val.aptType = aptType;

          vm.availSlotsArray.push(val);
        });
      }
    }

    if (vm.entity) {
      getListOfLocations();
    }

    function getDdMMyyyy(d) {
      var day = d.getDate();
      var month = d.getMonth();
      month = month + 1;
      if (("" + day).length == 1)
        day = '0' + day;
      if (("" + month).length == 1)
        month = '0' + month;
      return day + "/" + month + "/" + d.getFullYear();
    }

    var getTimeForSlot = function (esb, maxApts) {
      var numMins = esb.timeSlot * (60 / maxApts);
      var now = new Date(vm.selectedDate);
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);

      now.setTime((now.getTime() + numMins * 60 * 1000));
      return now;
    };

    function createDPEvent(patient, selectedVisitType) {
      var selectedSlotObj = KioskService.getSelectedSlot();
      var dpEvent = {};
      var maxAptsPerHour = KioskService.getDoctorSchedulesObj().data.doctorInfoList[0].weeklyAvailabilityList[0].maxAptsPerHour;

      dpEvent.patientName = patient.name;
      dpEvent.patientContactNumber = patient.contactNumber;
      dpEvent.patientOrigNumber = patient.patientOrigNumber;
      dpEvent.patientEmailId = patient.email;
      dpEvent.startTime = new Date(getTimeForSlot(selectedSlotObj, maxAptsPerHour)).getTime();
      dpEvent.ddmmyyyy = getDdMMyyyy(new Date(dpEvent.startTime)).replace(new RegExp('/', 'g'), "");
      dpEvent.userIdOrServiceName = patient.visitType.userId;
      dpEvent.doctor = true;
      dpEvent.timeSlot = selectedSlotObj.timeSlot;
      dpEvent.daySlot = selectedSlotObj.daySlot;
      dpEvent.sendEmailNotification = true;
      dpEvent.sendSmsNotification = true;
      dpEvent.standardReminderEnabled = false;
      dpEvent.standardReminderMinutes = 45;
      dpEvent.aptTypeName = patient.visitType.aptTypeName;
      dpEvent.details = patient.reason;
      dpEvent.numberOfTimeSlots = angular.fromJson(patient.visitType).numberOfTimeSlots;
      dpEvent.bookedTimeEvent = true;
      dpEvent.hospitalId = (selectedVisitType.hospitalId) ? selectedVisitType.hospitalId : null;
      dpEvent.patientBookedChannel = "WEB";
      dpEvent.newPatient = (patient.newPatient == 'true');
      dpEvent.international = (vm.patient.international == 'true');
      return dpEvent;
    }

    function bookWithPayment(patient) {

    }

    function bookAnAppointment(patient) {
      vm.patientData = patient;
      if (typeof patient.visitType === "string") {
        patient.visitType = angular.fromJson(patient.visitType);
      }
      var wholeObj = createDPEvent(patient, patient.visitType.aptTypeName);
      var docSchedules = KioskService.getDoctorSchedulesObj().data;
      $scope.bookApmtApiCall = true;
      var locationInfo = docSchedules.doctorInfoList[0].weeklyAvailabilityList[0].locationInfo;
      $http.post(urls.apiUrl + '?request=AddEventAction', {
        event: wholeObj,
        entityId: locationInfo.entityId,
        enableMultipleApts: locationInfo.enableMultipleApts,
        verificationEnabled: vm.patient.patientID == undefined ||  vm.patient.patientID==null ,
        userUtcOffset: -(new Date().getTimezoneOffset())
      }).then(function (response) {
        if (response.data.result) {
          handleAddAptConfirm(response.data.bookingStatus, response.data);
        } else {
          handleAptAddError(response.data.errorCode);
        }
      }, function (error) {
        console.log(error);
      });
    }

    var handleAddAptConfirm = function (bookingStatus, responseData) {
      if (bookingStatus == 'confirmed') {
        swal("Your appointment booking is successful! Please check your mail for more details.");
        resetToFirstStep();
      } else if (bookingStatus == 'confirmed') {
        swal("Booking Successful! Please check your mail for more details.");
      } else if (bookingStatus == 'reservedPendingPayment') {
        //swal("Booking reserved, will be confirmed on completion of payment.");
        vm.paymentData = responseData;
        showPaymentPage(responseData);
        //payAmount();
      } else if (bookingStatus == 'reservedPendingVerification' || bookingStatus == 'reservedPendingVerificationEmail') {
        //swal("Booking reserved, will be confirmed soon.");
        verifyOtp(responseData,"Enter Verfication Code");
      } else {
        swal("Error while booking the appointment. Please try again.");
      }
    };

    var handleAptAddError = function (errorCode) {
      if (errorCode === 'timeSlotsInSufficient' || errorCode === 'timeSlotsInSufficient') {
        swal("Sorry, all the appointment slots seem to be taken, Please try an alternate time.");
      } else if (errorCode === 'timeSlotUnavailable' || errorCode === 'timeSlotUnavailable') {
        swal("Sorry, the appointment slot you are trying to book is not available.  Please select an alternate time.");
      } else if (errorCode === 'appointmentAlreadyBooked' || errorCode === 'appointmentAlreadyBooked') {
        swal("You have already scheduled an appointment for this patient.");
      } else {
        swal("Error creating the request. Please try again.");
      }
    };

    vm.cancelApt = function() {

      swal({
        title: 'Are you sure?',
        text: "You are about to cancel this appointment!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Cancel Appointment',
        cancelButtonText: 'No, do not'
      }).then(function () {
        $http
          .post(urls.apiUrl + '?request=DeleteEventAction', {
            aIdList: [vm.aptCode]
          })
          .then(function (response) {
            if (response.data.result) {
              swal("Your appointment has been successfully cancelled.");
              vm.aptCode = null;
              vm.cancelEnabled = false;
            }
          }, function (error) {
            console.log(error);
          });

      });


    };

    var verifyOtp = function (respData, t) {
      //var t = retry? "Invalid OTP, Try again":"Enter OTP";
      swal({
        title: t,
        input: 'text',
        showCancelButton: true,
        cancelButtonText: 'Resend Code',
        inputValidator: function (value) {
          return new Promise(function (resolve, reject) {
            if (value) {
              resolve()
            } else {
              reject('You need to write something!')
            }
          })
        }
      }).then(function (otp) {
        var docSchedules = KioskService.getDoctorSchedulesObj().data;
        $scope.bookApmtApiCall = true;
        var locationInfo = docSchedules.doctorInfoList[0].weeklyAvailabilityList[0].locationInfo;

        $http
          .post(urls.apiUrl + '?request=ConfirmAppointmentAction', {
            otp: otp,
            aId: respData.aId,
            entityId: locationInfo.entityId
          })
          .then(function (response) {
            if (response.data.result) {
              swal("Your appointment is confirmed. Details of the appointment have been sent to you by SMS and Email!");
              resetToFirstStep();
            } else if (response.data.errorCode == "invalidAppointmentId") {
              //swal('OTP you entered is invalid');
              // retry
              verifyOtp(respData,"Invalid Code,Try again");
            }
          });
      }, function (dismiss) {
            if (dismiss === 'cancel') {
                  $http
              .post(urls.apiUrl + '?request=ConfirmAppointmentAction', {
                aId: respData.aId,
                resendOTP : true
              })
              .then(function (response) {
                if (response.data.result) {
                  verifyOtp(respData,"Code resent, try again");
                } else  {
                  swal("Sorry,Unable to resend Code!");
                }
              });
            }
       });
    };

    var showPaymentPage = function (responseData) {
      vm.paymentData = responseData;
      vm.payAmount();
    };
    // prashant: Added this to open video consultation booking.
    vm.openVideo = function () {
      window.location.assign("http://wello-care.appspot.com/ng/mmd/mmd-econsult.html?id=" + vm.selectedDoctor.uid + "&rt=vc");
    };


  }


})();

(function () {
  'use strict';

  angular.module('mmd.econsult', []);

})();

(function () {
  'use strict';

  angular.module('mmd.econsult')
    .controller('EconsultController', EconsultController);

  function EconsultController($scope, $rootScope, $state, $http, $filter, $sce, $log, urls) {
    var vm = this;
    vm.pvr = {};
    vm.attachmentInProgress = false;
    vm.freeEconsultExpired = false;
    //vm.requestSuccess = false;
    vm.linkInvalid = false;
    vm.requestSuccess = false;
    vm.entityId = null;
    vm.selectedVisitType = {};
    vm.selectedDoctorInfo = {};
    vm.selectedWeeklyAvailability = { locationInfo : { }};
    console.log("Record id is " + $state.params.rid);
    console.log("App id is " + $state.params.appid);
    console.log("Visit Type " + $state.params.vname);
    vm.selectedDate = new Date();
    vm.initialized = false;

    vm.getDoctorInfo = function() {
      // Load page with doctor ID (appid parameter)
      var appId = $state.params.appid;
      if(!appId) return;

      $http.post(urls.apiUrl + '?request=getDoctorInfo', {
        "requestType": "getDoctorInfo",
        "uId": parseInt(appId),
        "fetchCalendarInfo": false,
        "startRow": 0,
        "numRows": 1
      }).then(function(response) {
        vm.initialized = true;
        if(response.data && response.data.result && response.data.doctorInfoList && response.data.doctorInfoList.length > 0) {
          var doctorInfo = response.data.doctorInfoList[0];
          vm.selectedDoctorInfo = doctorInfo;

          if(doctorInfo.weeklyAvailabilityList && doctorInfo.weeklyAvailabilityList.length > 0) {
            vm.selectedWeeklyAvailability = doctorInfo.weeklyAvailabilityList[0];

            // Set up econsult visit types from the doctor's visit types
            var econsultVisitTypes = [];
            if(vm.selectedWeeklyAvailability.visitTypes) {
              angular.forEach(vm.selectedWeeklyAvailability.visitTypes, function(vt) {
                if(vt.consultationType === "Online Consultation" && vt.isEnabledForPublicAccess) {
                  econsultVisitTypes.push(vt);
                }
              });
            }
            vm.selectedWeeklyAvailability.econsultVisitTypes = econsultVisitTypes;

            // Initialize patient and pvr
            vm.pvr.patient = {};
            if(econsultVisitTypes.length > 0) {
              vm.pvr.patient.visitType = econsultVisitTypes[0];
            }
          }
        } else {
          vm.linkInvalid = true;
        }
      }, function(error) {
        vm.linkInvalid = true;
        vm.initialized = true;
      });
    };

    vm.getRecord = function () {
      // get the record, copy patients to pvr
      // set the record status to
      var mmdAction = {
        // TODO:Align on the request type.
        // TODO: Share the URL
        "requestType": "getPvrWithFollowUpCheck",
        "pvrKey":  $state.params.rid
      };

      $http.post(urls.apiUrl + "?request=getPvrWithFollowUpCheck", mmdAction).
            success(function(data) {
                vm.initialized = true;
                if(data.result && data.pvr!=null) {
                  if(data.errorCode!==null && data.errorCode == "econsultValidityExpired") {
                    vm.freeEconsultExpired = true;
                  }
                  vm.pvr.patient = data.pvr.patient;
                  vm.pvr.patient.name = (vm.pvr.patient.firstName + " " + vm.pvr.patient.lastName).trim();
                  vm.pvr.patient.lastName = null;

                  // Populate full doctor info from the response
                  if(data.doctorInfo) {
                    vm.selectedDoctorInfo = data.doctorInfo;
                  } else {
                    // Fallback to just setting the name
                    vm.selectedDoctorInfo.name = data.pvr.doctorName;
                  }

                  vm.selectedWeeklyAvailability.locationInfo = data.locationInfo;
                  vm.selectedWeeklyAvailability.econsultVisitTypes = data.econsultVisitTypes;
                  vm.pvr.patient.visitType = data.econsultVisitTypes[0];


                }else {
                  // may be invalid link
                  vm.linkInvalid = true;
                }
            }
      ).error(function(e){
        // Something wrong...
        vm.linkInvalid = true;
      });


    };

    // Check which parameter is provided and call appropriate function
    if($state.params.appid) {
      vm.getDoctorInfo();
    } else if($state.params.rid) {
      vm.getRecord();
    } else {
      vm.linkInvalid = true;
      vm.initialized = true;
    }


    $scope.$on('request-complete', function (event, args) {
      console.log("request complete");
      vm.requestSuccess = true;
    });

  }
})();

(function () {
  'use strict';

  angular.module('mmd.common', []);

})();

(function () {
  'use strict';

  angular.module('mmd.common')
    .service('CommonService', CommonService);

  function CommonService($http,$q,urls) {
    var isDoctor = false;
    var isClinic = false;
    var bookedChannel = "WEB";
    this.viewProfile = function(id) {
      return $http.post(urls.apiUrl + '?request=viewProfile&id=' + id);
    };
    this.getDateFormat = function(dateObj) {
      var formattedDate = '';
      var date = dateObj.getDate();
      var month = dateObj.getMonth() + 1;
      var year = dateObj.getFullYear();
      date = (date.toString().length == 1) ? ('0' + date) : date;
      month = (month.toString().length == 1) ? ('0' + month) : month;
      formattedDate = date + '/' + month + '/' + year;
      return formattedDate;
    };
    this.getTimeSlot = function(date,minsPerSlot) {
			      return Math.floor((date.getHours() * 60 + date.getMinutes())/minsPerSlot);
	  };
    //console(this.date);
    this.isToday = function(todayDate,calendarDate) {
      return (todayDate.getDate() == calendarDate.getDate()) && (todayDate.getDay() == calendarDate.getDay()
      && (todayDate.getFullYear() == calendarDate.getFullYear()));
    };
    this.getLocalTimeZone  = function () {
      return new Date().toString().match(/([A-Z]+[\+-][0-9]+)/)[1];
    };
    this.isClinicTimeZone  = function(locationInfo) {
      return locationInfo.timeZone==this.getLocalTimeZone();
    };
    this.isTimePastAvailability = function(serverTime,endSlot,minsPerSlot) {
      var currTimeSlot  = this.getTimeSlot(new Date(serverTime),minsPerSlot);
      return currTimeSlot > endSlot;
    };

    this.getBaseUrl = function() {
      /*var retUrl = "";
      var href = window.location.href;
      if(href.indexOf("firebaseapp")>-1) {
          retUrl = "http://mmdconnect.appspot.com";
          if(href.indexOf("wello-care")>-1) {
            retUrl = "http://wello-care.appspot.com";
          }
      }
      return retUrl;*/
      return urls.server;
    };

    this.getPaymentHost = function() {
      //return "https://mmdconnect.appspot.com";
      return urls.server;
    }
    this.setDoctorView = function(isDoctor) {
      this.isDoctor = isDoctor;
    }
    this.getDoctorView = function() {
      return this.isDoctor;
    }

    this.setClinicView = function(isClinic) {
      this.isClinic = isClinic;
    }
    this.getClinicView = function() {
      return this.isClinic;
    }
    this.setPatientBookedChannel = function(channel) {
      this.bookedChannel = channel;
    }
    this.getPatientBookedChannel = function() {
      return this.bookedChannel;
    }

    this.getHideProfile = function() {
      return this.hideProfile;
    }
    this.setHideInPerson = function(hide) {
      this.hideInPerson = hide;
    }

    this.getHideInPerson = function() {
      return this.hideInPerson;
    }
    this.setHideProfile = function(hidePro) {
       this.hideProfile = hidePro;
    }

    this.getMaxDays = function() {
      var maxDays = 7;
      if(window.innerWidth <= 800) {
        maxDays = 3;
      }
      return maxDays;
    }


  }

})();

(function () {
  'use strict';

  angular.module('mmd.common')
    .factory('CommonFactory', CommonFactory);

  function CommonFactory() {


  }

})();

(function () {
  'use strict';

  angular.module('mmd.common')
    .controller('CommonController', CommonController);

  function CommonController() {
    

  }

})();

(function () {
  'use strict';

  angular.module('mmd.common')
    .service('CountriesService', CountriesService);

  function CountriesService() {
    var countries = [{
      "name": "India",
      "dial_code": "+91",
      "code": "IN"
    },{
      "name": "Israel",
      "dial_code": "+972",
      "code": "IL"
    }, {
      "name": "Afghanistan",
      "dial_code": "+93",
      "code": "AF"
    }, {
      "name": "Albania",
      "dial_code": "+355",
      "code": "AL"
    }, {
      "name": "Algeria",
      "dial_code": "+213",
      "code": "DZ"
    }, {
      "name": "AmericanSamoa",
      "dial_code": "+1 684",
      "code": "AS"
    }, {
      "name": "Andorra",
      "dial_code": "+376",
      "code": "AD"
    }, {
      "name": "Angola",
      "dial_code": "+244",
      "code": "AO"
    }, {
      "name": "Anguilla",
      "dial_code": "+1 264",
      "code": "AI"
    }, {
      "name": "Antigua and Barbuda",
      "dial_code": "+1268",
      "code": "AG"
    }, {
      "name": "Argentina",
      "dial_code": "+54",
      "code": "AR"
    }, {
      "name": "Armenia",
      "dial_code": "+374",
      "code": "AM"
    }, {
      "name": "Aruba",
      "dial_code": "+297",
      "code": "AW"
    }, {
      "name": "Australia",
      "dial_code": "+61",
      "code": "AU"
    }, {
      "name": "Austria",
      "dial_code": "+43",
      "code": "AT"
    }, {
      "name": "Azerbaijan",
      "dial_code": "+994",
      "code": "AZ"
    }, {
      "name": "Bahamas",
      "dial_code": "+1 242",
      "code": "BS"
    }, {
      "name": "Bahrain",
      "dial_code": "+973",
      "code": "BH"
    }, {
      "name": "Bangladesh",
      "dial_code": "+880",
      "code": "BD"
    }, {
      "name": "Barbados",
      "dial_code": "+1 246",
      "code": "BB"
    }, {
      "name": "Belarus",
      "dial_code": "+375",
      "code": "BY"
    }, {
      "name": "Belgium",
      "dial_code": "+32",
      "code": "BE"
    }, {
      "name": "Belize",
      "dial_code": "+501",
      "code": "BZ"
    }, {
      "name": "Benin",
      "dial_code": "+229",
      "code": "BJ"
    }, {
      "name": "Bermuda",
      "dial_code": "+1 441",
      "code": "BM"
    }, {
      "name": "Bhutan",
      "dial_code": "+975",
      "code": "BT"
    }, {
      "name": "Bosnia and Herzegovina",
      "dial_code": "+387",
      "code": "BA"
    }, {
      "name": "Botswana",
      "dial_code": "+267",
      "code": "BW"
    }, {
      "name": "Brazil",
      "dial_code": "+55",
      "code": "BR"
    }, {
      "name": "British Indian Ocean Territory",
      "dial_code": "+246",
      "code": "IO"
    }, {
      "name": "Bulgaria",
      "dial_code": "+359",
      "code": "BG"
    }, {
      "name": "Burkina Faso",
      "dial_code": "+226",
      "code": "BF"
    }, {
      "name": "Burundi",
      "dial_code": "+257",
      "code": "BI"
    }, {
      "name": "Cambodia",
      "dial_code": "+855",
      "code": "KH"
    }, {
      "name": "Cameroon",
      "dial_code": "+237",
      "code": "CM"
    }, {
      "name": "Canada",
      "dial_code": "+1",
      "code": "CA"
    }, {
      "name": "Cape Verde",
      "dial_code": "+238",
      "code": "CV"
    }, {
      "name": "Cayman Islands",
      "dial_code": "+ 345",
      "code": "KY"
    }, {
      "name": "Central African Republic",
      "dial_code": "+236",
      "code": "CF"
    }, {
      "name": "Chad",
      "dial_code": "+235",
      "code": "TD"
    }, {
      "name": "Chile",
      "dial_code": "+56",
      "code": "CL"
    }, {
      "name": "China",
      "dial_code": "+86",
      "code": "CN"
    }, {
      "name": "Christmas Island",
      "dial_code": "+61",
      "code": "CX"
    }, {
      "name": "Colombia",
      "dial_code": "+57",
      "code": "CO"
    }, {
      "name": "Comoros",
      "dial_code": "+269",
      "code": "KM"
    }, {
      "name": "Congo",
      "dial_code": "+242",
      "code": "CG"
    }, {
      "name": "Cook Islands",
      "dial_code": "+682",
      "code": "CK"
    }, {
      "name": "Costa Rica",
      "dial_code": "+506",
      "code": "CR"
    }, {
      "name": "Croatia",
      "dial_code": "+385",
      "code": "HR"
    }, {
      "name": "Cuba",
      "dial_code": "+53",
      "code": "CU"
    }, {
      "name": "Cyprus",
      "dial_code": "+537",
      "code": "CY"
    }, {
      "name": "Czech Republic",
      "dial_code": "+420",
      "code": "CZ"
    }, {
      "name": "Denmark",
      "dial_code": "+45",
      "code": "DK"
    }, {
      "name": "Djibouti",
      "dial_code": "+253",
      "code": "DJ"
    }, {
      "name": "Dominica",
      "dial_code": "+1 767",
      "code": "DM"
    }, {
      "name": "Dominican Republic",
      "dial_code": "+1 849",
      "code": "DO"
    }, {
      "name": "Ecuador",
      "dial_code": "+593",
      "code": "EC"
    }, {
      "name": "Egypt",
      "dial_code": "+20",
      "code": "EG"
    }, {
      "name": "El Salvador",
      "dial_code": "+503",
      "code": "SV"
    }, {
      "name": "Equatorial Guinea",
      "dial_code": "+240",
      "code": "GQ"
    }, {
      "name": "Eritrea",
      "dial_code": "+291",
      "code": "ER"
    }, {
      "name": "Estonia",
      "dial_code": "+372",
      "code": "EE"
    }, {
      "name": "Ethiopia",
      "dial_code": "+251",
      "code": "ET"
    }, {
      "name": "Faroe Islands",
      "dial_code": "+298",
      "code": "FO"
    }, {
      "name": "Fiji",
      "dial_code": "+679",
      "code": "FJ"
    }, {
      "name": "Finland",
      "dial_code": "+358",
      "code": "FI"
    }, {
      "name": "France",
      "dial_code": "+33",
      "code": "FR"
    }, {
      "name": "French Guiana",
      "dial_code": "+594",
      "code": "GF"
    }, {
      "name": "French Polynesia",
      "dial_code": "+689",
      "code": "PF"
    }, {
      "name": "Gabon",
      "dial_code": "+241",
      "code": "GA"
    }, {
      "name": "Gambia",
      "dial_code": "+220",
      "code": "GM"
    }, {
      "name": "Georgia",
      "dial_code": "+995",
      "code": "GE"
    }, {
      "name": "Germany",
      "dial_code": "+49",
      "code": "DE"
    }, {
      "name": "Ghana",
      "dial_code": "+233",
      "code": "GH"
    }, {
      "name": "Gibraltar",
      "dial_code": "+350",
      "code": "GI"
    }, {
      "name": "Greece",
      "dial_code": "+30",
      "code": "GR"
    }, {
      "name": "Greenland",
      "dial_code": "+299",
      "code": "GL"
    }, {
      "name": "Grenada",
      "dial_code": "+1 473",
      "code": "GD"
    }, {
      "name": "Guadeloupe",
      "dial_code": "+590",
      "code": "GP"
    }, {
      "name": "Guam",
      "dial_code": "+1 671",
      "code": "GU"
    }, {
      "name": "Guatemala",
      "dial_code": "+502",
      "code": "GT"
    }, {
      "name": "Guinea",
      "dial_code": "+224",
      "code": "GN"
    }, {
      "name": "Guinea-Bissau",
      "dial_code": "+245",
      "code": "GW"
    }, {
      "name": "Guyana",
      "dial_code": "+595",
      "code": "GY"
    }, {
      "name": "Haiti",
      "dial_code": "+509",
      "code": "HT"
    }, {
      "name": "Honduras",
      "dial_code": "+504",
      "code": "HN"
    }, {
      "name": "Hungary",
      "dial_code": "+36",
      "code": "HU"
    }, {
      "name": "Iceland",
      "dial_code": "+354",
      "code": "IS"
    }, {
      "name": "Indonesia",
      "dial_code": "+62",
      "code": "ID"
    }, {
      "name": "Iraq",
      "dial_code": "+964",
      "code": "IQ"
    }, {
      "name": "Ireland",
      "dial_code": "+353",
      "code": "IE"
    }, {
      "name": "Israel",
      "dial_code": "+972",
      "code": "IL"
    }, {
      "name": "Italy",
      "dial_code": "+39",
      "code": "IT"
    }, {
      "name": "Jamaica",
      "dial_code": "+1 876",
      "code": "JM"
    }, {
      "name": "Japan",
      "dial_code": "+81",
      "code": "JP"
    }, {
      "name": "Jordan",
      "dial_code": "+962",
      "code": "JO"
    }, {
      "name": "Kazakhstan",
      "dial_code": "+7 7",
      "code": "KZ"
    }, {
      "name": "Kenya",
      "dial_code": "+254",
      "code": "KE"
    }, {
      "name": "Kiribati",
      "dial_code": "+686",
      "code": "KI"
    }, {
      "name": "Kuwait",
      "dial_code": "+965",
      "code": "KW"
    }, {
      "name": "Kyrgyzstan",
      "dial_code": "+996",
      "code": "KG"
    }, {
      "name": "Latvia",
      "dial_code": "+371",
      "code": "LV"
    }, {
      "name": "Lebanon",
      "dial_code": "+961",
      "code": "LB"
    }, {
      "name": "Lesotho",
      "dial_code": "+266",
      "code": "LS"
    }, {
      "name": "Liberia",
      "dial_code": "+231",
      "code": "LR"
    }, {
      "name": "Liechtenstein",
      "dial_code": "+423",
      "code": "LI"
    }, {
      "name": "Lithuania",
      "dial_code": "+370",
      "code": "LT"
    }, {
      "name": "Luxembourg",
      "dial_code": "+352",
      "code": "LU"
    }, {
      "name": "Madagascar",
      "dial_code": "+261",
      "code": "MG"
    }, {
      "name": "Malawi",
      "dial_code": "+265",
      "code": "MW"
    }, {
      "name": "Malaysia",
      "dial_code": "+60",
      "code": "MY"
    }, {
      "name": "Maldives",
      "dial_code": "+960",
      "code": "MV"
    }, {
      "name": "Mali",
      "dial_code": "+223",
      "code": "ML"
    }, {
      "name": "Malta",
      "dial_code": "+356",
      "code": "MT"
    }, {
      "name": "Marshall Islands",
      "dial_code": "+692",
      "code": "MH"
    }, {
      "name": "Martinique",
      "dial_code": "+596",
      "code": "MQ"
    }, {
      "name": "Mauritania",
      "dial_code": "+222",
      "code": "MR"
    }, {
      "name": "Mauritius",
      "dial_code": "+230",
      "code": "MU"
    }, {
      "name": "Mayotte",
      "dial_code": "+262",
      "code": "YT"
    }, {
      "name": "Mexico",
      "dial_code": "+52",
      "code": "MX"
    }, {
      "name": "Monaco",
      "dial_code": "+377",
      "code": "MC"
    }, {
      "name": "Mongolia",
      "dial_code": "+976",
      "code": "MN"
    }, {
      "name": "Montenegro",
      "dial_code": "+382",
      "code": "ME"
    }, {
      "name": "Montserrat",
      "dial_code": "+1664",
      "code": "MS"
    }, {
      "name": "Morocco",
      "dial_code": "+212",
      "code": "MA"
    }, {
      "name": "Myanmar",
      "dial_code": "+95",
      "code": "MM"
    }, {
      "name": "Namibia",
      "dial_code": "+264",
      "code": "NA"
    }, {
      "name": "Nauru",
      "dial_code": "+674",
      "code": "NR"
    }, {
      "name": "Nepal",
      "dial_code": "+977",
      "code": "NP"
    }, {
      "name": "Netherlands",
      "dial_code": "+31",
      "code": "NL"
    }, {
      "name": "Netherlands Antilles",
      "dial_code": "+599",
      "code": "AN"
    }, {
      "name": "New Caledonia",
      "dial_code": "+687",
      "code": "NC"
    }, {
      "name": "New Zealand",
      "dial_code": "+64",
      "code": "NZ"
    }, {
      "name": "Nicaragua",
      "dial_code": "+505",
      "code": "NI"
    }, {
      "name": "Niger",
      "dial_code": "+227",
      "code": "NE"
    }, {
      "name": "Nigeria",
      "dial_code": "+234",
      "code": "NG"
    }, {
      "name": "Niue",
      "dial_code": "+683",
      "code": "NU"
    }, {
      "name": "Norfolk Island",
      "dial_code": "+672",
      "code": "NF"
    }, {
      "name": "Northern Mariana Islands",
      "dial_code": "+1 670",
      "code": "MP"
    }, {
      "name": "Norway",
      "dial_code": "+47",
      "code": "NO"
    }, {
      "name": "Oman",
      "dial_code": "+968",
      "code": "OM"
    }, {
      "name": "Pakistan",
      "dial_code": "+92",
      "code": "PK"
    }, {
      "name": "Palau",
      "dial_code": "+680",
      "code": "PW"
    }, {
      "name": "Panama",
      "dial_code": "+507",
      "code": "PA"
    }, {
      "name": "Papua New Guinea",
      "dial_code": "+675",
      "code": "PG"
    }, {
      "name": "Paraguay",
      "dial_code": "+595",
      "code": "PY"
    }, {
      "name": "Peru",
      "dial_code": "+51",
      "code": "PE"
    }, {
      "name": "Philippines",
      "dial_code": "+63",
      "code": "PH"
    }, {
      "name": "Poland",
      "dial_code": "+48",
      "code": "PL"
    }, {
      "name": "Portugal",
      "dial_code": "+351",
      "code": "PT"
    }, {
      "name": "Puerto Rico",
      "dial_code": "+1 939",
      "code": "PR"
    }, {
      "name": "Qatar",
      "dial_code": "+974",
      "code": "QA"
    }, {
      "name": "Romania",
      "dial_code": "+40",
      "code": "RO"
    }, {
      "name": "Rwanda",
      "dial_code": "+250",
      "code": "RW"
    }, {
      "name": "Samoa",
      "dial_code": "+685",
      "code": "WS"
    }, {
      "name": "San Marino",
      "dial_code": "+378",
      "code": "SM"
    }, {
      "name": "Saudi Arabia",
      "dial_code": "+966",
      "code": "SA"
    }, {
      "name": "Senegal",
      "dial_code": "+221",
      "code": "SN"
    }, {
      "name": "Serbia",
      "dial_code": "+381",
      "code": "RS"
    }, {
      "name": "Seychelles",
      "dial_code": "+248",
      "code": "SC"
    }, {
      "name": "Sierra Leone",
      "dial_code": "+232",
      "code": "SL"
    }, {
      "name": "Singapore",
      "dial_code": "+65",
      "code": "SG"
    }, {
      "name": "Slovakia",
      "dial_code": "+421",
      "code": "SK"
    }, {
      "name": "Slovenia",
      "dial_code": "+386",
      "code": "SI"
    }, {
      "name": "Solomon Islands",
      "dial_code": "+677",
      "code": "SB"
    }, {
      "name": "South Africa",
      "dial_code": "+27",
      "code": "ZA"
    }, {
      "name": "South Georgia and the South Sandwich Islands",
      "dial_code": "+500",
      "code": "GS"
    }, {
      "name": "Spain",
      "dial_code": "+34",
      "code": "ES"
    }, {
      "name": "Sri Lanka",
      "dial_code": "+94",
      "code": "LK"
    }, {
      "name": "Sudan",
      "dial_code": "+249",
      "code": "SD"
    }, {
      "name": "Suriname",
      "dial_code": "+597",
      "code": "SR"
    }, {
      "name": "Swaziland",
      "dial_code": "+268",
      "code": "SZ"
    }, {
      "name": "Sweden",
      "dial_code": "+46",
      "code": "SE"
    }, {
      "name": "Switzerland",
      "dial_code": "+41",
      "code": "CH"
    }, {
      "name": "Tajikistan",
      "dial_code": "+992",
      "code": "TJ"
    }, {
      "name": "Thailand",
      "dial_code": "+66",
      "code": "TH"
    }, {
      "name": "Togo",
      "dial_code": "+228",
      "code": "TG"
    }, {
      "name": "Tokelau",
      "dial_code": "+690",
      "code": "TK"
    }, {
      "name": "Tonga",
      "dial_code": "+676",
      "code": "TO"
    }, {
      "name": "Trinidad and Tobago",
      "dial_code": "+1 868",
      "code": "TT"
    }, {
      "name": "Tunisia",
      "dial_code": "+216",
      "code": "TN"
    }, {
      "name": "Turkey",
      "dial_code": "+90",
      "code": "TR"
    }, {
      "name": "Turkmenistan",
      "dial_code": "+993",
      "code": "TM"
    }, {
      "name": "Turks and Caicos Islands",
      "dial_code": "+1 649",
      "code": "TC"
    }, {
      "name": "Tuvalu",
      "dial_code": "+688",
      "code": "TV"
    }, {
      "name": "Uganda",
      "dial_code": "+256",
      "code": "UG"
    }, {
      "name": "Ukraine",
      "dial_code": "+380",
      "code": "UA"
    }, {
      "name": "United Arab Emirates",
      "dial_code": "+971",
      "code": "AE"
    }, {
      "name": "United Kingdom",
      "dial_code": "+44",
      "code": "GB"
    }, {
      "name": "United States",
      "dial_code": "+1",
      "code": "US"
    }, {
      "name": "Uruguay",
      "dial_code": "+598",
      "code": "UY"
    }, {
      "name": "Uzbekistan",
      "dial_code": "+998",
      "code": "UZ"
    }, {
      "name": "Vanuatu",
      "dial_code": "+678",
      "code": "VU"
    }, {
      "name": "Wallis and Futuna",
      "dial_code": "+681",
      "code": "WF"
    }, {
      "name": "Yemen",
      "dial_code": "+967",
      "code": "YE"
    }, {
      "name": "Zambia",
      "dial_code": "+260",
      "code": "ZM"
    }, {
      "name": "Zimbabwe",
      "dial_code": "+263",
      "code": "ZW"
    }, {
      "name": "Bolivia, Plurinational State of",
      "dial_code": "+591",
      "code": "BO"
    }, {
      "name": "Brunei Darussalam",
      "dial_code": "+673",
      "code": "BN"
    }, {
      "name": "Cocos (Keeling) Islands",
      "dial_code": "+61",
      "code": "CC"
    }, {
      "name": "Congo, The Democratic Republic of the",
      "dial_code": "+243",
      "code": "CD"
    }, {
      "name": "Cote d'Ivoire",
      "dial_code": "+225",
      "code": "CI"
    }, {
      "name": "Falkland Islands (Malvinas)",
      "dial_code": "+500",
      "code": "FK"
    }, {
      "name": "Guernsey",
      "dial_code": "+44",
      "code": "GG"
    }, {
      "name": "Holy See (Vatican City State)",
      "dial_code": "+379",
      "code": "VA"
    }, {
      "name": "Hong Kong",
      "dial_code": "+852",
      "code": "HK"
    }, {
      "name": "Iran, Islamic Republic of",
      "dial_code": "+98",
      "code": "IR"
    }, {
      "name": "Isle of Man",
      "dial_code": "+44",
      "code": "IM"
    }, {
      "name": "Jersey",
      "dial_code": "+44",
      "code": "JE"
    }, {
      "name": "Korea, Democratic People's Republic of",
      "dial_code": "+850",
      "code": "KP"
    }, {
      "name": "Korea, Republic of",
      "dial_code": "+82",
      "code": "KR"
    }, {
      "name": "Lao People's Democratic Republic",
      "dial_code": "+856",
      "code": "LA"
    }, {
      "name": "Libyan Arab Jamahiriya",
      "dial_code": "+218",
      "code": "LY"
    }, {
      "name": "Macao",
      "dial_code": "+853",
      "code": "MO"
    }, {
      "name": "Macedonia, The Former Yugoslav Republic of",
      "dial_code": "+389",
      "code": "MK"
    }, {
      "name": "Micronesia, Federated States of",
      "dial_code": "+691",
      "code": "FM"
    }, {
      "name": "Moldova, Republic of",
      "dial_code": "+373",
      "code": "MD"
    }, {
      "name": "Mozambique",
      "dial_code": "+258",
      "code": "MZ"
    }, {
      "name": "Palestinian Territory, Occupied",
      "dial_code": "+970",
      "code": "PS"
    }, {
      "name": "Pitcairn",
      "dial_code": "+872",
      "code": "PN"
    }, {
      "name": "Réunion",
      "dial_code": "+262",
      "code": "RE"
    }, {
      "name": "Russia",
      "dial_code": "+7",
      "code": "RU"
    }, {
      "name": "Saint Barthélemy",
      "dial_code": "+590",
      "code": "BL"
    }, {
      "name": "Saint Helena, Ascension and Tristan Da Cunha",
      "dial_code": "+290",
      "code": "SH"
    }, {
      "name": "Saint Kitts and Nevis",
      "dial_code": "+1 869",
      "code": "KN"
    }, {
      "name": "Saint Lucia",
      "dial_code": "+1 758",
      "code": "LC"
    }, {
      "name": "Saint Martin",
      "dial_code": "+590",
      "code": "MF"
    }, {
      "name": "Saint Pierre and Miquelon",
      "dial_code": "+508",
      "code": "PM"
    }, {
      "name": "Saint Vincent and the Grenadines",
      "dial_code": "+1 784",
      "code": "VC"
    }, {
      "name": "Sao Tome and Principe",
      "dial_code": "+239",
      "code": "ST"
    }, {
      "name": "Somalia",
      "dial_code": "+252",
      "code": "SO"
    }, {
      "name": "Svalbard and Jan Mayen",
      "dial_code": "+47",
      "code": "SJ"
    }, {
      "name": "Syrian Arab Republic",
      "dial_code": "+963",
      "code": "SY"
    }, {
      "name": "Taiwan, Province of China",
      "dial_code": "+886",
      "code": "TW"
    }, {
      "name": "Tanzania, United Republic of",
      "dial_code": "+255",
      "code": "TZ"
    }, {
      "name": "Timor-Leste",
      "dial_code": "+670",
      "code": "TL"
    }, {
      "name": "Venezuela, Bolivarian Republic of",
      "dial_code": "+58",
      "code": "VE"
    }, {
      "name": "Viet Nam",
      "dial_code": "+84",
      "code": "VN"
    }, {
      "name": "Virgin Islands, British",
      "dial_code": "+1 284",
      "code": "VG"
    }, {
      "name": "Virgin Islands, U.S.",
      "dial_code": "+1 340",
      "code": "VI"
    }];

    this.getCountries = function (){
      return countries;
    }
  }
})();

(function () {
  'use strict';

  angular.module('mmd.clinic')
    .service('ClinicService', ClinicService);

  function ClinicService() {

    this.appointmentDetails = {};
    this.selectedDate = '';
    this.initialDate = '';
    this.lastTabDate = '';
    this.doctorSchedulesObj = {};
    this.selectedSlot = {};
    this.doctorDetails = {};
    this.doctorUrl = null;

    this.setDoctorUrl = function(url) {
      this.doctorUrl = url;
    };
    this.setAppointmentDetails = function (apmt) {
      this.appointmentDetails = apmt;
    };
    this.getAppointmentDetails = function () {
      return this.appointmentDetails;
    };

    this.setRecentTabSelected = function (tab) {
      this.recentTab = tab;
    };
    this.getRecentTabSelected = function () {
      return this.recentTab;
    };

    this.setInitialDateString = function (date) {
      var x = date.split('/');
      this.initialDate = new Date(x[2], x[1], x[0]);
    };
    this.setInitialDate = function (date) {
      this.initialDate = date;
    };
    this.getInitialDate = function () {
      return this.initialDate;
    };
    this.setSelectedDate = function (date) {
      this.selectedDate = date;
    };
    this.getSelectedDate = function () {
      return this.selectedDate;
    };
    this.setLastTabDate = function (date) {
      this.lastTabDate = date;
    };
    this.getLastTabDate = function () {
      return this.lastTabDate;
    };

    this.setSelectedDoctorDetails = function (doctorDetails) {
      this.doctorDetails = doctorDetails;
    };
    this.getSelectedDoctorDetails = function () {
      return this.doctorDetails;
    };

    this.setDoctorSchedulesObj = function (obj) {
      this.doctorSchedulesObj = obj;
    };
    this.getDoctorSchedulesObj = function () {
      return this.doctorSchedulesObj;
    };

    this.getMaxDays = function() {

    }

    this.getSlotString = function (val, maxAppointments) {
      if (!val && !maxAppointments) return "";

      var numberOfMinutes = val * (60 / maxAppointments);
      var nowDate = new Date();
      nowDate.setHours(0);
      nowDate.setMinutes(0);
      nowDate.setSeconds(0);
      nowDate.setMilliseconds(0);
      nowDate.setTime((nowDate.getTime() + numberOfMinutes * 60 * 1000));

      var totalHours = nowDate.getHours();
      var meridian = "AM";
      var hours = 0;

      if (totalHours < 12) {
        hours = totalHours;
        meridian = "AM";
      } else {
        meridian = "PM";
        if (totalHours !== 12) {
          hours = totalHours - 12;
        } else {
          hours = totalHours;
        }
      }
      var minutes = nowDate.getMinutes();
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      return hours + ":" + minutes + " " + meridian;
    };

    this.getAvailabilitySlotsHeaders = function (start, end, maxAppointments) {
      return this.getSlotString(start, maxAppointments) + " - " + this.getSlotString(end, maxAppointments);
    };

    this.getAvailabilitySlots = function (start, maxAppointments) {
      return this.getSlotString(start, maxAppointments);
    };

    this.setSelectedSlot = function (obj) {
      this.selectedSlot = obj;
    };
    this.getSelectedSlot = function () {
      return this.selectedSlot;
    };

  }

})();

(function () {
  'use strict';

  angular.module('mmd.clinic')
    .factory('ClinicFactory', ClinicFactory);

  function ClinicFactory() {

    var datesFact = {};

    datesFact.getDatesObj = function (ipDate) {
      if (typeof(ipDate) == 'object') {
        var datesObj = {
          startDate: '',
          endDate: ''
        };
        var startDate = new Date(ipDate.getFullYear(), ipDate.getMonth() + 1, ipDate.getDate());
        datesObj.startDate = startDate.getDate() + '/' + startDate.getMonth() + '/' + startDate.getFullYear();
        var endDate = angular.copy(startDate.setDate(startDate.getDate() + 3));
        endDate = new Date(endDate);
        datesObj.endDate = endDate.getDate() + '/' + endDate.getMonth() + '/' + endDate.getFullYear();

        return datesObj;
      } else {
        return 'error';
      }
    };

    datesFact.getWeekName = function (val) {
      var weeks = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      return weeks[val];
    };

    return datesFact;

  }

})();

// Show Video slots

(function () {
  'use strict';

  function ClinicController($scope, $rootScope, $state, $http, $filter, $sce, $log, urls, ClinicService, ClinicFactory,CommonService,$timeout) {

    var vm = this;
    vm.hidePoweredBy = false;
    console.log(" Inside clinic controller")
    $rootScope.showLoader = true;
    vm.baseUrl = CommonService.getBaseUrl();
    vm.redirectUrl = null;

    // stepper control
    vm.steps = ['Select the Department', 'Select the Doctor/Time', 'Book Appointment/Service'];
    vm.step = 0;
    vm.stepperControl = {};
    vm.stepStack = [];

    // list of all departments
    vm.departmentsList = [];
    vm.selectedDepartment = '';

    // state for step 0
    vm.selectedDoctorSuggestion = '';
    vm.selectedDoctorItemSuggestion = {};

    vm.selectedDoctorInfo = {};
    //vm.docSelectedOnce = false;

    // hides stepper when not applicable.
    vm.isEconsult = false;
    vm.patient = {};
    vm.doctorListSkipped = false;
    vm.entity = $state.params.entity;
    console.log($state.params);
    vm.doctor = $state.params.doctor;
    vm.uid = $state.params.uid;
    if(vm.uid){
      vm.doctor = "null";
    }

    vm.hideHeader = false;
    vm.hideHospitalName = false;
    vm.isQrCode = false;
    vm.gaId = "UA-26200577-1";
    var baseUri = document.baseURI;
    if (baseUri != null && baseUri.indexOf("gaId=") > -1) {
      vm.gaId = baseUri.split("gaId=")[1].split("&")[0];
      console.log("baseUri contains gaId= , hence populating gaId as " + vm.gaId);
    }
    window.ga('create',vm.gaId)
    window.ga('send', 'pageview', { page: "Home_Page" });
    if($state.params.hideHeader) {
      vm.hideHeader = ($state.params.hideHeader === "true");
    }
    if($state.params.qrCode) {
      vm.isQrCode = ($state.params.qrCode === "true");
    }
    if($state.params.hideProfile) {
      vm.hideProfile = ($state.params.hideProfile === "true");
    }else {
      vm.hideProfile = false;
    }

    CommonService.setHideInPerson(false);
    if($state.params.hideInPerson) {
      CommonService.setHideInPerson($state.params.hideInPerson == "true");
    }

    if($state.params.hideHospitalName) {
      vm.hideHospitalName = ($state.params.hideHospitalName === "true");
    }
  /*  if(baseUri != null && baseUri.indexOf("eid=") > -1){
      vm.entityId = baseUri.split("eid=")[1].split("&")[0];
    }*/
     if($state.params.eid) {
      vm.entityId = parseInt($state.params.eid);
      if (vm.doctor){
        // Doctor view, don't set clinicView as true
      }else{
        CommonService.setClinicView(true);
      }
    }

    vm.mmd = false;
    if($state.params.city && $state.params.city.length>0) {
      vm.city = $state.params.city;
      vm.mmd = true;
    }
    if($state.params.area && $state.params.area.length>0) {
      vm.area = $state.params.area;
      if(vm.area==="any") {
        vm.area = null;
      }
      vm.mmd = true;
    }
    if($state.params.speciality && $state.params.speciality.length>0) {
      vm.selectedDepartment = $state.params.speciality;
      if(vm.selectedDepartment==="any") {
        vm.selectedDepartment = null;
      }
      vm.mmd = true;
    }

    if(vm.mmd) {
      CommonService.setPatientBookedChannel("MMD");
    }else {
      if(vm.isQrCode) {
        CommonService.setPatientBookedChannel("QR Code");
      }else {
        if(vm.entityId || $state.params.entity){
          CommonService.setPatientBookedChannel("WEB");
        }else {
          if(vm.hideHeader || vm.hideProfile || vm.hideHospitalName) {
            // some custom URL so probably clinic specific
            CommonService.setPatientBookedChannel("WEB");
          }else {
            // MMD or SEO
            CommonService.setPatientBookedChannel("MMD");
          }
        }
      }
      
    }



    vm.cancelEnabled = false;
    vm.aptCode = null;
    vm.selectedWeeklyAvailability = {};
    // entity name is used in top level page inside title
    $rootScope.entityName = $state.params.entity;
    var today = new Date();
    vm.selectedDate = new Date();

    //var count = 0;
    vm.allowDepartmentSelection = false;
    vm.pvr = {};
    var suggestionInProgress = false;
    var lastQueryString = "";
    var queryCache = {};

    //---------------
    // WATCHES
    $scope.$watch('vm.entity', function (val, oldVal) {
      if (val != oldVal) {
        loginEntity();
        console.log("within watch1");
      }
    });

    $scope.$on('slot-selected', function (event, args) {
      //vm.slotSelected(args.slot,args.label);
      vm.isEconsult = false;
      vm.selectedDoctorInfo = args.doc;
      vm.selectedWeeklyAvailability = args.weeklyAvailability;
      vm.selectedSlot = args.slot;
      vm.selectedDate = args.date;
      vm.videoSlotsOnly = args.videoSlotsOnly;

      vm.nextStep();
    });
    $scope.$on('request-econsult', function (event, args) {
      vm.isEconsult = true;
      vm.selectedDoctorInfo = args.doc;
      vm.selectedWeeklyAvailability = args.weeklyAvailability;
      vm.selectedDate = args.date;
      vm.selectedSlot = null;
      vm.nextStep(null, args.doc,true);
    });
    $scope.$on('submit-service-request', function (event, args) {
      vm.nextStep(vm.patient);
    });
    $scope.$on('request-complete', function (event, args) {
      vm.patient={};
      vm.pvr = {};
      if(vm.redirectUrl) {
        window.top.location.replace(vm.redirectUrl);
      }else {
        resetToFirstStep();
      }

    });


    $scope.$watch('vm.selectedDepartment', function (newVal, oldVal) {
      if (newVal) {

        for (var i = 0; i < vm.departmentsList.length; i++) {
          if(vm.departmentsList[i].toUpperCase()==newVal.toUpperCase()) {
            vm.nextStep();
            break;
            console.log("within watch2");
          }
      }
    }
    });


    vm.onDoctorSuggestionSelected = function(item,model,label) {
      vm.selectedDoctorItemSuggestion.id = item.id;
      vm.doctorListSkipped = true;
      vm.nextStep();
    };

    vm.prevStep = function () {
      //vm.step -= 1;
      var last = vm.step;
      vm.step = vm.stepStack.pop();
      if(vm.stepperControl && vm.stepperControl.prevStep) {
        vm.stepperControl.prevStep();
      }

      if(last == 3 && vm.isEconsult) {
        vm.isEconsult = false;
        vm.prevStep();
      }

      if(vm.patient!=null){
        vm.patient.visitType = null;
      }

      if(last == 1) {
      vm.selectedDepartment = "";
      vm.selectedDoctorSuggestion = "";
      vm.selectedDoctorItemSuggestion = {};
      }
    //  vm.selectedDoctorInfo = vm.selectedDoctorInfo.splice(0,vm.selectedDoctorInfo.length);
    };

    // determine the next step.
    vm.nextStep = function (patient, doctorInfo, isEconsult) {
      console.log(" next step called");
      vm.stepStack.push(vm.step);
      switch (vm.step) {
        case 0:
          // current state - search
          // next state is - list
          console.log(" we are in step 0");
          vm.selectedDoctorInfo = {};

          if (vm.enableDepartmentSelection) {

            if (vm.selectedDoctorItemSuggestion.id) {
              // doctor selected
              vm.selectedDoctorInfo.uid = vm.selectedDoctorItemSuggestion.id;
            }
          } else {
            if(!vm.mmd) {
              vm.selectedDepartment = null;
            }

            vm.selectedDoctorInfo = {};
          }
          if(vm.stepperControl && vm.stepperControl.nextStep) {
            vm.stepperControl.nextStep();
          }
          vm.step += 1;
          break;

        case 1:

          // set the patient visit type to default visit type
          if(!vm.isEconsult) {
            var slot = vm.selectedSlot;
            //if(slot.video) {
            //  vm.patient.visitType = slot.applicableAptTypes[0];
            //}else {
              /*angular.forEach(slot.applicableAptTypes, function (visit) {
                if (visit.aptTypeName.toLowerCase().includes("first")) {
                  vm.patient.visitType = visit;
                }
              });*/
              if(!vm.patient.visitType) {
                // Remove some visit types from slot based on in person or video
                // NEVER DO THIS!!!!! Do not use UI actions to control logic.
                // Uncommented to test the behaviour
                if(!vm.videoSlotsOnly){
                  var slotVisitTypes = [];
                  angular.forEach(slot.applicableAptTypes, function (visit) {
                    if (visit.consultationType === "Video Consultation"){
                      slotVisitTypes.push(visit);
                    }
                  });
                  if(slotVisitTypes){
                    slot.applicableAptTypes = slot.applicableAptTypes.filter(function (val){
                      return slotVisitTypes.indexOf(val) == -1;
                    })
                  }
                }else{
                  var slotVisitTypes = [];
                  angular.forEach(slot.applicableAptTypes, function (visit) {
                    if (visit.consultationType !== "Video Consultation"){
                      slotVisitTypes.push(visit);
                    }
                  });
                  if(slotVisitTypes){
                    slot.applicableAptTypes = slot.applicableAptTypes.filter(function (val){
                      return slotVisitTypes.indexOf(val) == -1;
                    })
                  }
                }
                vm.patient.visitType = slot.applicableAptTypes[0];
              }
            //}
          }else {
            vm.patient.visitType = vm.selectedWeeklyAvailability.econsultVisitTypes[0];
          }

          if(vm.stepperControl && vm.stepperControl.nextStep) {
            vm.stepperControl.nextStep();
          }
          vm.step += 1;

          break;

      }
    };



    function loginEntity() {
      $http.post(urls.apiUrl + '?request=login_entity', {
        "requestType": "login_entity",
        "entityString": vm.entity,
        "entityId" : vm.entityId
      })
        .then(function (response) {
          if (response.data && response.data.result) {

            // If from eid flow set entity-string from result and proceed.
            if (!vm.entity){
              vm.entity = response.data.urlUniqueString;
            }

            vm.departmentsList = response.data.departmentList;
            vm.entityId = response.data.locationInfo ? response.data.locationInfo.entityId : '';
            vm.hidePoweredBy = response.data.locationInfo.configMap["hidePoweredByPatientBooking"] === "true";
            if(response.data.locationInfo.configMap["branchLocations"] && !vm.branches) {
              vm.branches = JSON.parse(response.data.locationInfo.configMap["branchLocations"]);
              vm.corporateLocationInfo = response.data.locationInfo;
            }else {
              vm.entityData = response.data;
              vm.selectedLocationInfo = vm.entityData.locationInfo;
              vm.enableDepartmentSelection = vm.entityData.locationInfo.enableDepartmentSelectionInIVR && vm.branches!="";
              vm.redirectUrl = vm.selectedLocationInfo.configMap["aptRedirectUrl"];
              if(!vm.enableDepartmentSelection) {
                vm.nextStep();
              }
            }


          } else {
            swal("Sorry ! Online appointments is currently not enabled for this clinic/hospital.");
          }
        }, function (error) {
          console.log(error);
        });
    }

    vm.getDoctorSuggestions = function (searchKey) {
      console.log(lastQueryString.indexOf(searchKey));
      if(!suggestionInProgress) {
        if(queryCache[searchKey]) {
          return queryCache[searchKey];
        }else {
          suggestionInProgress = true;
          lastQueryString = searchKey;
          return $http.get(urls.apiUrl + '?request=get_docs_entity&qs=' + searchKey + '&eid=' + vm.entityId)
          .then(function (response) {
            suggestionInProgress = false;
            var resp =  response.data.map(function (item) {
              return item;
            });
            queryCache[searchKey]=resp;
            return resp;
          }, function (error) {
            console.log(error);
          });
        }

      }

    };



    function resetToFirstStep() {
      if(vm.enableDepartmentSelection) {
        vm.step = 0;
        if(vm.stepperControl && vm.stepperControl.setActiveStep) {
          vm.stepperControl.setActiveStep(1);
        }
      }else {
        vm.step = 1;
        vm.stepStack = [];
        vm.stepStack.push(1);
        if(vm.stepperControl && vm.stepperControl.setActiveStep) {
          vm.stepperControl.setActiveStep(2);
        }
      }

      vm.selectedDepartment = '';
      vm.selectedDoctorInfo = {};
      vm.selectedDoctorSuggestion = '';

      vm.patient = {};
    }


    CommonService.setHideProfile(vm.hideProfile);
    if (vm.entity) {
      CommonService.setDoctorView(false);
      loginEntity();
    }else if(vm.doctor || vm.uid) {
      if(vm.uid){
        vm.selectedDoctorItemSuggestion.id = parseInt(vm.uid);
      }
      console.log(" this is a doctor page");
      CommonService.setDoctorView(true);


      setTimeout(function() {
          startDoctorPage();
        }, 0);

    }else if (vm.entityId){
      CommonService.setDoctorView(false);
      loginEntity();
    }else if(vm.mmd) {
      CommonService.setDoctorView(true);
        setTimeout(function() {
          startMMDPage();
        }, 10);

    }


    function startDoctorPage() {
      console.log("start doctor page");
      vm.hideHeader = true;
      vm.hideHospitalName = true;
      //$timeout.call(function() {
        vm.nextStep();
      //}, 5);
    };
    function startMMDPage() {
      vm.hideHeader = true;
      vm.hideHospitalName = true;
      vm.nextStep();
    };

    vm.cancelApt = function() {
      if((vm.aptCode == null)||(vm.aptCode == '')){
        swal("Please enter Appointment code or Mobile Number!");
        return false;
      }
      swal({
        title: 'Are you sure?',
        text: "You are about to cancel this appointment!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Cancel Appointment',
        cancelButtonText: 'No, do not cancel'
      }).then(function () {
        $http
          .post(urls.apiUrl + '?request=DeleteEventAction', {
            aIdList: [vm.aptCode]
          })
          .then(function (response) {
            if (response.data.result) {
              swal("Your appointment has been successfully cancelled.");
              vm.aptCode = null;
              vm.cancelEnabled = false;
            }else {
              if(response.data.errorCode == "aptCancellationNotPossible"){
                swal("This is a paid appointment hence cannot be cancelled by you. Please contact the clinic/Hospital to cancel and get a refund");
              }else{
                swal("Sorry, appointment could not be cancelled. This appointment ID/code is invalid");
              }
            }
          }, function (error) {
            console.log(error);
          });

      });
    };


  }

  angular.module('mmd.clinic')
    .controller('ClinicController', ClinicController);



})();

(function () {
  'use strict';

  angular
    .module('mmd', [
      'ngMaterial',
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ui.bootstrap',

      'toastr',
      'feb.stepper',
      '720kb.datepicker',
      'angularFileUpload',

      'mmd.clinic',
      'mmd.kiosk',
      'mmd.common',
      'mmd.meetmydoctor',
      'mmd.econsult'

    ]);

})(

);

(function() {
  'use strict';

  angular
    .module('mmd')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function () {
  'use strict';

  angular
    .module('mmd')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider

      .state('app', {
        url: '/app?entity&hideHeader&hideHospitalName&eid&qrCode',
        templateUrl: 'app/modules/clinic/clinic.html',
        controller: 'ClinicController',
        controllerAs: 'vm'
      })
      .state('doc', {
        url: '/?doctor&eid&uid&hideInPerson',
        templateUrl: 'app/modules/clinic/clinic.html',
        controller: 'ClinicController',
        controllerAs: 'vm'
      })
      .state('mmd', {
        url: '/mmd?city&area&speciality',
        templateUrl: 'app/modules/clinic/clinic.html',
        controller: 'ClinicController',
        controllerAs: 'vm'
      })
      .state('kiosk', {
        url: '/kiosk?entity',
        templateUrl: 'app/modules/kiosk/kiosk.html',
        controller: 'KioskController',
        controllerAs: 'vm'
      })
      .state('econsult', {
        url: '/econsult?rid&appid',
        templateUrl: 'app/modules/econsult/econsult.html',
        controller: 'EconsultController',
        controllerAs: 'vm'
      })
      /*.state('meetmydoctor', {
      url: '/',
      templateUrl: 'app/modules/meetmydoctor/meetmydoctor.html',
      controller: 'MeetMyDoctorController',
      controllerAs: 'vm'
    })*/;

    $urlRouterProvider.otherwise('/');
  }

})();


(function () {
  'use strict';

  var url = function() {
    var s = server();
    if(s.indexOf("docpulse-us")>0){
      return server() + "/pubapi";
    }else {
      return server() + "/api";
    }

  };

  var server = function() {
    var href =  window.location.href;
    //console.log("HREF = " + href);
    if(href.indexOf("127.0.0.1")>-1 || href.indexOf("localhost")>-1) {
      return "http://127.0.0.1:8080";
    }else {
      //console.log(" href = " + href);
      //console.log(href.indexOf("wello-care"));

      if(href.indexOf("firebase")>-1) {
        if(href.indexOf("kiosk")>-1 || href.indexOf("wello-care")>-1 ) {
          return 'https://wello-care.appspot.com';
        }else {
          if(href.indexOf("docpulse-test")>-1) {
            return 'https://dev-dot-mmdconnect.appspot.com';
          }else if(href.indexOf("docpulse-us")>-1) {
            return 'https://docpulse-us.appspot.com';
          }else {
            return 'https://mmdconnect.appspot.com';
          }
        }
      }else {
        return "";
      }

    }
  } ;

  var uploadUrl = function() {
    /*var href =  window.location.href;
    if(href.indexOf("127.0.0.1")>-1 || href.indexOf("localhost")>-1) {
      return "http://127.0.0.1:8888";
    }else {
      if(href.indexOf("firebase")>-1) {
        if(href.indexOf("kiosk")>-1 || href.indexOf("wello-care")>-1 ) {
          return 'https://wello-care.appspot.com';
        }else {
          if(href.indexOf("docpulse-test")>-1) {
            return 'https://dev-dot-mmdconnect.appspot.com';
          }else {
            return 'https://mmdconnect.appspot.com';
          }


        }
      }else {
        return '';
      }


    }*/
    return server();

  };

  var imageServer =
  angular
    .module('mmd')
    .constant('urls', {
      apiUrl: url(),
      apiUploadUrl: uploadUrl(),
      entityString: 'nirmal-clinic-jayanagar',
      server: server()
    });

})();

(function () {
  'use strict';

  angular
    .module('mmd')
    .config(config);

  /** @ngInject */
  function config($logProvider, $httpProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    $httpProvider.interceptors.push(['$rootScope', '$q', '$injector', function ($rootScope, $q, $injector) {
      return {
        request: function (config) {
          $rootScope.showLoader = true;
          return config;
        },
        requestError: function (req) {
          $rootScope.showLoader = false;
          if (req.url.indexOf('.html') < 0) {
            //console.log('From request interceptor : ', req);
          }
          return $q.reject(req);
        },
        response: function (response) {
          $rootScope.showLoader = false;
          return response;
        },
        responseError: function (res) {
          $rootScope.showLoader = false;
          return $q.reject(res);
        }
      };
    }]);
  }

})();

angular.module("mmd").run(["$templateCache", function($templateCache) {$templateCache.put("app/modules/clinic/clinic.html","<div class=home_page ng-if=!vm.branches ng-cloak><div class=header ng-if=\"!vm.hideHeader && vm.entity\"><div class=content><div class=row><div class=\"logo_section col-sm-6 col-xs-12 text-left\"><img style=height:90px ng-src=\"{{vm.baseUrl}}/images?eid={{vm.entityData.locationInfo.entityId}}&ifn={{vm.entityData.locationInfo.logoFileName}}\"></div><div class=\"logo_section col-sm-6 col-xs-12 text-right\" ng-if=!vm.hideHospitalName><span>{{vm.entityData.locationInfo.hospitalName}}</span></div></div><hr size=1><div class=row><div class=col-sm-12><div class=\"alert alert-danger\" ng-if=vm.entityData.locationInfo.webNotice ng-bind-html=vm.entityData.locationInfo.webNotice></div></div></div></div></div><div class=main_body><div class=\"content well\" ng-if=\"vm.entity || vm.doctor || vm.mmd\"><div class=row><div class=\"feb_stepper hidden-xs\" ng-show=\"vm.enableDepartmentSelection && !vm.isEconsult\"><feb-stepper steps={{vm.steps}} control=vm.stepperControl start-step=1></feb-stepper></div></div><div class=row><div class=\"col-xs-2 text-left\" style=\"padding: 0px 0px 5px 0px\"><button type=button class=\"btn btn-primary\" ng-click=vm.prevStep() ng-if=\"(!vm.enableDepartmentSelection && vm.step>1) || (vm.enableDepartmentSelection && vm.step > 0)\"><i class=\"fa fa-arrow-left\" aria-hidden=true></i>&nbsp; Prev</button></div><div class=\"col-xs-2 text-right padding_zero\"><button type=button class=\"btn btn-primary\" ng-click=vm.nextStep(vm.patient) ng-disabled=\"(vm.step == 0 && (!vm.selectedDepartment && !vm.selectedDoctorInfo)) || (vm.step == 1 && !vm.docSelectedOnce)|| (vm.step == 2 && !vm.selectedTimeSlot)\" ng-if=\"vm.step > 2\">Next &nbsp;<i class=\"fa fa-arrow-right\" aria-hidden=true></i></button></div></div><div class=row><div ng-if=\"vm.step == 0 && vm.enableDepartmentSelection\"><form ng-if=\"vm.branches!=null && vm.branches.length>0\" class=form><div class=\"col-sm-12 padding_zero\"><div class=\"col-sm-offset-3 col-sm-6\"><div class=form-group><label>Center:&nbsp;</label><select ng-model=vm.entityId class=form-control><option value={{branch.entityId}} ng-repeat=\"branch in vm.branches\">{{branch.name}}</option></select></div></div></div><hr></form><form name=userForm class=search_form><div class=\"col-sm-12 padding_zero\"><div class=\"col-sm-offset-1 col-sm-4\"><h5 class=text_center>Select a department:</h5><div class=text_input><!--\n                  <input aria-label=\"\" placeholder=\"Select Department\" ng-model=\"vm.selectedDepartment\"\n                         uib-typeahead=\"dept for dept in vm.departmentsList | filter:$viewValue\"\n                         typeahead-loading=\"loadingDepartments\"\n                         typeahead-no-results=\"noDepartments\" typeahead-show-hint=\"true\" typeahead-min-length=\"0\">\n                  <span class=\"loading_text\" ng-show=\"loadingDepartments\" ng-cloak>Loading..</span>\n                  --><select ng-model=vm.selectedDepartment class=form-control><option value=\"\">--Select--</option><option ng-repeat=\"d in vm.departmentsList\">{{d}}</option></select><span class=no_results_text ng-show=noDepartments ng-cloak>No Departments Found</span></div></div><div class=\"col-sm-2 text-center padding_top padding_bottom\">-- OR --</div><div class=col-sm-4><h5 class=text_center>Select a doctor:</h5><div class=text_input><!--\n                  <i class=\"fa fa-user-md\"></i>\n                  --> <span class=dr>Dr.</span> <input aria-label=\"\" placeholder=\"[Type Doctor Name]\" ng-model=vm.selectedDoctorSuggestion uib-typeahead=\"doc as doc.displayString for doc in vm.getDoctorSuggestions($viewValue)\" typeahead-loading=loadingDoctors typeahead-no-results=noDcotors typeahead-show-hint=true typeahead-min-length=1 typeahead-wait-ms=500 typeahead-on-select=\"vm.onDoctorSuggestionSelected($item, $model, $label)\"> <span class=loading_text ng-show=loadingDoctors ng-cloak>Loading..</span> <span class=no_results_text ng-show=noDcotors ng-cloak>No Doctors Found</span></div></div></div></form></div></div><div class=row><div ng-if=\"vm.step == 1\"><form name=userForm class=search_form><div class=padding_zero><!-- for clinic page --><simple-doctor-list entity-id=vm.entityId department=vm.selectedDepartment u-id=vm.selectedDoctorItemSuggestion.id url-unique-string=vm.doctor city=vm.city area=vm.area></simple-doctor-list><!-- This is for doctor page commented on 03/02/21 to make it similar to clinic page--><!--<doctor-schedule entity-id=\'vm.entityId\'\n                               ng-if=\"vm.doctor\"\n                               url-unique-string=\"vm.doctor\"\n                               drill-down=\"!vm.doctor\" video-slots-only=\"false\">\n              </doctor-schedule>--><!-- test --></div></form></div></div><div class=row><div ng-if=\"vm.step == 2\"><booking-form selected-doctor-info=vm.selectedDoctorInfo selected-slot=vm.selectedSlot , patient=vm.patient pvr=vm.pvr weekly-availability=vm.selectedWeeklyAvailability is-econsult=vm.isEconsult selected-date=vm.selectedDate show-patient-info=true></booking-form></div></div></div><div class=content ng-if=\"!vm.entity && !vm.doctor && !vm.mmd\"><div class=no_entity>URL parameters are incorrect.</div></div></div><div class=footer><div class=content><div class=\"col-sm-12 col-xs-12 padding_zero text-center\">To cancel an appointment, <a href=\"\" ng-click=\"vm.cancelEnabled=true\">click here</a>.<div class=\"well well-sm\" ng-if=vm.cancelEnabled>Appointment Code (In Email) or Mobile Number: <input type=text ng-model=vm.aptCode placeholder=\"Appointment Code Or Mobile Number\"> <button class=\"btn btn-success\" ng-click=vm.cancelApt() style=background:white;color:black>Submit</button></div></div><div class=\"col-sm-12 col-xs-12 padding_zero\" ng-if=!vm.hidePoweredBy><div class=\"col-sm-6 col-xs-12 col-sm-offset-3 padding_zero\"><span class=\"col-sm-6 col-xs-12 text_right_sm\">Powered by DocPulse</span> <span class=\"col-sm-6 col-xs-12 text_left_sm\"><img src=assets/images/dpshort.png alt=\"\" width=24px height=24px> - <a href=http://www.docpulse.com/ >www.docpulse.com</a></span></div></div></div></div></div><div ng-if=vm.branches><branch-selector branches=vm.branches entity-info=vm.corporateLocationInfo hide-name=vm.hideHospitalName></branch-selector></div>");
$templateCache.put("app/modules/econsult/econsult.html","<div class=home_page><div class=container><div class=\"panel panel-success\" ng-if=vm.initialized><div class=panel-heading><h4>Follow up E-Consultation Request with Dr. {{vm.selectedDoctorInfo.name}}</h4></div><div class=panel-body ng-if=!vm.requestSuccess><div class=\"alert alert-danger\" ng-if=vm.linkInvalid>The URL you have entered is invalid or expired. Please contact your clinic / doctor for further information.</div><div class=\"alert alert-danger\" ng-if=vm.freeEconsultExpired>The follow up e-consultation period for this request is expired. You can still request a consultation by filling up the following form. Please note that applicable charges are listed based on visit selected.</div><div class=row><booking-form selected-doctor-info=vm.selectedDoctorInfo patient=vm.pvr.patient pvr=vm.pvr weekly-availability=vm.selectedWeeklyAvailability is-econsult=true selected-date=vm.selectedDate followup=true></booking-form></div></div><div class=panel-body><div class=\"alert alert-success\" ng-if=vm.requestSuccess>Thank you for submitting the request. Doctor will review your request and respond in 24-48 hours !</div></div><div class=panel-footer><b>Powered by www.docpulse.com</b></div></div><div class=\"alert alert-success\" ng-if=!vm.initialized>Please wait....</div></div></div>");
$templateCache.put("app/modules/kiosk/kiosk.html","<div class=home_page_kiosk><nav class=\"navbar navbar-default navbar-fixed-top\"><div class=container-fluid><div class=navbar-header><img alt=Brand src=assets/images/wello-logo.png class=wello-logo></div></div></nav><div class=main_body><div class=\"content well\" ng-if=vm.entity><div class=\"feb_stepper hidden-xs\"><feb-stepper steps={{vm.steps}} control=vm.stepperControl start-step=1></feb-stepper></div><div class=\"visible-xs header_title\">{{ vm.steps[vm.step] }}</div><div class=\"col-sm-12 col-md-12 col-lg-12 padding_zero\"><div class=\"col-sm-6 col-xs-6 text-left padding_zero\"><button type=button class=\"btn btn-primary\" ng-click=vm.prevStep() ng-if=\"vm.step !== 0\"><i class=\"fa fa-arrow-left\" aria-hidden=true></i>&nbsp; Prev</button></div><div class=\"col-sm-6 col-xs-6 text-right padding_zero\"><button type=button class=\"btn btn-primary\" ng-click=vm.nextStep(vm.patient) ng-disabled=\"(vm.step == 0 && (!vm.selectedDepartment && !vm.selectedDoctorInfo)) || (vm.step == 1 && !vm.docSelectedOnce)|| (vm.step == 2 && !vm.selectedTimeSlot)\" ng-if=\"vm.step > 2\">Next &nbsp;<i class=\"fa fa-arrow-right\" aria-hidden=true></i></button></div></div><div ng-if=\"vm.step == 0\"><form ng-if=\"vm.branches!=null && vm.branches.length>0\" class=form><div class=\"col-sm-12 padding_zero\"><div class=\"col-sm-offset-3 col-sm-6\"><div class=form-group><label>Center:&nbsp;</label><select ng-model=vm.entity class=form-control><option value={{branch.entityString}} ng-repeat=\"branch in vm.branches\">{{branch.name}}</option></select></div></div></div><hr></form><form name=userForm class=search_form><div class=\"col-sm-12 padding_zero\"><div class=\"col-sm-offset-1 col-sm-4\"><div class=text_input><i class=\"fa fa-map-o\"></i> <input aria-label=\"\" placeholder=\"Select Department\" ng-model=vm.selectedDepartment uib-typeahead=\"dept for dept in vm.departmentsList | filter:$viewValue\" typeahead-loading=loadingDepartments typeahead-no-results=noDepartments typeahead-show-hint=true typeahead-min-length=0> <span class=loading_text ng-show=loadingDepartments ng-cloak>Loading..</span> <span class=no_results_text ng-show=noDepartments ng-cloak>No Departments Found</span></div></div><div class=\"col-sm-2 text-center padding_top padding_bottom\">-- OR --</div><div class=col-sm-4><div class=text_input><i class=\"fa fa-user-md\"></i> <input aria-label=\"\" placeholder=\"Type to get suggestions\" ng-model=vm.selectedDoctorData uib-typeahead=\"doc as doc.displayString for doc in vm.getDoctorsBySearchKey($viewValue)\" typeahead-loading=loadingDoctors typeahead-no-results=noDcotors typeahead-show-hint=true typeahead-min-length=1> <span class=loading_text ng-show=loadingDoctors ng-cloak>Loading..</span> <span class=no_results_text ng-show=noDcotors ng-cloak>No Doctors Found</span></div></div></div></form></div><div ng-if=\"vm.step == 1\"><form name=userForm class=search_form><div class=padding_zero><div class=\"panel panel-default\" ng-repeat=\"doc in vm.docsList\" ng-class=\"{\'selected_doc_section\':(doc.uid == vm.selectedDoctorFromList.uid && doc.name == vm.selectedDoctorFromList.name)}\"><div class=panel-body><div class=\"col-sm-12 padding_zero\"><div class=\"col-sm-2 padding_left_zero\"><img ng-src=\"/images?id={{doc.uid}}&ifn={{doc.imageFileName}}\" alt=\"\" class=\"img-responsive img-thumbnail\" ng-if=\"doc.imageFileName && doc.uid\"> <img src=assets/images/doc_default.png alt=\"\" class=\"img-responsive img-thumbnail\" ng-if=\"!doc.imageFileName || !doc.uid\"></div><div class=\"col-sm-10 padding_zero\"><div class=\"col-sm-12 padding_zero\"><div class=\"col-sm-4 padding_zero\"><div class=\"padding font_16px\">{{doc.name}}</div><div class=padding_left><div>{{doc.qualifications}}</div><div>{{doc.department}}</div><div>{{doc.specialization}}</div><div>{{doc.hospitalName}}</div><div ng-show=doc.profileDescription><div ng-init=\"limitText=180\"><p>{{ doc.profileDescription | limitTo: limitText }} <a href=javascript:void(0) class=show_more_link ng-hide=\"doc.profileDescription.length < limitText\" ng-click=\"limitText = doc.profileDescription.length + 1\">show more..</a></p></div></div><div class=\"padding_top_5px web_notice_section\" ng-if=\"(doc.weeklyAvailabilityList[0].announceTimings) || doc.screenApts || !doc.available\"><div ng-show=\"doc.webNotice && doc.webNotice.length>0\"><div ng-init=\"limitText2=180\"><p>{{ doc.webNotice | limitTo: limitText2 }} <a href=javascript:void(0) class=show_more_link ng-hide=\"doc.webNotice.length < limitText2\" ng-click=\"limitText2 = doc.webNotice.length + 1\">show more..</a></p></div></div></div><div class=screen_aptmts ng-if=doc.screenApts>Online appointment booking is not available for this doctor</div><div class=screen_aptmts ng-if=\"doc.screenApts && (doc.webNotice==null || doc.webNotice.length==0)\">For appointments, please contact {{doc.weeklyAvailabilityList[0].locationInfo.contactLandLineNumber}} to schedule an appointment.</div></div></div><div class=\"col-sm-8 padding_zero\"><div class=\"padding font_16px\" ng-show=\"doc.availSlotsArray==null\">This doctor is not available</div><div class=\"padding font_16px\" ng-show=\"doc.availSlotsArray.length > 0\"><b>Consultation Timings:</b></div><div class=padding_left ng-show=\"doc.availSlotsArray.length > 0\"><div ng-repeat=\"currentSlot in doc.availSlotsArray track by $index\"><div>{{currentSlot.headers}}</div></div></div><div class=padding><button class=\"btn btn-primary\" ng-click=\"vm.nextStep({}, doc)\" ng-if=\"!doc.screenApts && (doc.availSlotsArray!=null && doc.availSlotsArray.length !== 0)\">Book Appointment</button></div></div></div></div></div></div></div></div></form></div><div ng-if=\"vm.step == 2\"><form name=userForm class=search_form><div class=\"panel panel-default\"><div class=panel-body><div class=\"col-sm-12 padding_zero\"><div class=\"col-sm-2 padding_left_zero\"><img ng-src=\"/images?id={{vm.selectedDoctor.uid}}&ifn={{vm.selectedDoctor.imageFileName}}\" alt=\"\" class=\"img-responsive img-thumbnail\" ng-if=\"vm.selectedDoctor.imageFileName && vm.selectedDoctor.uid\"> <img src=assets/images/doc_default.png alt=\"\" class=\"img-responsive img-thumbnail\" ng-if=\"!vm.selectedDoctor.imageFileName || !vm.selectedDoctor.uid\"></div><div class=\"col-sm-10 padding_zero\"><div class=\"col-sm-12 padding_zero\"><div class=\"padding font_16px\">{{vm.selectedDoctor.name || vm.selectedDoctor.displayString}}</div><div class=padding_left><div>{{vm.selectedDoctor.qualifications}}</div><div>{{vm.selectedDoctor.department}}</div><div>{{vm.selectedDoctor.specialization}}</div><div>{{vm.selectedDoctor.hospitalName}}</div></div></div></div></div></div></div><div class=\"col-sm-12 padding_zero\"><div class=\"col-sm-3 col-xs-3 text_right padding_zero\"><button class=\"btn btn-default\" ng-click=vm.loadOtherDaySlots(-1) ng-disabled=\"vm.today == vm.selectedDate\"><i class=\"fa fa-arrow-left\" aria-hidden=true></i>&nbsp;</button></div><div class=\"col-sm-6 col-xs-6 padding_zero\"><datepicker date-format=\"dd MMM yyyy\" selector=form-control date-min-limit={{vm.todayDate}} date-set={{vm.todayDate}} button-prev=\"<i class=\'fa fa-arrow-left\'></i>\" button-next=\"<i class=\'fa fa-arrow-right\'></i>\"><div class=\"form-group margin_top_zero\"><div class=\"col-sm-12 col-xs-12\"><input class=form-control placeholder=\"Choose a date\" ng-model=vm.dt></div></div></datepicker></div><div class=\"col-sm-3 col-xs-3 text_left padding_zero\"><button class=\"btn btn-default\" ng-click=vm.loadOtherDaySlots(1)><i class=\"fa fa-arrow-right\" aria-hidden=true></i></button></div></div><!-- Showing all availability --><div class=list ng-show=\"vm.availSlotsArray.length > 0\"><div ng-repeat=\"avilSlot in vm.availSlotsArray track by $index\"><!-- availability heading  --><div class=slots_header>{{avilSlot.headers}} <span ng-if=\"avilSlot.aptType!=\'\'\">({{avilSlot.aptType}} only)</span></div><!-- Video launch --><div ng-if=\"avilSlot.slotLabelList.length === 0 && !vm.announceTimings && avilSlot.aptType==\'Video Consultation\'\"><a class=\"btn btn-primary\" ng-click=vm.openVideo()>Book a video appointment</a></div><!-- Message if no slots --><div ng-if=\"avilSlot.slotLabelList.length === 0 && !vm.announceTimings && avilSlot.aptType!=\'Video Consultation\'\"><div class=\"item alert alert-danger\">{{avilSlot.overSlot}}</div></div><!-- Showing Time Slots (shown is slots are there )--><div ng-if=\"avilSlot.slotLabelList.length > 0 && !vm.announceTimings && !avilSlot.isAdvBookingValid\"><div>{{avilSlot.overSlot}}</div><span class=slot ng-repeat=\"slot in avilSlot.slotLabelList\" ng-class=\"{\'slot_selected\':((avilSlot.slots[$index].aId == vm.selectedAId) && (avilSlot.slots[$index].timeSlot == vm.selectedTimeSlot))}\" ng-click=\"vm.slotSelected(avilSlot.slots[$index], slot, avilSlot)\">{{slot}}</span></div><div class=list ng-show=vm.announceTimings><div ng-if=vm.selectedDoctor.webNotice>{{vm.selectedDoctor.webNotice}}</div><div ng-if=!vm.selectedDoctor.webNotice>For appointments, please contact {{vm.selectedDoctor.weeklyAvailabilityList[0].locationInfo.contactLandLineNumber}} to schedule an appointment.</div></div></div></div><div class=list ng-show=\"vm.availSlotsArray.length == 0\"><div class=\"item text-center\">No Appointments available</div></div></form></div><div ng-if=\"vm.step == 3\"><form name=patientDetailsForm class=search_form><div class=\"panel panel-default\"><div class=panel-body><div class=\"col-sm-12 padding_zero\"><div class=\"col-sm-2 padding_left_zero\"><img ng-src=\"/images?id={{vm.selectedDoctor.uid}}&ifn={{vm.selectedDoctor.imageFileName}}\" alt=\"\" class=doc_image ng-if=\"vm.selectedDoctor.imageFileName && vm.selectedDoctor.uid\"> <img src=assets/images/doc_default.png alt=\"\" class=doc_image ng-if=\"!vm.selectedDoctor.imageFileName || !vm.selectedDoctor.uid\"></div><div class=\"col-sm-10 padding_zero\"><div class=\"col-sm-12 padding_zero\"><div class=\"col-sm-6 padding_zero\"><div class=\"padding font_16px\">{{vm.selectedDoctor.name || vm.selectedDoctor.displayString}}</div><div class=padding_left><div>{{vm.selectedDoctor.qualifications}}</div><div>{{vm.selectedDoctor.department}}</div><div>{{vm.selectedDoctor.specialization}}</div><div>{{vm.selectedDoctor.hospitalName}}</div></div></div><div class=\"col-sm-6 padding_zero\"><div class=font_16px>Appointment Details</div><div>{{vm.selectedSlotTime}}, {{vm.selectedDate | date:\'dd MMM yyyy\'}}</div><div><span>{{vm.entityData.locationInfo.address}}, </span><span>{{vm.entityData.locationInfo.area}}, </span><span>{{vm.entityData.locationInfo.city}}, </span><span>{{vm.entityData.locationInfo.country}}</span></div></div></div></div></div></div></div><div ng-if=vm.enableCaseId><div class=caseid_heading>If you already have a hospital ID you can retrieve your details below</div><div class=\"col-sm-12 caseid_form\"><div class=col-sm-5><div class=form-group><label for=name class=\"col-sm-5 col-xs-6 control-label padding_zero\">Hospital Id*</label><div class=\"col-sm-7 col-xs-6 padding_zero\"><input type=text class=form-control id=hospitalId placeholder=\"Hospital Id\" ng-model=vm.patientOld.hospitalId></div></div></div><div class=col-sm-5><div class=form-group><label for=contactNumber class=\"col-sm-5 col-xs-6 control-label padding_zero\">Contact Number*</label><div class=\"col-sm-7 col-xs-6 padding_zero\"><input type=text class=form-control id=mobileNumber placeholder=\"Contact Number\" ng-model=vm.patientOld.contactNumber required></div></div></div><div class=col-sm-2><div class=form-group><button type=button class=\"btn btn-primary\" ng-click=vm.getPatientDetails(vm.patientOld)>Retrieve Details</button></div></div></div></div><div class=\"col-sm-12 padding_zero\"><div class=form-group><label for=name class=\"col-sm-2 col-xs-4 control-label\">Name*</label><div class=\"col-sm-10 col-xs-8\"><input type=text class=form-control id=name placeholder=Name ng-model=vm.patient.name></div></div><div class=form-group><label for=contactNumber class=\"col-sm-2 col-xs-4 control-label\">Contact Number*</label><div class=\"col-sm-10 col-xs-8\"><input type=text class=form-control id=contactNumber placeholder=\"Contact Number\" ng-model=vm.patient.contactNumber required></div></div><div class=form-group><label for=email class=\"col-sm-2 col-xs-4 control-label\">Email</label><div class=\"col-sm-10 col-xs-8\"><input type=email class=form-control id=email placeholder=Email ng-model=vm.patient.email></div></div><div class=form-group><label for=type class=\"col-sm-2 col-xs-4 control-label\">Visit Type*</label><div class=\"col-sm-10 col-xs-8\"><select class=form-control ng-model=vm.patient.visitType id=type required ng-options=\"type as type.aptTypeName for type in vm.listOfVisitTypes\"></select></div></div><div class=form-group><label for=reason class=\"col-sm-2 col-xs-4 control-label\">Reason for visit*</label><div class=\"col-sm-10 col-xs-8\"><input type=text class=form-control id=reason placeholder=Reason ng-model=vm.patient.reason required></div></div><div class=form-group><label class=\"col-sm-offset-2 col-sm-3 col-xs-6\"><input type=radio name=optionsRadios value=true ng-model=vm.patient.newPatient> I am visiting for the first time</label><label class=\"col-sm-3 col-xs-6\"><input type=radio name=optionsRadios value=false ng-model=vm.patient.newPatient> No, I have visited before.</label></div><div class=form-group ng-if=\"vm.entityData.locationInfo.configMap.enableMarketingFields == \'true\'\"><div class=\"checkbox col-sm-offset-2 col-sm-10\"><label><input type=checkbox ng-model=vm.patient.international> Are you a international patient?</label></div></div><div class=form-group><div class=\"col-sm-offset-2 col-sm-10\"><button type=button class=\"btn btn-primary\" ng-click=vm.nextStep(vm.patient) ng-disabled=\"(vm.step == 0 && (!vm.selectedDepartment && !vm.selectedDoctorInfo)) || (vm.step == 1 && !vm.docSelectedOnce)|| (vm.step == 2 && !vm.selectedTimeSlot)\" ng-if=\"vm.step > 2\">Continue &nbsp;<i class=\"fa fa-arrow-right\" aria-hidden=true></i></button></div></div><div ng-show=vm.patientDetailsNotFilled class=\"col-sm-offset-2 text-danger col-sm-10\">Please fill the required details</div></div></form></div></div><div class=content ng-if=!vm.entity><div class=no_entity>URL parameters are incorrect.</div></div><div class=\"content text-center\">To cancel an appointment, <a href=\"\" ng-click=\"vm.cancelEnabled=true\">click here</a>.<div class=\"well well-sm\" ng-if=vm.cancelEnabled>Appointment Code (sent via Email):<input type=text ng-model=vm.aptCode> <button ng-click=vm.cancelApt()>Submit</button></div></div></div></div>");
$templateCache.put("app/modules/meetmydoctor/meetmydoctor.html","<md-toolbar class=md-hue-2><div class=md-toolbar-tools><!--\n    <md-button class=\"md-icon-button\" aria-label=\"Settings\" ng-disabled=\"true\">\n      <md-icon>menu</md-icon>\n    </md-button>\n    --><h1 flex md-truncate>MEET MY DOCTOR</h1><!--\n    <md-button aria-label=\"Favorite\" ng-repeat=\'country in vm.countries\'>\n      {{country}}\n    </md-button>\n    {{vm.options.country}}\n    --><md-input-container><md-select ng-model=vm.options.country><md-option ng-value=country ng-repeat=\"country in vm.countries\">{{country}}</md-option></md-select></md-input-container><md-button class=md-icon-button aria-label=More><md-icon>person</md-icon></md-button><!--\n    <md-button class=\"md-icon-button\" aria-label=\"Favorite\">\n      <md-icon>favorite</md-icon>\n    </md-button>\n\n    <md-button class=\"md-icon-button\" aria-label=\"More\">\n      <md-icon>more_vert</md-icon>\n    </md-button>\n    --></div></md-toolbar><div class=mmd_page><!--\n    <nav class=\"navbar\" tabindex=\'-1\'>\n        <div class=\"navbar-header\">\n          <div class=\"navbar-brand\"><b>MeetMyDoctor</b></div>\n        </div>\n        <div>\n          <ul class=\"nav navbar-nav navbar-right\">\n            <li style=\'cursor:pointer\' ng-repeat=\'country in vm.countries\'\n                ng-class=\"{\'active\': country == vm.defaultCountry}\"><a ng-click=\"vm.defaultCountry=country\">{{country}}</a>\n            </li>\n            <li><a href=\"/ng/portal/portal.html\">Login</a></li>\n          </ul>\n        </div>\n    </nav>\n    --><div layout=column class=zero><div flex=33 flex-md=\"{{ vm.box1Width }}\" class=one></div><div flex=33 layout=\"{{ vm.direction }}\" layout-md=row class=two><div flex=20 flex-md=10 hide-lg=\"\" class=two_one></div><div flex=30px show=\"\" hide-md=\"{{ vm.hideBox }}\" flex-md=25 class=two_two></div><div flex=20 flex-md=65 class=two_three></div></div><div flex=\"\" class=three></div></div><div class=search_box><div class=row><div class=col-md-12><form style=color:black;font-size:120%;padding:25px;text-align:center method=GET action=/mmd><h1 class=hero style=\"margin-top:50px;text-align:center;border-bottom:1px solid #6ab8e2;padding:10px\">CONSULT WITH THE BEST DOCTORS</h1><div class=row><div class=col-sm-3><div style=margin:5px><b>City</b><br><select class=form-control ng-model=vm.options.city ng-change=vm.handleCityChange() style=\"padding: 5px; margin-left: 4px\"><option ng-repeat=\"c in vm.cities\">{{c}}</option></select></div></div><div class=col-sm-3><div style=margin:5px><b>Near</b><br><select class=form-control ng-model=vm.options.area ng-change=vm.handleAreaChange() style=\"padding: 5px; margin-left: 4px\"><option value=\"\">-- Anywhere --</option><option ng-repeat=\"area in vm.options.areas\">{{area.displayString}}</option></select><div style=height:20px><div style=font-weight:bold;font-size:120%;color:red;height:20px ng-show=loading>......</div></div></div></div><div class=col-sm-3><div style=margin:5px><b>Speciality</b><br><select class=form-control ng-model=vm.options.speciality style=\"padding: 5px; margin-left: 2px\"><option value=\"\">-- Select a speciality --</option><option value={{vm.options.speciality.id}} ng-repeat=\"speciality in vm.specialities\">{{speciality.displayString}}</option></select><div style=height:20px><div style=font-weight:bold;color:red;font-size:120% ng-show=loading>......</div></div></div></div><div class=col-sm-3><div style=margin:5px><br><a class=\"btn btn-primary\" ng-click=vm.findDoctors()>Find Doctors &nbsp;<i class=\"fa fa-angle-right\"></i></a></div></div></div><br><br></form></div></div><div></div></div><hr style=margin-top:50px;color:#6ab8e2><div class=row><div class=col-md-4><a href=http://www.meetmydoctor.in/directory/Bangalore/doctors>Doctors in Bangalore</a><br><a href=http://www.meetmydoctor.in/directory/Bangalore>Doctors in Bangalore by area</a><br><a href=http://www.meetmydoctor.in/directory/Bangalore/Any/Paediatrics>Paediatricians(child specialists) in Bangalore</a><br><a href=http://www.meetmydoctor.in/directory/Bangalore/Any/Obstetrics%20and%20Gynaecology/doctors/0>Gynaecology doctors in Bangalore</a><br><a href=http://www.meetmydoctor.in/directory/Bangalore/Any/ENT>ENT specialists in Bangalore</a><br><a href=http://www.meetmydoctor.in/directory/Bangalore/Any/Neurology>Neurologists in Bangalore</a><br><a href=http://www.meetmydoctor.in/directory/Bangalore/Any/Dermatology>Dermatologists(Skin Specialists) in Bangalore</a><br><a href=http://www.meetmydoctor.in/directory/Bangalore/Any/Oncology>Oncologists(Cancer specialists) in Bangalore</a><br><a href=http://www.meetmydoctor.in/directory/Bangalore/Any/Orthopaedics>Orthopaedic doctors in Bangalore</a><br></div><div class=col-md-4><a href=http://www.meetmydoctor.in/directory/Bangalore/doctors>Our Doctors</a><br><a href=# ng-click=vm.cancelApt()>Cancel Appointments</a><br><a href=/Aboutus.html>About Us</a><br><a href=http://www.docpulse.com/contact-us>Contact Us</a><br><a href=/tos.html>Terms of Service</a><br><a href=/privacy.html>Privacy Policy</a><br><a href=# ng-click=vm.cancelApt()>Cancel Appointments</a><br><a href=# ng-click=vm.recommend()>Recommend a doctor</a></div><div class=col-md-4><br><b>Connect with us</b><br><br><a href=http://www.facebook.com/pages/MeetMyDoctor/232098856851409><img style=\"border: none; vertical-align: middle\" src=images/social_2.png>Facebook</a><br><a href=http://twitter.com/#!/MeetMyDoc><img style=\"border: none; vertical-align: middle\" src=images/social_3.png>Twitter</a><br><br></div></div></div><!--\n<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <md-button class=\"md-icon-button\" aria-label=\"Settings\" ng-disabled=\"true\">\n      <md-icon md-svg-icon=\"img/icons/menu.svg\"></md-icon>\n    </md-button>\n\n    <h2 flex md-truncate>Toolbar with Disabled/Enabled Icon Buttons</h2>\n\n    <md-button class=\"md-icon-button\" aria-label=\"Favorite\">\n      <md-icon md-svg-icon=\"img/icons/favorite.svg\" class=\"favorite-icon\"></md-icon>\n    </md-button>\n\n    <md-button class=\"md-icon-button\" aria-label=\"More\">\n      <md-icon md-svg-icon=\"img/icons/more_vert.svg\"></md-icon>\n    </md-button>\n  </div>\n</md-toolbar>\n\n<md-content class=\"md-padding\">\n  Meet My Doctor\n  <md-nav-bar\n    md-no-ink-bar=\"disableInkBar\"\n    md-selected-nav-item=\"currentNavItem\"\n    nav-bar-aria-label=\"navigation links\">\n    <md-nav-item md-nav-click=\"goto(\'page1\')\" name=\"page1\">\n      Online Consult\n    </md-nav-item>\n    <md-nav-item md-nav-click=\"goto(\'page2\')\" name=\"page2\" ng-disabled=\"secondTabDisabled\">\n      Book a physical visit\n    </md-nav-item>\n    <md-nav-item md-nav-click=\"goto(\'page3\')\" name=\"page3\">\n      FAQ\n    </md-nav-item>\n    <md-nav-item md-nav-click=\"goto(\'page4\')\" name=\"page4\" disabled>\n      Payments\n    </md-nav-item>\n  </md-nav-bar>\n  <span>{{status}}</span>\n  <div class=\"ext-content\">\n    External content for `<span>{{currentNavItem}}</span>`.\n  </div>\n\n\n</md-content>\n-->");
$templateCache.put("app/modules/clinic/components/booking-form/partials/booking-form.html","<style>@media (min-width: 576px) {\n    .form-col-4 {\n      flex: 0 0 33.33333%;\n      max-width: 33.33333%;\n    }\n\n    .form-col-8 {\n      flex: 0 0 66.66667%;\n      max-width: 66.66667%;\n    }\n\n    .offset-form-col-4 {\n      margin-left: 33.33333%;\n    }\n\n    .mobileCode{\n      width: 100px;\n    }\n    .mobNum {\n      width: 200px;\n    }\n    .contactNum{\n      width: 345px;\n    }\n\n    .countryCode{\n      width: 150px ;\n    }\n\n    .customBox{\n      width:500px;\n    }\n\n  }</style><form name=patientDetailsForm class=search_form id=booking_form><div class=\"panel panel-default\"><div class=panel-body><div class=\"col-sm-12 padding_zero\"><div class=\"col-sm-2 padding_left_zero\"><img ng-src=\"{{vm.baseUrl}}/images?id={{vm.selectedDoctorInfo.uid}}&ifn={{vm.selectedDoctorInfo.imageFileName}}\" alt=\"\" class=doc_image ng-if=\"vm.selectedDoctorInfo.imageFileName && vm.selectedDoctorInfo.uid\"> <img src=assets/images/doc_default.png alt=\"\" class=doc_image ng-if=\"!vm.selectedDoctorInfo.imageFileName || !vm.selectedDoctorInfo.uid\"></div><div class=\"col-sm-10 padding_zero\"><div class=\"col-sm-12 padding_zero\"><div class=\"col-sm-6 padding_zero\"><div class=\"padding font_16px\">{{vm.selectedDoctorInfo.salutation}}{{vm.selectedDoctorInfo.name || vm.selectedDoctorInfo.displayString}}</div><div class=padding_left><div>{{vm.selectedDoctorInfo.qualifications}}</div><div>{{vm.selectedDoctorInfo.department}}</div><div>{{vm.selectedDoctorInfo.specialization}}</div><div>{{vm.selectedDoctorInfo.hospitalName}}</div></div></div><div class=\"col-sm-6 padding_zero\" ng-if=vm.selectedSlot><div class=font_16px>Appointment Details</div><div>{{vm.getSlotString()}}, {{vm.selectedDate | date:\'dd MMM yyyy\'}}</div><div ng-if=!vm.isVideoType() style=\"font-weight: bold\"><span>{{vm.weeklyAvailability.locationInfo.hospitalName}}, </span><span>{{vm.weeklyAvailability.locationInfo.address}}, </span><span>{{vm.weeklyAvailability.locationInfo.area}}, </span><span>{{vm.weeklyAvailability.locationInfo.city}}, </span><span>{{vm.weeklyAvailability.locationInfo.country}}</span></div></div></div></div></div></div></div><div ng-if=vm.weeklyAvailability.locationInfo.enableCaseIDSelection><div class=caseid_heading>If you already have a hospital ID you can retrieve your details below</div><div class=\"col-sm-12 caseid_form\"><div class=col-sm-5><div class=form-group><label for=name class=\"col-sm-5 col-xs-6 control-label padding_zero\">Hospital ID*</label><div class=\"col-sm-7 col-xs-6 padding_zero\"><input type=text class=form-control id=hospitalId placeholder=\"Hospital ID\" ng-model=vm.patientOld.hospitalId></div></div></div><div class=col-sm-5><div class=form-group><label for=contactNumber class=\"col-sm-5 col-xs-6 control-label padding_zero\">Contact Number*</label><div><select class=\"col-sm-1 col-xs-2 form-control mobileCode\" ng-model=vm.countryCode><option ng-repeat=\"country in vm.countryList\" value={{country.dial_code}}>{{country.dial_code}} {{country.name}}</option></select></div><div class=\"col-sm-6 col-xs-6 padding_zero\"><input type=text class=\"form-control mobNum\" id=mobileNumber placeholder=\"Contact Number\" ng-model=vm.patientOld.contactNum required></div></div></div><div class=col-sm-2><div class=form-group><button type=button class=\"btn btn-primary\" ng-click=vm.getPatientDetails(vm.patientOld)>Retrieve Details</button></div></div></div></div><div class=col-sm-12><div class=form-group><label for=name class=\"col-sm-2 col-xs-4 control-label\">Patient/Client Name*</label><div class=\"col-sm-10 col-xs-8\"><input type=text class=\"form-control customBox\" id=name placeholder=Name ng-model=vm.patient.name></div></div><!-- <div class=\"form-group\">\n      <label for=\"contactNumber\" class=\"col-sm-2 col-xs-4 control-label\">Contact Number*</label>\n      <div class=\"col-sm-10 col-xs-8\">\n        <select class=\"form-control\" ng-model=\"vm.countryCode\">\n          <option ng-repeat=\"country in vm.countryList\" value=\"{{country.dial_code}}\">{{country.dial_code}}\n            {{country.name}}\n          </option>\n        </select>\n        <input type=\"text\" class=\"form-control\" id=\"contactNumber\" placeholder=\"Contact Number\"\n               ng-model=\"vm.patient.contactNum\" required>\n      </div>\n    </div> --><!--<div>\n        <select class=\"col-sm-1 col-xs-2 form-control\" ng-model=\"vm.countryCode\">\n          <option ng-repeat=\"country in vm.countryList\" value=\"{{country.dial_code}}\">{{country.dial_code}}\n            {{country.name}}\n          </option>\n        </select>\n      </div>\n      <div class=\"col-sm-9 col-xs-6\">\n        <input type=\"text\" class=\"form-control\" id=\"contactNumber\" placeholder=\"Contact Number\"\n               ng-model=\"vm.patient.contactNum\" required>\n      </div>--><!-- </div> --><div class=form-group><label for=contactNumber class=\"col-sm-2 col-xs-4 control-label\">Contact Number*</label><div class=\"col-sm-4 col-xs-8\"><div class=row><div class=col-xs-6><select class=\"form-control countryCode\" ng-model=vm.countryCode><option ng-repeat=\"country in vm.countryList\" value={{country.dial_code}}>{{country.dial_code}} {{country.name}}</option></select></div><div class=col-xs-6><input type=text class=\"form-control contactNum\" id=contactNumber placeholder=\"Contact Number\" ng-model=vm.patient.contactNum required></div></div></div></div><div class=form-group ng-if=vm.showEmailId()><label for=email class=\"col-sm-2 col-xs-4 control-label\">Email<span ng-if=\"vm.isVideoType() || vm.isEconsult\">*</span></label><div class=\"col-sm-10 col-xs-8\"><input type=text class=\"form-control customBox\" id=email placeholder=Email ng-model=vm.patient.emailId ng-blur=vm.validateEmail()><p class=error style=color:red ng-if=vm.invalidEmailId>Invalid Email, kindly enter correct emailId</p></div></div><!-- Add PVR specific --><div class=form-group><label class=\"col-sm-2 col-xs-4 control-label\">Patient/Client Information</label><div class=\"col-sm-10 col-xs-8\"><input name=age type=radio ng-model=vm.patientAgeType value=age> Age <input name=age type=radio ng-model=vm.patientAgeType value=dob> Date Of Birth<div class=form-group><div ng-if=\"vm.patientAgeType==\'dob\'\"><input type=text name=dob1 ng-model=vm.patient.dobdd placeholder=DD ng-change=vm.checkDate() style=width:40px;padding:5px> <input type=text name=dob2 ng-model=vm.patient.dobmm placeholder=MM ng-change=vm.checkDate() style=width:40px;padding:5px> <input type=text name=dob3 ng-model=vm.patient.dobyyyy placeholder=YYYY ng-change=vm.checkDate() style=width:100px;padding:5px><p ng-show=vm.invalidDate class=error>Invalid Date</p></div><br><div ng-if=\"vm.patientAgeType==\'age\'\"><input type=text name=dob1 ng-model=vm.patient.ageYearsStr placeholder=Yrs ng-change=vm.checkAgeYears() style=width:40px;padding:5px> Yrs<p ng-show=vm.invalidAge class=error>Invalid Age</p><input type=text name=dob2 ng-model=vm.patient.ageMonthsStr placeholder=Mnts ng-change=vm.checkAgeMonths() style=width:40px;padding:5px> Mnts<p ng-show=vm.invalidAge class=error>Invalid Age</p></div><br></div><div class=form-group><input name=sex type=radio ng-model=vm.patient.sex value=Male>&nbsp;Male&nbsp;&nbsp;&nbsp; <input name=sex type=radio ng-model=vm.patient.sex value=Female>&nbsp;Female&nbsp;&nbsp;&nbsp; <input name=sex type=radio ng-model=vm.patient.sex value=Other>&nbsp;Other</div><div ng-if=!vm.hideRequestForAnotherPatient()><div class=form-group><input type=checkbox ng-model=vm.guardian>&nbsp;Requesting on behalf of the patient?</div><div ng-if=vm.guardian class=form-group>Requestor Email ID : <input type=text ng-model=vm.pvr.reqEmailId> Requestor Mobile Number : <input type=text ng-model=vm.pvr.reqMobileNumber></div></div></div></div><div class=form-group ng-if=vm.showFirstAndFollowup()><div class=\"col-sm-offset-2 col-sm-4 col-xs-6\"><input type=radio name=optionsRadios value=true ng-model=vm.patient.newPatient> I am visiting for the first time</div><div class=\"col-sm-3 col-xs-6\"><input type=radio name=optionsRadios value=false ng-model=vm.patient.newPatient> No, I have visited before.</div></div><div class=form-group ng-if=\"vm.showFirstAndFollowup() && vm.showFileNumberForFollowup() && vm.patient.newPatient === \'false\' \"><label for=fileNumber class=\"col-sm-2 col-xs-4 control-label\">File Number:<span>*</span></label><div class=\"col-sm-10 col-xs-8\"><input type=fileNumber class=form-control id=fileNumber placeholder=\"File Number\" ng-model=vm.patient.fileNumber></div></div><div class=form-group ng-if=vm.showNationalID()><label for=nationalId class=\"col-sm-2 col-xs-4 control-label\">National ID Number:<span>*</span></label><div class=\"col-sm-10 col-xs-8\"><input ng-if=!vm.numericNationalID() type=nationalId class=\"form-control customBox\" id=nationalId placeholder=\"National ID Number\" ng-model=vm.patient.govtIdNum> <input ng-if=vm.numericNationalID() type=number class=\"form-control customBox\" id=nationalId placeholder=\"National ID Number\" ng-model=vm.patient.govtIdNum><p class=error style=color:red ng-if=vm.isVideoType()>Please attach copy of your national ID to the form below</p></div></div><!-- <div class=\"form-group\"\n         ng-if=\"!vm.isVideoType() && vm.weeklyAvailability.locationInfo.configMap.enableMarketingFields == \'true\'\">\n      <div class=\"checkbox col-sm-offset-2 col-sm-10\">\n        <input type=\"checkbox\" ng-model=\"vm.patient.international\"> Are you a international patient?\n      </div>\n    </div> --><div ng-if=\"vm.isVideoType() || (!vm.isVideoType() && vm.weeklyAvailability.locationInfo.configMap.enableMarketingFields == \'true\')\" class=form-group><div class=\"col-sm-offset-2 col-sm-10\"><input type=checkbox ng-model=vm.patient.international ng-change=vm.setupVisitTypes()> Are you an international patient?</div></div><div ng-if=\"vm.patient.international && vm.showPassportDetails()\" class=form-group><label class=\"col-sm-2 col-xs-4 control-label\">Passport Number*</label><div class=\"col-sm-10 col-xs-8\"><input class=\"form-control customBox\" type=text ng-model=vm.patient.passportNumber> <span style=\"color: red\">Note: Attach a copy of passport for verification, without the attachment appointment may be rejected</span></div></div><div class=form-group ng-if=vm.showNationality()><label for=nationality class=\"col-sm-2 col-xs-4 control-label\">Nationality:<span>*</span></label><div class=\"col-sm-10 col-xs-8\"><!--\n        <input type=\"nationality\" class=\"form-control\" id=\"nationality\" placeholder=\"Nationality\" ng-model=\"vm.patient.nationality\">\n        --> <input class=\"form-control customBox\" aria-label=\"\" placeholder=\"[Type to select nationality]\" ng-model=vm.patient.nationality uib-typeahead=\"country for country in vm.countries | filter:$viewValue | limitTo:8\"></div></div><div class=form-group ng-if=\"vm.selectedSlot && !vm.isEconsult\"><label class=\"col-sm-2 col-xs-4 control-label\">Select Type*</label><div class=\"col-sm-10 col-xs-8\"><select ng-if=vm.patient.visitType class=\"form-control customBox\" ng-model=vm.patient.visitType required ng-options=\"vt as vt.aptTypeName for vt in vm.visitTypes\" ng-change=vm.getPatientProvidedFields()></select><br><div ng-if=\"vm.patient.visitType &&  vm.patient.visitType.isPaymentEnabled\" class=margin_top_5px><div ng-if=!vm.pastVisitDate class=\"label label-danger font_14px\">Consultation Fees: {{(vm.patient.visitType.fees + vm.patient.visitType.fees*vm.patient.visitType.taxPercentage/100) | number:0}} {{vm.weeklyAvailability.locationInfo.currencyPrefix}}</div><div ng-if=\"vm.isFollowupVisit && !vm.invalidFollowup && vm.pastVisitDate\" class=\"label label-danger font_14px\">Consultation Fees: {{(vm.patient.visitType.followUpFees + vm.patient.visitType.followUpFees*vm.patient.visitType.taxPercentage/100) | number:0}} {{vm.weeklyAvailability.locationInfo.currencyPrefix}}</div><br><div class=\"alert alert-danger\" ng-if=vm.getCancellationMessage()>{{vm.getCancellationMessage()}}</div></div><div ng-if=\"vm.isCouponCodeEnabled() && vm.patient.visitType &&  vm.patient.visitType.isPaymentEnabled \"><input type=text placeholder=\"Enter Coupon Code\" ng-model=vm.couponCode> <button class=\"btn btn-primary\" ng-click=vm.applyCouponCode(vm.couponCode) ng-disabled=vm.couponMatched>Apply</button> <button class=\"btn btn-danger\" ng-click=vm.clearCouponDiscount()>Clear</button></div><div class=alert-danger ng-if=vm.couponError>Invalid Coupon Code</div><div class=alert-danger ng-if=vm.couponExpired>This coupon is expired</div><div ng-if=vm.couponMatched class=alert-success>Successfully Applied Coupon {{vm.couponCode}} to avail discount of {{vm.couponDiscountAmt}} Rs</div></div></div><div class=form-group ng-if=\"vm.selectedSlot && !vm.isEconsult && vm.staffInstructions.length > 0\"><label class=\"col-sm-2 col-xs-2 control-label\"></label><div class=\"col-sm-10 col-xs-8 alert alert-danger customBox\"><span style=\"font-weight: bold\">Essential Instructions for Your {{ vm.patient.visitType.aptTypeName }}</span><br><!-- Add a list to display staff instructions --><ul><li ng-repeat=\"instruction in  vm.staffInstructions\">{{ instruction }}</li></ul></div></div><div class=form-group ng-if=\"vm.patient.visitType.daysLimitForFollowUp && vm.patient.visitType.followUpFees>=0\"><label class=\"col-sm-2 col-xs-4 control-label\"></label><div class=\"col-sm-10 col-xs-8\"><input type=checkbox ng-model=vm.isFollowupVisit ng-click=vm.clearFollowup()> <span>Is Followup visit ? <b style=\"color: green\">Select if previous visit is with in {{vm.patient.visitType.daysLimitForFollowUp}} days</b></span><div ng-if=vm.isFollowupVisit>Enter Previous Visit Date<!--          <input ng-blur=\"vm.checkPrevDateValidity()\" ng-model=\"vm.previousVisitDate\" type=\"text\" title=\"dd/mm/yyyy\" placeholder=\"dd/mm/yyyy\">--> <input ng-blur=vm.checkPrevDateValidity() ng-model=vm.previousVisitDate type=date title=\"enter date\"></div><div ng-if=vm.invalidFollowup style=\"color: red\">Invalid followup appointment date (previous appointment date should be within {{vm.patient.visitType.daysLimitForFollowUp}} days )</div></div></div><div class=form-group ng-if=vm.isEconsult><label for=type class=\"col-sm-2 col-xs-4 control-label\">Visit Type*</label><div class=\"col-sm-10 col-xs-8\"><select class=form-control ng-model=vm.patient.visitType id=type2 required ng-options=\"type as type.aptTypeName for type in vm.weeklyAvailability.econsultVisitTypes\"></select><div ng-if=\"vm.patient.visitType && vm.isEconsult && vm.patient.visitType.isPaymentEnabled\"><div ng-if=\"vm.patient.visitType && vm.patient.visitType.isPaymentEnabled\" class=margin_top_5px><div class=\"label label-danger font_14px\">Consultation Fees: {{(vm.patient.visitType.fees + vm.patient.visitType.fees*vm.patient.visitType.taxPercentage/100) | number:0}} {{vm.weeklyAvailability.locationInfo.currencyPrefix}}</div><br><div class=\"alert alert-danger\" ng-if=vm.getCancellationMessage()>{{vm.getCancellationMessage()}}</div></div><span class=\"label label-danger font_14px\" ng-if=\"vm.patient.visitType.fees==0\">Free!</span></div></div></div><div class=form-group ng-show=!vm.hideReason><label for=reason class=\"col-sm-2 col-xs-4 control-label\"><span ng-if=\"vm.isVideoType() || vm.isEconsult\">Chief Complaint/Main </span>Reason for consultation*</label><div class=\"col-sm-10 col-xs-8\"><input type=text class=\"form-control customBox\" id=reason placeholder=Reason ng-model=vm.patient.reason required></div></div><div class=form-group ng-if=\"vm.isVideoType() || vm.isEconsult\"><label for=reason class=\"col-sm-2 col-xs-4 control-label\">Your question/query*</label><div class=\"col-sm-10 col-xs-8\"><textarea class=\"form-control customBox\" rows=5 placeholder=\"Your Query\" ng-model=vm.pvr.patientQuery required></textarea></div></div><div ng-if=\"vm.isVideoType() && vm.pvr.customItems\" ng-repeat=\"ci in vm.pvr.customItems\"><div class=form-group ng-if=\"vm.isVideoType() && vm.pvr.customItems\"><label class=\"col-sm-2 col-xs-4 control-label\">{{ci.fieldName}} <span ng-if=ci.mandatory>*</span></label><div class=\"col-sm-10 col-xs-8\" ng-if=\"ci.fieldValueType==6\" style=\"display: flex\"><input type=text class=\"form-control customBox\" ng-model=ci.fieldValue style=width:75px> <span>{{ci.unit}}</span></div><div class=\"col-sm-10 col-xs-8\" ng-if=\"ci.fieldValueType != 6\"><input type=text class=\"form-control customBox\" ng-model=ci.fieldValue></div></div></div><div class=form-group ng-if=\"vm.isVideoType() || vm.isEconsult\"><uploader style=width:100% pvr=vm.pvr attachment-in-progress=vm.attachmentInProgress></uploader></div><div class=form-group ng-if=\"vm.patient.visitType && vm.patient.visitType.isPaymentEnabled && vm.patient.visitType.fees>0 && vm.consentUrl\"><label class=\"col-sm-7 col-xs-4 control-label\"><input type=checkbox ng-model=vm.agreeToTerms>&nbsp;&nbsp;I have read and agree to the consultation terms and conditions&nbsp;<a ng-click=vm.openConsentUrl()>(View T&C)</a></label></div><div class=form-group><div class=\"col-sm-5 col-xs-4 control-label\"><button type=button class=\"btn btn-primary\" ng-click=vm.submitRequest() ng-disabled=\"(vm.patient.visitType && vm.patient.visitType.isPaymentEnabled && vm.patient.visitType.fees>0 && !vm.agreeToTerms && vm.consentUrl)||vm.showPayPalAlertText\">Continue &nbsp;<i class=\"fa fa-arrow-right\" aria-hidden=true></i></button><div ng-if=vm.showPaypal() id=paypal-button><b style=\"color: green\" ng-if=vm.showPayPalAlertText>Appointment is reserved, please complete payment by clicking on paypal button to confirm the appointment</b></div></div></div><div ng-show=vm.patientDetailsNotFilled class=\"col-sm-offset-2 text-danger col-sm-10\">Please fill the required details and Attach necessary documents.</div></div></form>");
$templateCache.put("app/modules/clinic/components/day-schedule/partials/day-schedule.html","<style>.slotCss{\n        border-radius: 5px;\n    }</style><!-- we are inside the availability for a single location, single doctor, for a single day --> <a class=\"slot slotCss\" ng-repeat=\"slot in vm.avail.slots\" ng-if=vm.avail.advFlag ng-click=vm.slotSelected(slot)><i ng-if=\"vm.avail.header.indexOf(\'Video\')>-1&&vm.videoSlotsOnly\" class=\"fa fa-video-camera\"></i> {{slot.slotLabel}}</a><div class=margin_left_5px>{{vm.avail.noSlotsMessage}}</div><div class=margin_left_5px>{{vm.avail.slotsMessage}}</div>");
$templateCache.put("app/modules/clinic/components/profile/partials/profile-details.html","<style>.modal-md{\n    width: 720px;\n  }</style><div class=modal-header><h3 class=modal-title id=modal-title><span ng-if=\"userProfile.isDoctor && userProfile.showDr\">Dr.</span>{{userProfile.name}}</h3></div><div ng-if=userProfile.profileUrl class=modal-body><iframe ng-src={{userProfile.profileUrl}} width=680 height=500></iframe></div><div ng-if=!userProfile.profileUrl class=modal-body id=modal-body><p>{{userProfile.profileSummary}}</p><uib-accordion><uib-accordion-group is-open=g.isOpen class=panel-default heading={{g.sectionTitle}} ng-repeat=\"g in userProfile.sections\"><ul><li ng-repeat=\"t in g.sectionContent\">{{t}}</li></ul></uib-accordion-group></uib-accordion></div><div class=modal-footer><button class=\"btn btn-warning\" type=button ng-click=cancel()>Cancel</button></div>");
$templateCache.put("app/modules/clinic/components/profile/partials/profile.html","<div class=font_20px>{{vm.doctorInfo.salutation}}{{vm.doctorInfo.name}}</div><div class=font_16px>{{vm.doctorInfo.qualifications}}</div><div class=font_14px>{{vm.doctorInfo.department}}</div><div>{{vm.doctorInfo.specialization}}</div><div>{{vm.doctorInfo.hospitalName}}</div><div ng-show=\"vm.doctorInfo.profileDescription || vm.doctorInfo.profileUrl\"><div ng-init=\"limitText=180\"><p class=hidden-xs>{{ vm.doctorInfo.profileDescription | limitTo: limitText }} <a href=javascript:void(0) class=show_more_link ng-hide=\"vm.doctorInfo.profileDescription.length < limitText\" ng-click=\"limitText = vm.doctorInfo.profileDescription.length + 1\">show more..</a><br></p><a class=\"btn btn-info btn-sm\" ng-click=vm.viewProfile()>View Details</a></div></div>");
$templateCache.put("app/modules/clinic/components/doctor-schedule/partials/doctor-schedule.html","<div class=doctor_schedule ng-if=vm.dataAvailable><!-- for mobile --><div class=visible-xs style=background:white ng-if=\"!vm.hideProfile && !vm.drillDown\"><div class=row><div class=\"col-xs-6 text-left\"><img class=\"img-responsive img-circle\" ng-if=\"vm.doc.imageFileName && vm.doc.uid\" ng-src=\"{{vm.baseUrl}}/images?id={{vm.doc.uid}}&ifn={{vm.doc.imageFileName}}\" alt=\"\" class=\"img-responsive img-thumbnail center-block\" ng-if=\"vm.doc.imageFileName && vm.doc.uid\"> <img src=assets/images/doc_default.png alt=\"\" class=\"img-responsive img-circle\" ng-if=\"!vm.doc.imageFileName || !vm.doc.uid\"></div><div class=\"col-xs-6 text-right\" ng-if=!vm.hideProfile><profile doctor-info=vm.doc></profile></div></div></div><div class=hidden-xs style=background:white ng-if=\"!vm.hideProfile && !vm.drillDown\"><div class=row><div class=col-sm-2><img style=width:150px class=img-responsive ng-if=\"vm.doc.imageFileName && vm.doc.uid\" ng-src=\"{{vm.baseUrl}}/images?id={{vm.doc.uid}}&ifn={{vm.doc.imageFileName}}\" alt=\"\" class=\"img-responsive img-thumbnail center-block\" ng-if=\"vm.doc.imageFileName && vm.doc.uid\"> <img style=width:150px src=assets/images/doc_default.png alt=\"\" class=img-responsive ng-if=\"!vm.doc.imageFileName || !vm.doc.uid\"></div><div class=col-sm-10><profile doctor-info=vm.doc></profile><div class=margin_top_5px ng-if=\"(vm.doc.webNotice && vm.doc.webNotice.length>0)\"><p ng-bind-html=vm.doc.webNotice style=\"padding: 10px;\n    background: orangered;\n    font-weight: bolder;\n    font-size: 1.1em;\n    color: white;\n    border-radius: 5px\"></p></div></div></div></div><div><div ng-if=vm.urlUniqueString><md-button class=md-raised ng-click=vm.econsult() ng-if=vm.doc.onlineConsultEnabled><md-icon>email</md-icon>Request E-Consult</md-button><!--<md-button class=\'md-raised md-warn\' ng-click=\"vm.getVideoSchedule()\" ng-if=\"vm.doc.inPersonConsultEnabled && vm.doc.videoConsultEnabled\">\n        <md-icon>video_call</md-icon>\n        Show Video Slots Only\n      </md-button>--><md-button class=\"md-raised md-warn\" ng-click=vm.getVideoSchedule() ng-if=vm.doc.videoConsultEnabled><md-icon>video_call</md-icon>Show Video Slots Only</md-button><!-- <md-button class=\'md-raised md-primary\' ng-click=\"vm.getInPersonSchedule()\" ng-if=\"vm.doc.inPersonConsultEnabled && vm.doc.videoConsultEnabled\">\n        <md-icon>person</md-icon>\n        Show In-Person Slots Only\n      </md-button>--><md-button class=\"md-raised md-primary\" ng-click=vm.getInPersonSchedule() ng-if=vm.doc.inPersonConsultEnabled><md-icon>person</md-icon>Show In-Person Slots Only</md-button></div><div class=\"row text-right\"><div class=\"col-sm-3 col-sm-offset-9\"><datepicker ng-if=!vm.dateFromUrl date-format=\"dd MMM yyyy\" selector=form-control date-min-limit={{vm.todayDate}} button-prev=\"<i class=\'fa fa-chevron-left\'></i>\" button-next=\"<i class=\'fa fa-chevron-right\'></i>\"><div class=form-group><div class=input-group><a ng-click=vm.handlePrevious() class=input-group-addon><i class=\"fa fa-chevron-left\"></i> </a><input type=text class=form-control placeholder=\"Choose a date\" ng-model=vm.dateSelectorDate ng-change=vm.handleDateChange() onkeydown=\"return false\"> <a ng-click=vm.handleNext() class=input-group-addon><i class=\"fa fa-chevron-right\"></i></a></div></div></datepicker></div></div><div class=schedule ng-repeat=\"weeklyAvailability in vm.doc.weeklyAvailabilityList\"><weekly-schedule doc-info=vm.doc weekly-availability=weeklyAvailability clinic=\"vm.entityId!==null\" video-slots-only=vm.videoSlotsOnly></weekly-schedule></div></div></div><div ng-if=!vm.dataAvailable>Loading please wait...</div>");
$templateCache.put("app/modules/clinic/components/doctor-list/partials/doctor-list.html","<div class=\"panel panel-default\" ng-repeat=\"doc in vm.docsList\"><!-- for mobile --><div class=\"panel-heading visible-xs\" style=background:white><div class=row><div class=\"col-xs-6 text-left\"><img class=\"img-responsive img-circle\" ng-if=\"doc.imageFileName && doc.uid\" ng-src=\"{{vm.baseUrl}}/images?id={{doc.uid}}&ifn={{doc.imageFileName}}\" alt=\"\" class=\"img-responsive img-thumbnail center-block\" ng-if=\"doc.imageFileName && doc.uid\"> <img src=assets/images/doc_default.png alt=\"\" class=\"img-responsive img-circle\" ng-if=\"!doc.imageFileName || !doc.uid\"></div><div class=\"col-xs-6 text-right\" ng-if=!vm.hideProfile><profile doctor-info=doc></profile></div></div></div><div class=panel-body><div class=row><div class=\"hidden-xs col-sm-2 margin_bottom\" ng-if=!vm.urlUniqueString><img style=width:150px class=img-responsive ng-if=\"doc.imageFileName && doc.uid\" ng-src=\"{{vm.baseUrl}}/images?id={{doc.uid}}&ifn={{doc.imageFileName}}\" alt=\"\" class=\"img-responsive img-thumbnail center-block\" ng-if=\"doc.imageFileName && doc.uid\"> <img style=width:150px src=assets/images/doc_default.png alt=\"\" class=img-responsive ng-if=\"!doc.imageFileName || !doc.uid\"></div><div class=hidden-xs ng-if=\"vm.urlUniqueString && !vm.hideProfile\"><div class=col-sm-2><img style=width:150px class=img-responsive ng-if=\"doc.imageFileName && doc.uid\" ng-src=\"{{vm.baseUrl}}/images?id={{doc.uid}}&ifn={{doc.imageFileName}}\" alt=\"\" class=\"img-responsive img-thumbnail center-block\" ng-if=\"doc.imageFileName && doc.uid\"> <img style=width:150px src=assets/images/doc_default.png alt=\"\" class=img-responsive ng-if=\"!doc.imageFileName || !doc.uid\"></div><div class=col-sm-10><profile doctor-info=doc></profile><div class=\"web_notice_section well well-sm margin_top_5px\" ng-if=\"(doc.webNotice && doc.webNotice.length>0)\"><div ng-init=\"limitText2=180\"><p>{{ doc.webNotice | limitTo: limitText2 }} <a href=javascript:void(0) class=show_more_link ng-hide=\"doc.webNotice.length < limitText2\" ng-click=\"limitText2 = doc.webNotice.length + 1\">show more..</a></p></div></div></div></div><div ng-class=\"{\'col-sm-10\' : !vm.urlUniqueString,\'col-sm-12\': vm.urlUniqueString}\"><div class=row><div class=\"col-sm-5 hidden-xs\" ng-if=!vm.urlUniqueString><profile doctor-info=doc></profile></div><div ng-class=\"{\'col-sm-7\' : !vm.urlUniqueString,\'col-sm-12\': vm.urlUniqueString}\"><!-- per location  --><div ng-repeat=\"weeklyAvailability in doc.weeklyAvailabilityList\"><div class=row><label class=\"col-sm-6 col-xs-12 text-center bg-success padding_5px\" ng-if=!vm.entityId><h4><i class=\"fa fa-hospital-o\"></i>&nbsp;{{weeklyAvailability.locationInfo.hospitalName}} <span ng-if=vm.urlUniqueString>,{{weeklyAvailability.locationInfo.area}}</span></h4></label><div class=\"col-sm-6 col-xs-12\" style=margin-top:10px;max-width:200px><datepicker date-format=\"dd MMM yyyy\" selector=form-control date-min-limit={{vm.todayDate}} button-prev=\"<i class=\'fa fa-arrow-left\'></i>\" button-next=\"<i class=\'fa fa-arrow-right\'></i>\"><div class=\"form-group margin_top_zero\"><div class=\"col-sm-12 col-xs-12\"><input class=form-control placeholder=\"Choose a date\" ng-model=weeklyAvailability.dateSelectorDate ng-change=vm.handleDateChange(weeklyAvailability,doc)></div></div></datepicker></div></div><div class=screen_aptmts ng-if=doc.screenApts>Online appointment booking is not available for this doctor<div ng-if=\"(doc.webNotice==null || doc.webNotice.length==0)\">For appointments, please contact {{weeklyAvailability.locationInfo.contactLandLineNumber}} to schedule an appointment.</div></div><ul class=\"nav nav-tabs hidden-xs\"><li><a ng-click=vm.getDoctorInfo(doc,weeklyAvailability,false)><i class=\"fa fa-chevron-left\"></i></a></li><li ng-class=\"{active: day==weeklyAvailability.activeDay}\" ng-repeat=\"day in weeklyAvailability.dayLabels\"><a ng-click=vm.daySelected($index,weeklyAvailability,doc)>{{day}}</a></li><li><a ng-click=vm.getDoctorInfo(doc,weeklyAvailability,true)><i class=\"fa fa-chevron-right\"></i></a></li></ul><div class=\"row text-center visible-xs\"><div class=col-xs-1><button type=button class=\"btn btn-default btn-sm\" ng-click=vm.getDoctorInfo(doc,weeklyAvailability,false)><i class=\"fa fa-chevron-left\"></i></button></div><div class=col-xs-3 ng-repeat=\"day in weeklyAvailability.dayLabels\"><button ng-click=vm.daySelected($index,weeklyAvailability,doc) type=button class=\"btn btn-warning btn-sm\" ng-class=\"{active: day==weeklyAvailability.activeDay}\">{{day}}</button></div><div class=col-xs-1><button type=button class=\"btn btn-default btn-sm\" ng-click=vm.getDoctorInfo(doc,weeklyAvailability,true)><i class=\"fa fa-chevron-right\"></i></button></div></div><div class=\"web_notice_section well well-sm margin_top_5px\" ng-if=\"(doc.webNotice && doc.webNotice.length>0) && ((weeklyAvailability.announceTimings) || doc.screenApts || weeklyAvailability.activeAvails.length==0)\"><div ng-init=\"limitText2=180\"><p>{{ doc.webNotice | limitTo: limitText2 }} <a href=javascript:void(0) class=show_more_link ng-hide=\"doc.webNotice.length < limitText2\" ng-click=\"limitText2 = doc.webNotice.length + 1\">show more..</a></p></div></div><div ng-if=\"weeklyAvailability.activeAvails.length>0\" class=margin_top_5px><div class=\"panel panel-default\"><div style=background:silver;color:white;padding:5px class=text-center><b class=hidden-xs>Consultation</b> <b>Timings on {{weeklyAvailability.activeDay}}:</b></div><div ng-repeat=\"avail in weeklyAvailability.activeAvails\" class=\"panel-body text-center\"><!--\n                    <h4 class=\"padding_10px margin_left\"><span class=\"label label-default font_14px\">{{avail}}</span></h4>\n                    --><h4 class=\"margin_5px padding_5px font_14px font_bold text-primary\">{{avail}}</h4><button class=\"btn btn-sm btn-default\" ng-click=vm.getSchedule(doc,weeklyAvailability) ng-if=!doc.screenApts><i class=\"fa fa-chevron-circle-down\"></i> View Available Slots</button><div ng-if=doc.activeWeeklyAvailability><div class=padding_5px><day-schedule weekly-availability=doc.activeWeeklyAvailability doctor-info=doc avail=avail></day-schedule></div></div></div></div></div><div class=\"padding font_16px margin_5px\" ng-show=\"weeklyAvailability.activeAvails.length==0 && !doc.webNotice\">​No ​slots ​available for selected date.<br>​​For further queries, please call: {{weeklyAvailability.locationInfo.contactLandLineNumber}}</div><button class=\"btn btn-primary btn-sm\" ng-click=vm.econsult(doc,weeklyAvailability) ng-if=weeklyAvailability.enableOnlineConsultation><i class=\"fa fa-edit\"></i>Request Econsultation (24 hour response)</button></div></div></div></div></div></div></div>");
$templateCache.put("app/modules/clinic/components/branch-selector/partials/branch-selector.html","<div class=branch-selector style=\"background-repeat: no-repeat;background-size: cover;postion:fixed:top:0;right:0;left:0;bottom:0\"><div class=header><div style=display:flex><div style=\"width:30%;text-align: left\"><img ng-src=\"{{vm.baseUrl}}/images?eid={{vm.entityInfo.entityId}}&ifn={{vm.entityInfo.logoFileName}}\"></div><div style=\"width:65%;text-align: right\" ng-if=!vm.hideName><h2>{{vm.entityInfo.hospitalName}}</h2></div></div><!--\n    <\n\n    --></div><div class=content><h3 style=background:#0abde3;margin:0;padding:10px;color:white>Choose a branch or center to book an appointment</h3><div class=row style=\"margin:25px 0px\"><div class=\"col-lg-4 col-lg-offset-4 col-sm-4 col-sm-offset-3 col-xs-12\"><select ng-model=vm.selectedEntity class=\"form-control input-lg\"><option ng-repeat=\"b in vm.branches\">{{b.name}}</option></select><a class=\"btn btn-success btn-lg\" style=margin-top:25px ng-click=vm.handleSubmit()>Book Appointment <i class=\"fa fa-chevron-right\"></i><i class=\"fa fa-chevron-right\"></i></a></div><div class=\"col-lg-4 col-sm-3 col-xs-12\"></div></div><div class=center-block></div></div><div class=footer><div class=\"col-sm-12 col-xs-12 padding_zero\"><div class=\"col-sm-6 col-xs-12 col-sm-offset-3 padding_zero\"><span class=\"col-sm-6 col-xs-12 text_right_sm\">Powered by DocPulse</span> <span class=\"col-sm-6 col-xs-12 text_left_sm\"><img src=assets/images/docpulse-logo.png alt=\"\" width=24px height=24px> - <a href=http://www.docpulse.com/ >www.docpulse.com</a></span></div></div></div></div>");
$templateCache.put("app/modules/clinic/components/simple-doctor-list/partials/simple-doctor-list.html","<div class=row><div class=\"text-right col-xs-12 color_55\"><div style=line-height:30px;margin:auto>Showing {{vm.docsList.length}} records <a class=\"btn btn-info btn-sm\" ng-if=vm.hasMoreRecords ng-click=vm.showNextPage() style=background:white;color:black>Show More <i class=\"fa fa-chevron-right\"></i></a></div></div></div><div class=\"panel panel-default doctor_list margin_top_5px\" ng-repeat=\"doc in vm.docsList\"><!-- for mobile --><div class=\"panel-heading visible-xs text-center\" style=background:white><div class=row><div class=\"col-xs-6 col-xs-offset-3\"><img ng-if=\"doc.imageFileName && doc.uid\" ng-src=\"{{vm.baseUrl}}/images?id={{doc.uid}}&ifn={{doc.imageFileName}}\" alt=\"\" class=\"img-responsive img-circle center-block\" ng-if=\"doc.imageFileName && doc.uid\"> <img src=assets/images/doc_default.png alt=\"\" class=\"img-responsive img-circle center-block\" ng-if=\"!doc.imageFileName || !doc.uid\"></div></div><div class=row><div class=col-xs-12><profile ng-if=!vm.hideProfile doctor-info=doc show-locations=vm.showLocations></profile></div></div></div><div class=\"panel-heading hidden-xs\" style=background:white><div class=row ng-if=!vm.hideProfile><div class=col-sm-2><img style=width:150px class=img-responsive ng-if=\"doc.imageFileName && doc.uid\" ng-src=\"{{vm.baseUrl}}/images?id={{doc.uid}}&ifn={{doc.imageFileName}}\" alt=\"\" class=\"img-responsive img-thumbnail center-block\" ng-if=\"doc.imageFileName && doc.uid\"> <img style=width:150px src=assets/images/doc_default.png alt=\"\" class=img-responsive ng-if=\"!doc.imageFileName || !doc.uid\"></div><div class=col-sm-10><profile doctor-info=doc show-locations=vm.showLocations></profile><div class=\"web_notice_section well well-sm margin_top_5px\" ng-if=\"(doc.webNotice && doc.webNotice.length>0)\"><!--\n          <div ng-init=\"limitText2=180\">\n          --><p ng-bind-html=doc.webNotice><!--\n              <a href=\"javascript:void(0)\" class=\"show_more_link\"\n                 ng-hide=\"doc.webNotice.length < limitText2\"\n                 ng-click=\"limitText2 = doc.webNotice.length + 1\">\n                show more..\n              </a>\n              --></p><!--\n          </div>\n          --></div></div></div></div><div><div class=screen_aptmts ng-if=doc.screenApts>Online appointment booking is not available for this doctor<div ng-if=\"(doc.webNotice==null || doc.webNotice.length==0)\">For appointments, please contact {{doc.weeklyAvailabilityList[0].locationInfo.contactLandLineNumber}} to schedule an appointment.</div></div><!--\n    <div class=\"row\">\n      <div class=\"col-sm-3 padding_5px\">\n        <button class=\"btn btn-info btn-block econsult_btn\" ng-click=\"vm.econsult(doc)\"\n                ng-if=\"doc.onlineConsultationVisitType\">\n          <i class=\"fa fa-edit\"></i>Request Econsult\n        </button>\n\n      </div>\n      <div class=\"col-sm-3 padding_5px\">\n        <button class=\"btn btn-info btn-block\" ng-click=\"vm.setupSchedule(doc)\">\n          <i class=\"fa fa-video-camera\"></i> Book Video Consult\n        </button>\n      </div>\n      <div class=\"col-sm-3 padding_5px\">\n        <button class=\"btn btn-success btn-block\" ng-click=\"vm.setupSchedule(doc)\">\n          <span ng-if=\"!doc.screenApts\">Book Appointment</span>\n          <span ng-if=\"doc.screenApts\">View Timings</span>\n          <span class=\"fa fa-chevron-circle-down\"></span></button>\n      </div>\n    </div>\n    --><div style=background-color:#ccc><!--\n      <button class=\"btn btn-info econsult_btn\" ng-click=\"vm.econsult(doc)\"\n              ng-if=\"doc.onlineConsultEnabled\">\n        <i class=\"fa fa-edit\"></i>Request Econsult\n      </button>\n      --><!--\n      <button class=\"btn btn-info\" ng-click=\"vm.setupVideoSchedule(doc)\" ng-if=\"doc.videoConsultEnabled\">\n        <i class=\"fa fa-video-camera\"></i> Book Video Consult\n        <span class=\"fa fa-chevron-circle-down\"></span></button>\n      </button>\n      --><md-button class=\"md-raised md-accent circular-btn\" ng-click=vm.econsult(doc) ng-if=doc.onlineConsultEnabled><md-icon>email</md-icon>Request E-Consult</md-button><md-button class=\"md-raised md-warn circular-btn\" ng-click=vm.setupSchedule(doc,true) ng-if=doc.videoConsultEnabled><md-icon>video_call</md-icon>Book Video Appointment</md-button><md-button class=\"md-raised md-primary circular-btn\" ng-click=vm.setupSchedule(doc,false) ng-if=\"doc.inPersonConsultEnabled && !vm.hideInPerson\"><md-icon>person</md-icon><span ng-if=!doc.screenApts>Book In-Person Appointment</span> <span ng-if=doc.screenApts>View Timings</span></md-button><!--\n      <button class=\"btn btn-success\" ng-click=\"vm.setupSchedule(doc)\">\n        <span ng-if=\"!doc.screenApts\">Book InPerson Appointment</span>\n        <span ng-if=\"doc.screenApts\">View Timings</span>\n        <span class=\"fa fa-chevron-circle-down\"></span></button>\n        --></div><div id={{doc.uid}}><md-card ng-if=doc.showSchedule><doctor-schedule entity-id=vm.entityId uid=doc.uid drill-down=doc.showSchedule video-slots-only=doc.videoSlotsOnly></doctor-schedule></md-card></div></div></div><div class=row><div class=\"text-right col-xs-12 color_55\"><div style=line-height:30px;margin:auto>Showing {{vm.docsList.length}} records <a class=\"btn btn-info btn-sm\" ng-if=vm.hasMoreRecords ng-click=vm.showNextPage() style=background:white;color:black>Show More <i class=\"fa fa-chevron-right\"></i></a></div></div></div>");
$templateCache.put("app/modules/clinic/components/uploader/partials/uploader-component.html","<table class=\"table table-responsive\"><tr><th>Attach files</th><td><input type=button class=\"btn btn-success\" ng-click=vm.handleAttach() value=\"Attach Reports/Images/Documents etc\"> <span style=\"color: red\" ng-show=vm.getUrlInProgress>Please wait...</span><div style=\"background: whitesmoke; padding: 20px\" ng-show=vm.attachNow><input type=file ng-file-select=vm.onFileSelect($files)></div><table class=table><tr><th>Name</th><th>Size</th><th>Status</th><th></th></tr><tr ng-repeat=\"blob in vm.pvr.patientAttachments\"><td>{{blob.fileName}}</td><td>{{blob.size}}</td><td>{{blob.status}}</td><td><input class=\"btn btn-info btn-small\" type=button value=Delete ng-click=vm.handleDelete(blob)></td></tr></table></td></tr></table>");
$templateCache.put("app/modules/clinic/components/weekly-schedule/partials/weekly-schedule.html","<style>.availHeader {\n    background: gray;\n    color: white;\n    padding: 10px;\n    border-radius: 5px;\n  }</style><div class=\"schedule padding_5px\" ng-cloak><div class=row><label class=\"col-sm-6 col-xs-12 text-center bg-success padding_5px\" ng-if=!vm.clinic><h4><i class=\"fa fa-hospital-o\"></i>&nbsp;{{vm.weeklyAvailability.locationInfo.hospitalName}} <span ng-if=!vm.weeklyAvailability.locationInfo.isVirtualClinic>,{{vm.weeklyAvailability.locationInfo.area}}</span></h4></label></div><!-- Added clinic web notice for taking care of Hosmat issue --><div class=row><div class=col-sm-12 style=margin:0;padding:0><div class=\"alert alert-danger\" ng-if=\"vm.weeklyAvailability.locationInfo.webNotice && !vm.clinic\" ng-bind-html=vm.weeklyAvailability.locationInfo.webNotice></div></div></div><ul class=\"nav nav-tabs hidden-xs\"><li ng-if=!vm.weeklyAvailability.dateFromUrl><a ng-click=vm.handlePrevious()><i class=\"fa fa-chevron-left\"></i></a></li><li ng-class=\"{active: day==vm.activeDay}\" ng-repeat=\"day in vm.dayLabels\"><a ng-click=vm.daySelected($index)>{{day}}</a></li><li ng-if=!vm.weeklyAvailability.dateFromUrl><a ng-click=vm.handleNext()><i class=\"fa fa-chevron-right\"></i></a></li></ul><div class=\"row visible-xs margin_top_5px\"><div class=\"col-xs-4 text-center padding_zero\" ng-repeat=\"day in vm.dayLabels\"><a ng-click=vm.daySelected($index) type=button class=\"btn btn-info btn-sm\" ng-class=\"{active: day==vm.activeDay}\" style=background:white;color:black>{{day}}</a></div></div><div class=\"web_notice_section well well-sm margin_top_5px\" ng-if=\"(doc.webNotice && doc.webNotice.length>0) && ((weeklyAvailability.announceTimings) || doc.screenApts || weeklyAvailability.activeAvails.length==0)\"><div ng-init=\"limitText2=180\"><p>{{ doc.webNotice | limitTo: limitText2 }} <a href=javascript:void(0) class=show_more_link ng-hide=\"doc.webNotice.length < limitText2\" ng-click=\"limitText2 = doc.webNotice.length + 1\">show more..</a></p></div></div><div ng-if=\"vm.weeklyAvailability.daySlots[vm.dayIndex]!=null && vm.weeklyAvailability.daySlots[vm.dayIndex].length>0\" class=margin_top_5px><div class=\"panel panel-default\"><div style=background:silver;color:white;padding:5px><b class=hidden-xs>Consultation</b> <b>Timings on {{vm.activeDay}}:</b></div><div ng-repeat=\"avail in vm.weeklyAvailability.daySlots[vm.dayIndex]\" class=\"panel-body padding_5px schedule_panel\"><!--\n        <h4 ng-if=\"avail.aptTypeName!=null\" class=\"margin_5px padding_5px font_14px font_bold text-primary\">{{avail.header}}</h4>\n        --><h4 class=\"margin_5px padding_5px font_14px font_bold text-primary availHeader\"><i class=\"fa fa-video-camera\" ng-if=\"avail.header.indexOf(\'Video\')>-1&&vm.videoSlotsOnly\"></i>&nbsp;{{avail.header}} All times are in - {{vm.docInfo.timezoneToDisplay}}</h4><div class=padding_5px ng-if=!vm.docInfo.screenApts><day-schedule weekly-availability=vm.weeklyAvailability doctor-info=vm.docInfo avail=avail selected-date=vm.selectedDate video-slots-only=vm.videoSlotsOnly></day-schedule></div><div class=screen_aptmts ng-if=vm.docInfo.screenApts>Online appointment booking is not available<div ng-if=\"(vm.docInfo.webNotice==null || vm.docInfo.webNotice.length==0)\">For appointments, please contact {{vm.weeklyAvailability.locationInfo.contactLandLineNumber}} to schedule an appointment.</div></div></div></div></div><div class=\"padding font_16px margin_5px\" ng-show=\"!vm.weeklyAvailability.errorMessage && (vm.weeklyAvailability.daySlots[vm.dayIndex]==null || vm.weeklyAvailability.daySlots[vm.dayIndex].length==0) && !doc.webNotice\">​No ​slots ​available for selected date.<br>​​For further queries, please call: {{vm.weeklyAvailability.locationInfo.contactLandLineNumber}}</div><div class=\"padding font_16px margin_5px\" ng-show=vm.weeklyAvailability.errorMessage>No ​slots ​available for selected date.<br>​​For further queries, please call: {{vm.weeklyAvailability.locationInfo.contactLandLineNumber}}</div><!--\n  <button class=\"btn btn-primary btn-sm\" ng-click=\"vm.econsult()\"\n          ng-if=\"vm.weeklyAvailability.enableOnlineConsultation && vm.isDoctor\">\n    <i class=\"fa fa-edit\"></i>Request Econsultation (24 hour response)\n  </button>\n--></div>");
$templateCache.put("app/modules/meetmydoctor/components/home/partials/home.html","");}]);